import React, {useState, useEffect, useMemo, useRef} from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import Grid from "@mui/material/Grid";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import countryOptions from "../components/List/Countries";
import UploadedFilePreview from "components/MDDropzone/UploadedFilePreview";
import {Alert, Chip, CircularProgress, FormControlLabel, Snackbar, Tooltip} from "@mui/material";
// Büyük formda her tuşta tüm formun yeniden çizilmesini önleyen tamponlu TextField (yazma gecikmesi)
import TextField from "components/BufferedTextField";
import DecimalTextField from "components/DecimalTextField";
import AutoAwesomeOutlinedIcon from "@mui/icons-material/AutoAwesomeOutlined";
import MenuItem from "@mui/material/MenuItem";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { getISOWeek } from "date-fns";
import MDDropzone from "../../../../../components/MDDropzone";
import Switch from "@mui/material/Switch";
import Button from "@mui/material/Button";
import { GlobalWorkerOptions } from "pdfjs-dist";
import {useLocation, useNavigate} from "react-router-dom";
import DashboardLayout from "../../../../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../../../../examples/Navbars/DashboardNavbar";
import CrudService from "services/cruds-service";
import { fetchPartyAddressBook, withBillingAddress } from "constants/partyBillingAddress";
import {DatePicker, LocalizationProvider} from "@mui/x-date-pickers";
import * as mongoose from "three/addons/libs/ecsy.module";
import "jspdf-autotable";
import Footer from "../../../../../examples/Footer";
import { tr } from "date-fns/locale";
import { companies } from '../companies.js';
import dayjs from "dayjs";
import RequiredLabelWithTooltip from "../../../../../assets/theme/components/form/RequiredLabelWithTooltip";
import { DEFAULT_CUSTOMS_OFFICES } from "constants/customsOffices";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { PDFDocument, StandardFonts, rgb } from "pdf-lib";
import Fade from "@mui/material/Fade";
import Zoom from "@mui/material/Zoom";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import LinkIcon from "@mui/icons-material/Link";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import LocalShippingOutlinedIcon from "@mui/icons-material/LocalShippingOutlined";
import DialogTitle from "@mui/material/DialogTitle";
import SendRoundedIcon from "@mui/icons-material/SendRounded";
import { jwtDecode } from "jwt-decode";
import oceanAdditionalFeeOptions from "../../../../../constants/oceanAdditionalFeeOptions";
import { describeRoute, sameRoute } from "./shipmentRoute";
import { blCargoArea, buildBlCargoContent, drawBlCargo, loadSheetBackground, FILENDERS_MBL_CARGO_AREA, drawRouteFields, FILENDERS_MBL_PARTY_CELLS, drawCopyMark, FBL_SHEET_TINT } from "./blCargoPrint";
import BlPrintEditor from "./BlPrintEditor";
import {
    cargoForPayload,
    cargoFromSaved,
    newCargo,
    newContainerGroup,
    syncContainerRows,
    withContainerTotals,
} from "./oceanCargo";
import CreateCustomer from "../crm/customer/CreateCustomer";
import Drawer from "@mui/material/Drawer";
import ShipmentNotifications from "./notifications/ShipmentNotifications";
import NotificationsLauncher from "./notifications/NotificationsLauncher";
import CreateServiceProvider from "../crm/Service Provider/CreateServiceProvider";
import EditIcon from "@mui/icons-material/Edit";
import ShipmentFinanceModal, { FinanceDetailsButton } from "../crm/invoice/finance/shared/ShipmentFinanceModal";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import DeleteIcon from "@mui/icons-material/Delete";
import ConnectOMBL from "./ConnectOMBL";
import { istanbulPickerValue } from "./oceanStatus/constants";
import { AddRowButton, RemoveRowButton } from "components/RowActions";

// Ocean TMS te zorunlu alan yok: etiketler ipucunu korur ama zorunluluk işareti göstermez
const LabelWithTooltip = (opts) => RequiredLabelWithTooltip({ ...opts, mark: false });

// Container PCS kadar konteyner satırı oluşturulur; üst sınır yoksa yanlışlıkla yazılan büyük bir
// sayı (ör. 1000) binlerce satır üretip sayfayı donduruyordu
const MAX_CONTAINER_PCS = 100;
GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/2.16.105/pdf.worker.js`;
const CreateOceanShipment = () => {
    const navigate = useNavigate();
    const initialAddressState = {
        additionalInfo: "",
        gateway: "",
        country: "",
        city: "",
        district: "",
        latLong: "",
        zipcode: "",
        officeCode: "",
        brokerageName: "",
        pickupType: "Direct Pickup",
        deliveryType: "Direct Delivery",
    };

    const packingOptions = [
        { label: "Box" },
        { label: "Crate" },
        { label: "Pallet" },
        { label: "Pallets" },
        { label: "Package" },
        { label: "Packages" },
        { label: "PCS" },
        { label: "Roll" },
        { label: "Mix" },
        { label: "Loose" },
        { label: "Unpackaged or Unpacked" },
    ];
    const containerType = [
        { label: "20'DC" },
        { label: "40'DC" },
        { label: "40'HC" },
        { label: "45'HC" },
        { label: "20'Open-Top" },
        { label: "40'Open-Top" },
        { label: "20'Flatrack" },
        { label: "40'Flatrack" },
        { label: "20'Reefer" },
        { label: "40'HC Reefer" },
        { label: "Swapbody" }
    ];
    const serviceOptions = [
        { label: "Port to Port" },
        { label: "Port to Door" },
        { label: "Door to Port" },
        { label: "Door to Door" },
    ];
    const incotermsOptions = [
        { label: "CFR" },
        { label: "CIF" },
        { label: "CIP" },
        { label: "CPT" },
        { label: "DAP" },
        { label: "DAT" },
        { label: "DPU" },
        { label: "DDP" },
        { label: "EXW" },
        { label: "FAS" },
        { label: "FCA" },
        { label: "FOB" },
        { label: "FOT" },
        { label: "FOR" },
    ];
    const oceanTransportSubOptions = [
        { label: "FCL-IMPORT" },
        { label: "FCL-EXPORT" },
        { label: "LCL-IMPORT" },
        { label: "LCL-EXPORT" },
    ];
    const imcoOptions = [
        { label: "(1.1) Substances and objects with a mass explosion hazard" },
        { label: "(1.2) Substances and objects with an explosion hazard but without a mass explosion hazard" },
        { label: "(1.3) Substances and objects with a fire hazard and a minor blast or minor projection hazard, or both, but without a mass explosion hazard" },
        { label: "(1.4) Substances and objects posing no significant hazard" },
        { label: "(1.6) Extremely insensitive substances without a mass explosion hazard" },
        { label: "(2.1) Flammable gases" },
        { label: "(2.2) Non-flammable, non-toxic gases" },
        { label: "(2.3) Toxic gases" },
        { label: "(3) Flammable liquids" },
        { label: "(4.1) Flammable solids, substances prone to spontaneous combustion, and solid desensitized explosives" },
        { label: "(4.2) Substances prone to spontaneous combustion" },
        { label: "(4.3) Substances emitting flammable gases when in contact with water" },
        { label: "(5.1) Oxidizing substances" },
        { label: "(5.2) Organic peroxides" },
        { label: "(6.1) Toxic substances" },
        { label: "(7) Radioactive substances" },
        { label: "(8) Corrosive substances" },
        { label: "(9) Miscellaneous dangerous substances and objects" },
    ];
    const DEFAULT_LINE_OPTIONS = [
        { id: 1, name: "HAPAG LLOYD" },
        { id: 2, name: "CMA CGM" },
        { id: 3, name: "MAERSK" },
        { id: 4, name: "ONE LINE" },
        { id: 5, name: "MSC" },
        { id: 6, name: "YANG MING" },
        { id: 7, name: "OOCL" },
        { id: 8, name: "EVERGREEN" },
        { id: 9, name: "SEALEAD" },
        { id: 10, name: "WAN HAI" },
        { id: 11, name: "MLH" },
        { id: 12, name: "ECULINE" },
        { id: 13, name: "VANGUARD" },
        { id: 14, name: "SHIPCO" },
        { id: 15, name: "CATONI" },
        { id: 16, name: "ZIM" },
        { id: 17, name: "ARKAS LINE" },
        { id: 18, name: "AKKON" },
        { id: 19, name: "MEDKON" },
        { id: 20, name: "TURKON" },
        { id: 21, name: "ADMIRAL" },
    ];
    const freightStatusOptions = [
        { label: "Prepaid" },
        { label: "Collect" },
    ];
    const LS_KEY = "customs_offices_v1";


    const customsOfficeOptions = React.useMemo(() => {
        try {
            const saved = localStorage.getItem(LS_KEY);
            if (saved) {
                const arr = JSON.parse(saved);
                if (Array.isArray(arr) && arr.length) return arr;
            }
        } catch {}
        return DEFAULT_CUSTOMS_OFFICES;
    }, []);

    const ORIGINAL_FRONT_PDF = "/documents/cmr/original-front.pdf";
    const ORIGINAL_BACK_PDF = "/documents/cmr/original-back.pdf";
    const SEAWAYBILL_FRONT_PDF = "/documents/cmr/seawaybill-front.pdf";
    const SEAWAYBILL_BACK_PDF = "/documents/cmr/seawaybill-back.pdf";
    // Direct BL prints on the plain Filenders MBL form (no UTIKAD logo / colored background).
    const DIRECT_BL_FRONT_PDF = "/documents/cmr/ocean-mbl-seawaybill.pdf";
    const [printDialogOpen, setPrintDialogOpen] = useState(false);
    const [previewDialogOpen, setPreviewDialogOpen] = useState(false);
    const [selectedPrintType, setSelectedPrintType] = useState("original");
    const [previewMergedPdfUrl, setPreviewMergedPdfUrl] = useState("");
    // Original print: the original set or a copy ("COPY" in place of "ORIGINAL" on the FBL).
    const [blCopy, setBlCopy] = useState(false);
    // Texts of the B/L being previewed, as corrected by the user (null: built from the file).
    const [blTexts, setBlTexts] = useState(null);
    const [blTextsDirty, setBlTextsDirty] = useState(false);
    const location = useLocation();
    const transferredData = location.state; // Eğer state boşsa undefined döner
    const [customerOptions, setCustomerOptions] = useState([]); // Options for Autocomplete
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [successMessage, setSuccessMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState("");
    const [inputValue, setInputValue] = useState(""); // Kullanıcı girişini takip etmek için
    const [open, setOpen] = useState(false); // Listeyi kontrol etmek için
    const [partyOptions, setPartyOptions] = useState([]);
    const [customerModalOpen, setCustomerModalOpen] = useState(false);
    const [customerModalTarget, setCustomerModalTarget] = useState(null);
    const [serviceProviderModalOpen, setServiceProviderModalOpen] = useState(false);
    const [serviceProviderModalTarget, setServiceProviderModalTarget] = useState(null);
    const [exchangeRates, setExchangeRates] = useState(null);
    const [emailPreviewOpen, setEmailPreviewOpen] = useState(false);
    const [emailPreviewData, setEmailPreviewData] = useState({
        to: "",
        cc: "",
        subject: "",
        body: "",
    });
    const [globalAgentOptions, setGlobalAgentOptions] = React.useState([]);
    const handleCustomerCreatedFromModal = (createdCustomer) => {
        const attr = createdCustomer?.attributes || createdCustomer;

        const newOption = {
            id: createdCustomer?.id || attr?._id || Date.now(),
            name: attr?.name || "Unnamed Customer",
            type: "customer",
        };

        setPartyOptions((prev) => {
            const exists = prev.some(
                (item) =>
                    item.type === "customer" &&
                    item.name?.toLowerCase() === newOption.name.toLowerCase()
            );

            return exists ? prev : [...prev, newOption];
        });

        if (customerModalTarget === "customer") {
            setSelectedCustomer(newOption);
            setInputValue(newOption.name);
        }

        if (customerModalTarget === "shipper") {
            setShipper(newOption.name);
        }

        if (customerModalTarget === "consignee") {
            setConsignee(newOption.name);
        }

        if (customerModalTarget === "notify") {
            setNotify(newOption.name);
        }

        if (customerModalTarget === "manufacturer") {
            setManufacturer(newOption.name);
        }
        setCustomerModalOpen(false);
        setCustomerModalTarget(null);
    };

    // "+ New Account" for the service provider inputs (opens Create Service Provider).
    const NEW_SERVICE_PROVIDER_OPTION = {
        id: "new-service-provider",
        name: "+ New Account",
        type: "new",
    };

    const serviceProviderFilter = createFilterOptions();
    const filterServiceProviderOptions = (options, state) => [
        NEW_SERVICE_PROVIDER_OPTION,
        ...serviceProviderFilter(
            options.filter((option) => option?.type !== "new"),
            state
        ),
    ];

    const renderServiceProviderOption = (props, option) => (
        <li {...props} key={option.id}>
            {option.type === "new" ? (
                <strong style={{ color: "#1976d2" }}>+ New Account</strong>
            ) : (
                option.name
            )}
        </li>
    );

    // Manufacturer stays free text, but its list now also offers "+ New Account".
    const manufacturerFilter = createFilterOptions();
    const filterManufacturerOptions = (options, state) => [
        NEW_PARTY_OPTION,
        ...manufacturerFilter(
            options.filter((option) => option?.type !== "new"),
            state
        ),
    ];

    const handleServiceProviderCreatedFromModal = (createdProvider) => {
        const attr = createdProvider?.attributes || createdProvider;
        const newOption = {
            id: createdProvider?.id || attr?._id || Date.now(),
            name: attr?.name || "Unnamed Service Provider",
            type: "serviceProvider",
        };

        setServiceProviders((prev) =>
            prev.some((item) => item.name?.toLowerCase() === newOption.name.toLowerCase())
                ? prev
                : [...prev, newOption]
        );

        if (serviceProviderModalTarget === "serviceProvider") {
            setSelectedServiceProvider(newOption);
        }
        if (serviceProviderModalTarget === "pickupServiceProvider") {
            setPickupServiceProvider(newOption.name);
        }
        if (serviceProviderModalTarget === "deliveryServiceProvider") {
            setDeliveryServiceProvider(newOption.name);
        }
        if (serviceProviderModalTarget === "exportBrokerage") {
            handleStateChange(setExportLocation, "brokerageName", newOption.name);
        }
        if (serviceProviderModalTarget === "importBrokerage") {
            handleStateChange(setImportLocation, "brokerageName", newOption.name);
        }

        setServiceProviderModalOpen(false);
        setServiceProviderModalTarget(null);
    };

    const NEW_PARTY_OPTION = {
        id: "new-party",
        name: "+ New",
        type: "new",
    };

    const SAME_AS_CONSIGNEE_OPTION = {
        id: "same-as-consignee",
        name: "Same as Consignee",
        type: "sameAsConsignee",
    };

    const plainTextVersion = (html) => html.replace(/<[^>]*>/g, "").replace(/\s+/g, " ").trim();

    const getAuthUserEmail = () => {
        const token = localStorage.getItem("token");
        if (!token) return "";
        try {
            const decoded = jwtDecode(token);
            return decoded?.email || decoded?.user?.email || "";
        } catch {
            return "";
        }
    };
    const getEmailsFromParty = (item) => {
        const source = item?.attributes || item || {};

        const emails = [
            source.email,
            ...(source.representatives || []).map((r) => r.email),
            ...(source.operationRepresentatives || []).map((r) => r.email),
            ...(source.pricingRepresentatives || []).map((r) => r.email),
            ...(source.financeRepresentatives || []).map((r) => r.email),
        ]
            .filter(Boolean)
            .map((x) => String(x).trim());

        return Array.from(new Set(emails));
    };


    const [serviceProviders, setServiceProviders] = useState([]);
    const serviceProviderPartyOptions = useMemo(() => {
        const spItems = (serviceProviders || [])
            .map((item) => {
                const source = item?.attributes || item;

                return {
                    id: `sp-${source.id || source._id || source.name}`,
                    name: source.name || "Unnamed Service Provider",
                    type: "serviceProvider",
                    email: source.email || "",
                    emails: getEmailsFromParty(source),
                    raw: source,
                };
            })
            .filter((item) => item.name);

        const gaItems = (globalAgentOptions || [])
            .map((item) => {
                const source = item?.attributes || item;

                return {
                    id: `ga-${source.id || source._id || source.name}`,
                    name: source.name || "Unnamed Global Agent",
                    type: "globalAgent",
                    email: source.email || "",
                    emails: getEmailsFromParty(source),
                    raw: source,
                };
            })
            .filter((item) => item.name);

        const map = new Map();

        [...spItems, ...gaItems].forEach((item) => {
            const key = `${item.type}::${item.name.toLowerCase()}`;
            if (!map.has(key)) map.set(key, item);
        });

        return Array.from(map.values()).sort((a, b) =>
            a.name.localeCompare(b.name)
        );
    }, [serviceProviders, globalAgentOptions]);
    const findPickupServiceProviderEmail = () => {
        const provider = serviceProviderPartyOptions.find(
            (opt) => opt.name === pickupServiceProvider
        );

        return Array.from(new Set(provider?.emails || []))
            .filter(Boolean)
            .join(", ");
    };

    const formatDate = (date) => date ? dayjs(date).format("DD/MM/YYYY") : "—";

    const fetchExchangeRates = async () => {
        try {
            const res = await fetch("https://api.exchangerate-api.com/v4/latest/USD");
            return await res.json();
        } catch (error) {
            console.error("Exchange Rate API Error:", error);
            return null;
        }
    };

    useEffect(() => {
        const loadRates = async () => {
            const data = await fetchExchangeRates();
            setExchangeRates(data);
        };

        loadRates();
    }, []);

    function convertCurrency(amount, fromCurrency, toCurrency, rates) {
        const value = Number(amount || 0);

        if (!value) return 0;
        if (!fromCurrency || !toCurrency) return value;
        if (fromCurrency === toCurrency) return value;
        if (!rates?.rates) return value;

        const fromRate = rates.rates[fromCurrency];
        const toRate = rates.rates[toCurrency];

        if (!fromRate || !toRate) return value;

        return (value / fromRate) * toRate;
    }


    useEffect(() => {
        const fetchCustomers = async () => {
            try {
                const response = await CrudService.getCustomers();

                const options = response.data.map((customer) => {
                    const pickupAddress =
                        customer.attributes?.operationAddresses?.[0]?.pickupAddress || "No Address";

                    return {
                        name: customer.attributes?.name || "Unnamed Customer", // Müşteri ismi
                        id: customer.id, // Müşteri ID'si
                        pickupAddress, // Pickup Address bilgisi
                    };
                });

                setCustomerOptions(options); // Müşteri seçeneklerini güncelle
            } catch (error) {
                console.error("Müşteri verileri alınırken hata oluştu:", error);
            }
        };

        fetchCustomers();
    }, []);



    React.useEffect(() => {
        const fetchGlobalAgents = async () => {
            try {
                const res = await CrudService.getGlobalAgents(); // senin servis adın neyse
                // res.data / res.globalAgents vs yapına göre uyarlayabilirsin:
                const list = res?.data?.data || res?.data || [];
                setGlobalAgentOptions(list);
            } catch (e) {
                console.error("getGlobalAgents error:", e);
                setGlobalAgentOptions([]);
            }
        };

        fetchGlobalAgents();
    }, []);

    const [salesRep, setSalesRep] = useState([]);
    const [salesRepOptions, setSalesRepOptions] = useState([]);

    useEffect(() => {
        const fetchSalesReps = async () => {
            try {
                const response = await CrudService.getUsers();
                const users = response.data;
                const formattedUsers = users.map(user => ({
                    id: user.id,
                    label: user.attributes.name
                }));
                setSalesRepOptions(formattedUsers);
            } catch (error) {
                console.error("Satış temsilcileri alınamadı:", error);
            }
        };
        fetchSalesReps();
    }, []);

    const [selectedCustomerSalesRepIds, setSelectedCustomerSalesRepIds] = useState([]);
    // Customer of the shipment being loaded for editing: its own Sales Rep is kept and the
    // customer's default reps are applied only when the user picks a customer. Applying them on
    // load replaced (or, for a customer with none, emptied) the saved Sales Rep on the next save.
    const loadedCustomerIdRef = useRef(undefined);


// 1) Customer seçilince customer detayını çek -> salesRep id’lerini sakla
    useEffect(() => {
        const run = async () => {
            const customerId = selectedCustomer?.id;   // ✅ value değil id
            if (
                loadedCustomerIdRef.current !== undefined &&
                String(customerId ?? "") === String(loadedCustomerIdRef.current ?? "")
            ) {
                loadedCustomerIdRef.current = undefined;
                return;
            }
            if (!customerId) {
                setSelectedCustomerSalesRepIds([]);
                setSalesRep([]);
                return;
            }

            try {
                const res = await CrudService.getCustomerById(customerId);
                const customer = res?.data?.attributes;
                const ids = Array.isArray(customer?.salesRep)
                    ? customer.salesRep
                        .map((x) => (typeof x === "string" ? x : (x?._id || x?.id)))
                        .filter(Boolean)
                    : [];

                setSelectedCustomerSalesRepIds(ids);
            } catch (e) {
                console.error("Customer detail fetch error:", e);
                setSelectedCustomerSalesRepIds([]);
                setSalesRep([]);
            }
        };

        run();
    }, [selectedCustomer?.id]);

// 2) salesRepOptions hazır olunca -> Sales Rep Autocomplete value set et
    useEffect(() => {
        if (!salesRepOptions?.length) return;

        const selected = salesRepOptions.filter((o) =>
            selectedCustomerSalesRepIds.some((id) => String(id) === String(o.id)) // ✅ o.value değil o.id
        );

        setSalesRep(selected);
    }, [salesRepOptions, selectedCustomerSalesRepIds]);

    const [shipmentData, setShipmentData] = useState({});

    const [loading, setLoading] = useState(false); // Yüklenme durumu
    const [isEditing, setIsEditing] = useState(false); // Düzenleme modu
    // Opening an existing shipment starts read-only so a stray click can't
    // change a saved value; the user has to explicitly hit "Edit" to unlock
    // the form. A brand new shipment (no id yet) is never read-only.
    const [readOnlyMode, setReadOnlyMode] = useState(false);
    const [financeModalOpen, setFinanceModalOpen] = useState(false);
    const searchParams = new URLSearchParams(location.search); // Query parametrelerini yakalıyoruz
    const shipmentId = searchParams.get("id"); // URL'deki `id` parametresini alıyoruz
    const openDmblFromUrl = searchParams.get("openDmbl") === "1";
    const [savedShipmentId, setSavedShipmentId] = useState(shipmentId || "");
    const effectiveShipmentId = shipmentId || savedShipmentId;
    // The DBL form follows the shipment on screen; a clone has none until it is saved.
    const dblShipmentId = effectiveShipmentId;
    const urlDmblId = searchParams.get("dmblId");
    // Shipment notification links open the file with ?tab=notifications.
    const [notificationsOpen, setNotificationsOpen] = useState(searchParams.get("tab") === "notifications");
    const emptyServiceAddress = {
        type: "",
        country: "",
        city: "",
        port: "",
        additionalInfo: "",
    };

    const getOptionName = (option) => {
        if (typeof option === "string") return option;
        return option?.name || "";
    };

    const toSavedCustomerOption = (customerName) => {
        const name = String(customerName || "").trim();
        return name && name !== "Unknown Customer" ? { name } : null;
    };

    // Eğer shipmentId varsa düzenleme modundayız ve veriyi çekiyoruz
    useEffect(() => {
        if (shipmentId) {
            setIsEditing(true); // Düzenleme modunu etkinleştiriyoruz
            setReadOnlyMode(true);
            fetchOceanShipmentDetails(shipmentId); // Shipment detaylarını çekiyoruz
        }
    }, [shipmentId]);

    const fetchOceanShipmentDetails = async (id) => {
        setLoading(true);
        try {
            const response = await CrudService.getOceanShipmentById(id);
            const shipmentData = response.data.attributes;
            setLinkedOmbl(shipmentData.linkedOmbl || null);
            setShipmentNo(shipmentData.shipmentNo || ""); // Eğer shipmentNo varsa kaydediyor, yoksa boş bir string
            const incomingMBLCustomer = location.state?.mblCustomer || null;
            const matchedQuote = quoteNoList.find((opt) => String(opt.label) === String(shipmentData.quoteNo));
            setSelectedQuoteNo(matchedQuote || null);
            const customerNameToUse = incomingMBLCustomer || shipmentData.customer;
            const matchedCustomer = customerOptions.find(
                (opt) =>
                    opt.name?.trim().toLowerCase() ===
                    customerNameToUse?.trim().toLowerCase()
            );

            // A customer missing from the (active) list keeps its saved name; dropping it
            // to null made the next save store "Unknown Customer" on the shipment.
            loadedCustomerIdRef.current = matchedCustomer?.id;
            setSelectedCustomer(matchedCustomer || toSavedCustomerOption(customerNameToUse));

            setSalesRep(
                Array.isArray(shipmentData.salesRep)
                    ? salesRepOptions.filter(repOption => shipmentData.salesRep.includes(repOption.id))
                    : []
            );
            setSelectedOceanTransportSubOption(
                oceanTransportSubOptions.find(
                    (opt) => opt.label === shipmentData.oceanTransportType,
                ) || null,
            );
            // Metin ve sayısal değerler
            setShipmentIncoterm(shipmentData.incoterm || "");
            setShipper(shipmentData.shipper || "");
            setConsignee(shipmentData.consignee || "");
            setNotify(shipmentData.notify || "");
            setManufacturer(shipmentData.manufacturer || "");
            setBillTo(shipmentData.billTo || "");
            setCommodity(shipmentData.commodity || "");
            setQuoteNo(shipmentData.quoteNo || "");
            setHsCode(shipmentData.hsCode || "");
            setUnit(shipmentData.unit || "");
            setTotalCost(shipmentData.totalCost || 0);
            setSealNumber(shipmentData.sealNumber || "");
            setWeek(shipmentData.week || 0);
            setTransitTime(shipmentData.transitTime || 0);
            setCountryOfOrigin(shipmentData.countryOfOrigin || "");
            setCmrNumber(shipmentData.cmrNumber || "");
            setOfficeCode(shipmentData.officeCode || "");
            setBrokerageName(shipmentData.brokerageName || "");
            setOperationType(shipmentData.operationType || "ocean");
            setCargoDetails(
                Array.isArray(shipmentData.cargoDetails) && shipmentData.cargoDetails.length
                    ? shipmentData.cargoDetails.map(cargoFromSaved)
                    : [newCargo()]
            );
            setPlateContainerNumber(shipmentData.plateContainerNumber || "");
            setSelectedTransport(containerType.find((opt) => opt.label === shipmentData.containerType,) || null);
            setSelectedService(shipmentData.service || "");
            setPickupAddress1(shipmentData.pickupAddress1 || emptyServiceAddress);
            setPickupAddress2(shipmentData.pickupAddress2 || emptyServiceAddress);
            setLoadingAddress({
                ...emptyServiceAddress,
                ...(shipmentData.loadingAddress || {}),
            });
            setDeliveryAddress1(shipmentData.deliveryAddress1 || emptyServiceAddress);
            setDeliveryAddress2(shipmentData.deliveryAddress2 || emptyServiceAddress);
            const savedBillOfLadingType = shipmentData.billOfLadingType || "HBL";

            setBillOfLadingType(savedBillOfLadingType);

            if (savedBillOfLadingType === "DIRECT_BL" && openDmblFromUrl) {
                setShowDirectMblSection(true);
            } else {
                setShowDirectMblSection(false);
            }
            // Adres bilgileri
            if (shipmentData?.pickupLocation) {
                setPickupLocation({
                    additionalInfo: shipmentData.pickupLocation?.additionalInfo || "",
                    latLong: shipmentData.pickupLocation?.latLong || "",
                    district: shipmentData.pickupLocation?.district || "",
                    city: shipmentData.pickupLocation?.city || "",
                    country: shipmentData.pickupLocation?.country || "",
                    zipcode: shipmentData.pickupLocation?.zipcode || "",
                    serviceProvider: shipmentData.pickupLocation?.serviceProvider || "",
                    pickupType: shipmentData.pickupLocation?.pickupType || "",
                });
                const foundCountry = countryOptions.find(
                    (option) => option.label === shipmentData.pickupLocation?.country
                );
                setSelectedCountry(foundCountry || null);
            } else {
                setPickupLocation({
                    additionalInfo: "",
                    latLong: "",
                    district: "",
                    city: "",
                    country: "",
                    zipcode: "",
                    serviceProvider: "",
                    pickupType: "",
                });
                setSelectedCountry(null);
            }

            setDeliveryLocation({
                additionalInfo: shipmentData.deliveryLocation?.additionalInfo || "",
                gateway: shipmentData.deliveryLocation?.gateway || "",
                latLong: shipmentData.deliveryLocation?.latLong || "",
                district: shipmentData.deliveryLocation?.district || "",
                city: shipmentData.deliveryLocation?.city || "",
                country: shipmentData.deliveryLocation?.country || "",
                zipcode: shipmentData.deliveryLocation?.zipcode || "",
                serviceProvider: shipmentData.deliveryLocation?.serviceProvider || "",
                deliveryType: shipmentData.deliveryLocation?.deliveryType || "Direct Delivery",
            });

            setExportLocation({
                additionalInfo: shipmentData.exportLocation?.additionalInfo || [],
                latLong: shipmentData.exportLocation?.latLong || "",
                district: shipmentData.exportLocation?.district || "",
                city: shipmentData.exportLocation?.city || "",
                country: shipmentData.exportLocation?.country || "",
                zipcode: shipmentData.exportLocation?.zipcode || "",
                officeCode: shipmentData.exportLocation?.officeCode || "",
                brokerageName: shipmentData.exportLocation?.brokerageName || "",
            });
            setBookingConfirmationDate(
                shipmentData.bookingConfirmationDate
                    ? new Date(shipmentData.bookingConfirmationDate)
                    : null
            );

            setBookingConfirmationTime(
                shipmentData.bookingConfirmationTime || ""
            );

            setBookingConfirmationPdf(
                shipmentData.bookingConfirmationPdf || null
            );
            setGateInWithoutStorageDate(
                shipmentData.gateInWithoutStorageDate
                    ? new Date(shipmentData.gateInWithoutStorageDate)
                    : null
            );

            setGateInWithoutStorageTime(
                shipmentData.gateInWithoutStorageTime || ""
            );

            const foundCountry = countryOptions.find(
                (option) => option.label === shipmentData.deliveryLocation?.country
            );
            setSelectedDeliveryCountry(foundCountry || null);

            const foundExportCountry = countryOptions.find(
                (option) =>
                    option.label === (shipmentData.exportLocation?.exportCountry || shipmentData.exportLocation?.country) ||
                    option.code === (shipmentData.exportLocation?.exportCountry || shipmentData.exportLocation?.country)
            );

            setSelectedExportCountry(foundExportCountry || null);
            setUtikadNumber(shipmentData.utikadNumber || "");
            setImportLocation({
                importCountry: shipmentData.importLocation?.importCountry || "",
                additionalInfo: shipmentData.importLocation?.additionalInfo || [],
                latLong: shipmentData.importLocation?.latLong || "",
                district: shipmentData.importLocation?.district || "",
                city: shipmentData.importLocation?.city || "",
                country: shipmentData.importLocation?.country || "",
                zipcode: shipmentData.importLocation?.zipcode || "",
                officeCode: shipmentData.importLocation?.officeCode || "",
                brokerageName: shipmentData.importLocation?.brokerageName || "",
            });
            const foundImportCountry = countryOptions.find(
                (option) =>
                    option.label === (shipmentData.importLocation?.importCountry || shipmentData.importLocation?.country) ||
                    option.code === (shipmentData.importLocation?.importCountry || shipmentData.importLocation?.country)
            );

            setSelectedImportCountry(foundImportCountry || null);
            setPickupDate(
                shipmentData.pickupDate ? new Date(shipmentData.pickupDate) : null,
            );
            setEstimatedDeliveryDate(
                shipmentData.estimatedDeliveryDate
                    ? new Date(shipmentData.estimatedDeliveryDate)
                    : null,
            );
            setRequestedDeliveryDate(
                shipmentData.requestedDeliveryDate
                    ? new Date(shipmentData.requestedDeliveryDate)
                    : null,
            );
            setEstimatedDeparture(
                shipmentData.estimatedDeparture
                    ? new Date(shipmentData.estimatedDeparture)
                    : null,
            );
            setActualDeparture(
                shipmentData.actualDeparture
                    ? new Date(shipmentData.actualDeparture)
                    : null,
            );
            setActualDelivery(
                shipmentData.actualDelivery
                    ? new Date(shipmentData.actualDelivery)
                    : null,
            );
            setAppointmentDate(
                shipmentData.appointmentDate
                    ? new Date(shipmentData.appointmentDate)
                    : null,
            );
            setProofOfDelivery(
                shipmentData.proofOfDelivery
                    ? new Date(shipmentData.proofOfDelivery)
                    : null,
            );

            setPickupTime(
                shipmentData.pickupTime || null
            );
            setEstimatedDeliveryTime(
                shipmentData.estimatedDeliveryTime
                || null,
            );
            setRequestedDeliveryTime(
                shipmentData.requestedDeliveryTime
                || null,
            );
            setEstimatedDepartureTime(
                shipmentData.estimatedDepartureTime
                || null,
            );
            setActualDepartureTime(
                shipmentData.actualDepartureTime
                || null,
            );
            setActualDeliveryTime(
                shipmentData.actualDeliveryTime
                || null,
            );
            setAppointmentTime(
                shipmentData.appointmentTime
                || null,
            );
            setProofOfDeliveryTime(
                shipmentData.proofOfDeliveryTime
                || null,
            );

            // Seçenekler ve dokümanlar
            setSelectedCountries(
                shipmentData.carbonFootprint?.plannedRouteCountries.map((country) => ({
                    label: country, // Autocomplete'de görüntülenecek ülke ismi
                    code:
                        countryOptions.find((opt) => opt.label === country)?.code ||
                        country, // Eğer varsa ülke kodu
                })) || [],
            );
            setEmissionFactor(shipmentData.carbonFootprint.emissionFactor || 0);
            setTotalCarbonEmissions(
                shipmentData.carbonFootprint.totalCarbonEmissions || 0,
            );
            setExportDeclaration(shipmentData.exportDeclaration || null);
            setImportDeclaration(shipmentData.importDeclaration || null);
            setAtr(shipmentData.atr || null);
            setCmr(shipmentData.cmr || null);
            setConfirmationMail(shipmentData.confirmationMail || null);
            setT1t2(shipmentData.t1t2 || null);
            setPackingList(shipmentData.packingList || null);
            setCommercialInvoice(shipmentData.commercialInvoice || null);
            setSignedCmr(shipmentData.signedCmr || null);
            setClosedT1t2(shipmentData.closedT1t2 || null);
            setBookingConfirmationPdf(shipmentData.bookingConfirmationPdf || null);
            setLinehaulCarrier(shipmentData.linehaulCarrier || null);
            setPickupCarrier(shipmentData.pickupCarrier || null);
            setCarrierBroker(shipmentData.carrierBroker || null);
            setVesselName(shipmentData.vesselName || "");
            setVoyageNumber(shipmentData.voyageNumber || "");

            setCustomsDeclarationCutoffDate(
                shipmentData.customsDeclarationCutoffDate
                    ? new Date(shipmentData.customsDeclarationCutoffDate)
                    : null
            );
            setCustomsDeclarationCutoffTime(
                shipmentData.customsDeclarationCutoffTime || ""
            );

            setShippingInstructionCutoffDate(
                shipmentData.shippingInstructionCutoffDate
                    ? new Date(shipmentData.shippingInstructionCutoffDate)
                    : null
            );
            setShippingInstructionCutoffTime(
                shipmentData.shippingInstructionCutoffTime || ""
            );

            setFreeTimeDetention(shipmentData.freeTimeDetention || "");
            setFreeTimeDemurrage(shipmentData.freeTimeDemurrage || "");
            setSallingRate(shipmentData.sallingRate || "");
            setCurrency(shipmentData.currency || "");
            setProfit(shipmentData.profit || 0);
            setLocationHistory(shipmentData.locationHistory || "");
            setCustomDetail({
                responsibility: shipmentData?.customDetail?.responsibility || false,
                customNote: shipmentData?.customDetail?.customNote || "",
                customRefNo: shipmentData?.customDetail?.customRefNo || "",
                responsibilityImport: shipmentData?.customDetail?.responsibilityImport || false,
                customNoteImport : shipmentData?.customDetail?.customNoteImport  || "",
            });
            setIsADR(shipmentData.adr || false);
            setImco(shipmentData.imco || null);

            const matchedServiceProvider = serviceProviders.find((sp) => sp?.name?.toLowerCase().trim() === shipmentData.serviceProvider?.toLowerCase().trim());
            setSelectedServiceProvider(matchedServiceProvider || null);

            setBuyingRate(shipmentData.buyingRate || null);
            setBuyingRateCurrency(shipmentData.buyingRateCurrency || null);

            setPickupRate(shipmentData.pickupRate || null);
            setPickupRateCurrency(shipmentData.pickupRateCurrency || null);

            setDeliveryRate(shipmentData.deliveryRate || null);
            setDeliveryRateCurrency(shipmentData.deliveryRateCurrency || null);

            setExportCustomsRate(shipmentData.exportCustomsRate || null);
            setExportCustomsRateCurrency(shipmentData.exportCustomsRateCurrency || null);

            setImportCustomsRate(shipmentData.importCustomsRate || null);
            setImportCustomsRateCurrency(shipmentData.importCustomsRateCurrency || null);
            setDeliveryCarrierInvoice(shipmentData.deliveryCarrierInvoice || null);
            setCarrierImportCustomBrokerInvoice(shipmentData.carrierImportCustomBrokerInvoice || null);
            setSellingRateCurrency(shipmentData.sellingRateCurrency || null);
            setShippingLine(shipmentData.shippingLine || "");
            setBookingNumber(shipmentData.bookingNumber || "");
            setPickupServiceProvider(shipmentData.pickupServiceProvider || "");
            setDeliveryServiceProvider(shipmentData.deliveryServiceProvider || "");
            setVesselServiceType(shipmentData.vesselServiceType || "Direct");
            setVesselPol(shipmentData.vesselPol || { country: "", port: "" });
            setVesselPod(shipmentData.vesselPod || { country: "", port: "" });
            setFreightStatus(shipmentData.freightStatus || "");
            setLoadingDate(shipmentData.loadingDate ? new Date(shipmentData.loadingDate) : null);
            setLoadingTime(shipmentData.loadingTime || "");
            setAdditionalFees(
                Array.isArray(shipmentData.additionalFees) && shipmentData.additionalFees.length
                    ? shipmentData.additionalFees.map((row) => ({ ...row, unit: row.unit ?? 1 }))
                    : [{ fee: "", rate: "", unit: 1, currency: shipmentData.sellingRateCurrency || "EUR" }]
            );
            setSellingRate(shipmentData.baseSellingRate ?? shipmentData.sellingRate ?? "");
            setFinalSellingRate(
                shipmentData.finalSellingRate ??
                shipmentData.sellingRate ??
                ""
            );            setTransshipments(
                Array.isArray(shipmentData.transshipments) && shipmentData.transshipments.length
                    ? shipmentData.transshipments.map((item) => ({
                        country: item?.country || "",
                        port: item?.port || "",
                        transshipmentEtaDate: item?.transshipmentEtaDate
                            ? new Date(item.transshipmentEtaDate)
                            : null,
                        transshipmentEtaTime: item?.transshipmentEtaTime || "",
                    }))
                    : [
                        {
                            country: "",
                            port: "",
                            transshipmentEtaDate: null,
                            transshipmentEtaTime: "",
                        },
                    ]
            );
        } catch (error) {
            console.error("Error fetching shipment details:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        const fetchOptions = async () => {
            try {
                const [customersRes, agentsRes] = await Promise.all([
                    CrudService.getCustomers(),
                    CrudService.getGlobalAgents(),
                ]);

                const customers = (customersRes.data || []).map((c) => ({
                    id: c.id,
                    name: c.attributes?.name || "Unnamed Customer",
                    type: "customer",
                }));

                const agents = (agentsRes.data || []).map((a) => ({
                    id: a.id,
                    name: a.attributes?.name || a.name || "Unnamed Global Agent",
                    type: "agent",
                }));

                const merged = [...customers, ...agents].sort((x, y) =>
                    (x.name || "").localeCompare(y.name || "")
                );

                setCustomerOptions(merged);
                setPartyOptions(merged);
            } catch (err) {
                console.error("Options alınırken hata oluştu:", err);
            }
        };

        fetchOptions();
    }, []);

// companies (string[]) + partyOptions (object[]) => string[]
    const shipperConsigneeOptions = React.useMemo(() => {
        const companyItems = (companies || [])
            .map((name) => String(name || "").trim())
            .filter(Boolean)
            .map((name) => ({
                id: `company-${name.toLowerCase()}`,
                name,
                type: "company",
            }));

        const partyItems = (partyOptions || [])
            .filter((p) => p?.name)
            .map((p) => ({
                id: `${p.type}-${p.id}`,
                name: String(p.name).trim(),
                type: p.type, // "customer" | "agent"
            }));

        // unique by (type + name) (aynı isim farklı tipte olabilir)
        const map = new Map();
        [...companyItems, ...partyItems].forEach((item) => {
            const key = `${item.type}::${item.name.toLowerCase()}`;
            if (!map.has(key)) map.set(key, item);
        });

        return Array.from(map.values()).sort((a, b) => a.name.localeCompare(b.name));
    }, [partyOptions, companies]);

    const allPartyOptions = useMemo(() => {
        const map = new Map();

        [
            ...(shipperConsigneeOptions || []),      // company + customer + GA
            ...(serviceProviderPartyOptions || []),  // SP + GA
        ].forEach((item) => {
            if (!item?.name) return;

            const key = `${item.type || "party"}::${item.name.toLowerCase()}`;

            if (!map.has(key)) {
                map.set(key, item);
            }
        });

        return Array.from(map.values()).sort((a, b) =>
            a.name.localeCompare(b.name)
        );
    }, [shipperConsigneeOptions, serviceProviderPartyOptions]);

    const buildPickupNotificationBody = () => {
        const L = (key, value) => `
    <tr>
      <td style="padding:6px 10px;border:1px solid #ccc;width:35%;"><b>${key}</b></td>
      <td style="padding:6px 10px;border:1px solid #ccc;">${value || "—"}</td>
    </tr>
  `;

        const dateTime = (date, time) =>
            `${formatDate(date)}${time ? ` ${time}` : ""}`;

        const money = (amount, currency) =>
            `${amount || "—"}${currency ? ` ${currency}` : ""}`;




        const cargoRows = (cargoDetails || [])
            .flatMap((cargo, cargoIndex) => {
                const containers = Array.isArray(cargo.containers) && cargo.containers.length
                    ? cargo.containers
                    : [{}];

                return containers.map((container, containerIndex) => `
      <tr>
        <td style="padding:6px;border:1px solid #ccc;">${cargoIndex + 1}.${containerIndex + 1}</td>
        <td style="padding:6px;border:1px solid #ccc;">${cargo.commodity || "—"}</td>
        <td style="padding:6px;border:1px solid #ccc;">${container.packingType || cargo.selectedPackingType || "—"}</td>
        <td style="padding:6px;border:1px solid #ccc;">${container.containerType || "—"}</td>
        <td style="padding:6px;border:1px solid #ccc;">${cargo.containerPcs || containers.length || "—"}</td>
        <td style="padding:6px;border:1px solid #ccc;">${container.containerNo || "—"}</td>
        <td style="padding:6px;border:1px solid #ccc;">${container.sealNumber || "—"}</td>
        <td style="padding:6px;border:1px solid #ccc;">${container.vgm || "—"}</td>
        <td style="padding:6px;border:1px solid #ccc;">${container.unitQuantity || "—"}</td>
        <td style="padding:6px;border:1px solid #ccc;">${container.grossWeight || "—"}</td>
        <td style="padding:6px;border:1px solid #ccc;">${container.cbm || "—"}</td>
      </tr>
    `);
            })
            .join("");

        return `
    <div style="font-family:Segoe UI,Arial,sans-serif;font-size:14px;color:#333;line-height:1.6;">
      <p>Dear <b>${pickupServiceProvider || "Service Provider"}</b>,</p>

      <p>
        Please find below the pickup/loading notification details for the related ocean shipment.
      </p> <br>

      <h3>Shipment Information</h3>
      <table style="border-collapse:collapse;width:100%;">
        ${L("OHFL Number", shipmentNo ? `OHFL${shipmentNo}` : "—")}
        ${L("Shipper", shipper)}
        ${L("Incoterm", shipmentIncoterm)}
        ${L("Ocean Transport Mode", selectedOceanTransportSubOption?.label)}
      </table><br>

      <h3>Loading Details</h3>
      <table style="border-collapse:collapse;width:100%;">
        ${L("Loading Service Provider", pickupServiceProvider)}
        ${L("Loading Date", dateTime(pickupDate, pickupTime))}
        ${L("Loading Cost", money(pickupRate, pickupRateCurrency))}
        ${L("Loading Country", pickupAddress1?.country)}
        ${L("Loading City", pickupAddress1?.city)}
        ${L("Loading Full Address", pickupLocation?.additionalInfo)}
      </table><br>

      <h3>Empty Release Container Details</h3>
      <table style="border-collapse:collapse;width:100%;">
        ${L("Empty Release Container Date", dateTime(loadingDate, loadingTime))}
        ${L("Empty Release Container Country", loadingAddress?.country)}
        ${L("Empty Release Container City", loadingAddress?.city)}
        ${L("Empty Release Container Full Address", loadingAddress?.additionalInfo)}
      </table><br>

      <h3>Vessel Details</h3>
      <table style="border-collapse:collapse;width:100%;">
        ${L("POL", [vesselPol?.port, vesselPol?.country].filter(Boolean).join(", "))}
        ${L("POD", [vesselPod?.port, vesselPod?.country].filter(Boolean).join(", "))}
        ${L("Vessel Name", vesselName)}
        ${L("Voyage Number", voyageNumber)}
        ${L("Shipping Line", shippingLine)}
        ${L("Booking Number", bookingNumber)}
        ${L("BC Date", dateTime(bookingConfirmationDate, bookingConfirmationTime))}
        ${L("Gate-in Without Storage Date", dateTime(gateInWithoutStorageDate, gateInWithoutStorageTime))}
        ${L("Customs Dec Cutoff Date", dateTime(customsDeclarationCutoffDate, customsDeclarationCutoffTime))}
        ${L("ETD", dateTime(estimatedDeparture, estimatedDepartureTime))}
        ${L("ETA", dateTime(estimatedDeliveryDate, estimatedDeliveryTime))}
      </table><br>

      <h3>Cargo Details</h3>
      <table style="border-collapse:collapse;width:100%;">
        <thead>
          <tr>
            <th style="padding:6px;border:1px solid #ccc;">#</th>
<th style="padding:6px;border:1px solid #ccc;">Commodity</th>
<th style="padding:6px;border:1px solid #ccc;">Packing Type</th>
<th style="padding:6px;border:1px solid #ccc;">Container Type</th>
<th style="padding:6px;border:1px solid #ccc;">Container PCS</th>
<th style="padding:6px;border:1px solid #ccc;">Container No</th>
<th style="padding:6px;border:1px solid #ccc;">Seal Number</th>
<th style="padding:6px;border:1px solid #ccc;">VGM</th>
<th style="padding:6px;border:1px solid #ccc;">Unit</th>
<th style="padding:6px;border:1px solid #ccc;">Gross Weight</th>
<th style="padding:6px;border:1px solid #ccc;">CBM</th>
          </tr>
        </thead>
        <tbody>
          ${
            cargoRows ||
            `<tr>
              <td colspan="9" style="padding:6px;border:1px solid #ccc;">
                No cargo details
              </td>
            </tr>`
        }
        </tbody>
      </table><br>

     <table style="margin-top:28px;border-collapse:collapse;font-family:Segoe UI,Arial,sans-serif;text-align:left;">
  <tr>
    <td style="vertical-align:top;padding-right:16px;border-right:2px solid #e5e7eb;">
      <img
        src="https://filentech.com/filenders_logo.png"
        alt="Filenders"
        style="width:145px;height:auto;display:block;"
      />
    </td>

    <td style="vertical-align:top;padding-left:16px;color:#333;font-size:13px;line-height:1.5;">
      <p style="margin:0;font-size:15px;font-weight:700;color:#1f2937;">
        Filenders Ocean Team
      </p>

      <p style="margin:2px 0 8px 0;color:#6b7280;">
        Filenders Logistics and Technology
      </p>

      <p style="margin:0;">
        <b>Email:</b>
        <a href="mailto:ocean.operation@filenders.com" style="color:#1a73e8;text-decoration:none;">
          ocean.operation@filenders.com
        </a>
      </p>

      <p style="margin:0;">
        <b>Web:</b>
        <a href="https://www.filenders.com" style="color:#1a73e8;text-decoration:none;">
          www.filenders.com
        </a>
      </p>
    </td>
  </tr>
</table>

    </div>
  `;
    };

    const handleOpenPickupNotificationPreview = () => {
        const to = findPickupServiceProviderEmail();
        const authEmail = getAuthUserEmail();

        const cc = [authEmail, "ocean.operation@filenders.com"]
            .filter(Boolean)
            .join(", ");

        const subject = `Loading / Empty Release Container Notification - ${shipmentNo ? `OHFL${shipmentNo}` : ""}`;

        setEmailPreviewData({
            to,
            cc,
            subject,
            body: buildPickupNotificationBody(),
        });

        setEmailPreviewOpen(true);
    };

    const confirmAndSendPickupNotification = async () => {
        const { to, cc, subject, body } = emailPreviewData;

        try {
            const res = await fetch(`${process.env.REACT_APP_API_URL}/email/Send-meeting-recap`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                },
                body: JSON.stringify({
                    to,
                    cc,
                    subject,
                    body,
                    text: plainTextVersion(body),
                }),
            });

            const result = await res.json();

            if (res.ok) {
                setEmailPreviewOpen(false);
                showActionFeedback("Pickup notification email sent successfully.", "success");
            } else {
                showActionFeedback(result.error || "Email could not be sent.", "error");
            }
        } catch (error) {
            console.error(error);
            showActionFeedback("Email sending failed.", "error");
        }
    };

    const findOptionByName = (name) => {
        const target = String(name || "").trim().toLowerCase();

        if (!target) return null;

        return (
            allPartyOptions.find(
                (o) => String(o.name || "").trim().toLowerCase() === target
            ) || {
                id: `manual-${target}`,
                name,
                type: "manual",
            }
        );
    };

    useEffect(() => {
        if (!shipmentId && !transferredData) return;

        // transferredData varsa edit fetch yapma
        if (transferredData) {
            fillFormWithTransferredData(transferredData);
            return;
        }

        // edit ise: customerOptions/salesRepOptions hazırsa fetch
        if (shipmentId && customerOptions.length > 0 && salesRepOptions.length > 0) {
            fetchOceanShipmentDetails(shipmentId);
        }
    }, [shipmentId, transferredData, customerOptions.length, salesRepOptions.length]);


    const fillFormWithTransferredData = (data) => {
        const matchedCustomer = customerOptions.find((opt) =>
            opt.name?.toLowerCase().trim() === data.customer?.toLowerCase().trim()
        );
        setSelectedCustomer(matchedCustomer || toSavedCustomerOption(data.customer));
        const matchedServiceProvider = serviceProviders.find(
            (sp) =>
                sp?.name?.toLowerCase().trim() ===
                data.serviceProvider?.toLowerCase().trim()
        );
        setSelectedServiceProvider(matchedServiceProvider || null);

        setPickupDate(
            transferredData.pickupDate
                ? dayjs(transferredData.pickupDate, "DD-MM-YYYY").toDate()
                : null
        );
        setEstimatedDeliveryDate(
            transferredData.deliveryDate
                ? dayjs(transferredData.deliveryDate, "DD-MM-YYYY").toDate()
                : null
        );

        setActualDeparture(
            transferredData.departureDate
                ? dayjs(transferredData.departureDate, "DD-MM-YYYY").toDate()
                : null
        );

        setWeek(data.week || "");
        setShipper(data.shipper || "");
        setConsignee(data.consignee || "");
        setTransitTime(data.transitTime || "");
        setPlateContainerNumber(data.plateNumber || "");
        setSalesRep(
            Array.isArray(data.salesRep)
                ? salesRepOptions.filter(repOption =>
                    data.salesRep.includes(repOption.id)
                )
                : []
        );

        setSelectedOceanTransportSubOption(
            oceanTransportSubOptions.find(
                (opt) => opt.label === (data.oceanTransportType || "").toUpperCase()
            ) || null
        );
        setSallingRate(data.sellingRate || "");
        setCurrency(data.sellingCurrency || "EUR");
        setProfit(data.grossProfit || 0);
        setSelectedService(data.service || "");
        setPickupAddress1(data.pickupAddress1 || emptyServiceAddress);
        setPickupAddress2(data.pickupAddress2 || emptyServiceAddress);
        setDeliveryAddress1(data.deliveryAddress1 || emptyServiceAddress);
        setDeliveryAddress2(data.deliveryAddress2 || emptyServiceAddress);
        setLoadingAddress(data.loadingAddress || emptyServiceAddress);
        setLoadingDate(data.loadingDate ? new Date(data.loadingDate) : null);
        setLoadingTime(data.loadingTime || "");
    };

    const [shipmentNo, setShipmentNo] = useState(0);
    const [pickupLocation, setPickupLocation] = useState(initialAddressState);
    const [deliveryLocation, setDeliveryLocation] = useState(initialAddressState);
    const [exportLocation, setExportLocation] = useState(initialAddressState);
    const [selectedExportCountry, setSelectedExportCountry] = useState(null);
    const [importLocation, setImportLocation] = useState(initialAddressState);
    const [selectedImportCountry, setSelectedImportCountry] = useState(null);
    const [grossWeight, setGrossWeight] = useState("");
    const [notStackable, setNotStackable] = useState(true); // Default olarak Not Stackable true
    const [stackingFactor, setStackingFactor] = useState(2); // Stacking Factor
    const [operationType, setOperationType] = useState("ocean"); // Operation type (ocean, sea, air, rail)
    const [countryOfOrigin, setCountryOfOrigin] = useState(null);
    const [commodity, setCommodity] = useState("");
    const [quoteNo, setQuoteNo] = useState("");
    const [hsCode, setHsCode] = useState("");
    const [unit, setUnit] = useState("");
    const [totalCost, setTotalCost] = useState(0);
    const [sealNumber, setSealNumber] = useState("");
    const [week, setWeek] = useState(0);
    const [transitTime, setTransitTime] = useState(0);
    const [shipper, setShipper] = useState("");
    const [consignee, setConsignee] = useState("");
    const [manufacturer, setManufacturer] = useState("");
    const [notify, setNotify] = useState("");
    const [billTo, setBillTo] = useState("");
    const [selectedCountries, setSelectedCountries] = useState([]);
    const [cmrNumber, setCmrNumber] = useState("");
    const [officeCode, setOfficeCode] = useState("");
    const [brokerageName, setBrokerageName] = useState("");
    const [customDetail, setCustomDetail] = useState({
        importResponsibility: false,
        exportResponsibility: false,
    });
    const [isADR, setIsADR] = useState(false); // ADR/DG anahtarı
    const [shipmentIncoterm, setShipmentIncoterm] = useState("");
    const [imco, setImco] = useState(null); // Seçilen IMCO sınıfı
    const [selectedServiceProvider, setSelectedServiceProvider] = useState(null);
    const [emissionFactor, setEmissionFactor] = useState(0);
    const [totalCarbonEmissions, setTotalCarbonEmissions] = useState(0);
    const [selectedCountry, setSelectedCountry] = useState(null);
    const [selectedDeliveryCountry, setSelectedDeliveryCountry] = useState(null);
    const [pickupDate, setPickupDate] = useState(null);
    const [estimatedDeliveryDate, setEstimatedDeliveryDate] = useState(null);
    const [requestedDeliveryDate, setRequestedDeliveryDate] = useState(null);
    const [estimatedDeparture, setEstimatedDeparture] = useState(null);
    const [actualDeparture, setActualDeparture] = useState(null);
    const [actualDelivery, setActualDelivery] = useState(null);
    const [proofOfDelivery, setProofOfDelivery] = useState(null);
    const [appointmentDate, setAppointmentDate] = useState(null);
    const [selectedOceanTransportSubOption, setSelectedOceanTransportSubOption] = useState(null);
    const [plateContainerNumber, setPlateContainerNumber] = useState(null);
    const [pickupTime, setPickupTime] = useState("");
    const [estimatedDeliveryTime, setEstimatedDeliveryTime] = useState("");
    const [estimatedDepartureTime, setEstimatedDepartureTime] = useState("");
    const [requestedDeliveryTime, setRequestedDeliveryTime] = useState("");
    const [actualDepartureTime, setActualDepartureTime] = useState("");
    const [actualDeliveryTime, setActualDeliveryTime] = useState("");
    const [proofOfDeliveryTime, setProofOfDeliveryTime] = useState("");
    const [appointmentTime, setAppointmentTime] = useState("");
    const [exportDeclaration, setExportDeclaration] = useState(null);
    const [importDeclaration, setImportDeclaration] = useState(null);
    const [atr, setAtr] = useState(null);
    const [cmr, setCmr] = useState(null);
    const [confirmationMail, setConfirmationMail] = useState(null);
    const [t1t2, setT1t2] = useState(null);
    const [packingList, setPackingList] = useState(null);
    const [commercialInvoice, setCommercialInvoice] = useState(null);
    const [signedCmr, setSignedCmr] = useState(null);
    const [closedT1t2, setClosedT1t2] = useState(null);
    const [linehaulCarrier, setLinehaulCarrier] = useState(null);
    const [pickupCarrier, setPickupCarrier] = useState(null);
    const [carrierBroker, setCarrierBroker] = useState(null);
    const [sallingRate, setSallingRate] = useState(null);
    const [currency, setCurrency] = useState("");
    const [shippingLine, setShippingLine] = useState("");
    const [bookingNumber, setBookingNumber] = useState("");
    const [profit, setProfit] = useState(0); // Başlangıç değeri null
    const [quoteNoList, setQuoteNoList] = useState([]); // Açılır menü seçenekleri
    const [selectedQuoteNo, setSelectedQuoteNo] = useState(null); // Seçilen değer
    const [quoteDetails, setQuoteDetails] = useState([]); // Tüm quote detaylarını tutar
    const [locationHistory, setLocationHistory] = useState([]);
    const [refreshLocationHistory, setRefreshLocationHistory] = useState(false);
    const [buyingRate, setBuyingRate] = useState("");
    const [buyingRateCurrency, setBuyingRateCurrency] = useState("EUR");
    const [pickupRate, setPickupRate] = useState("");
    const [pickupRateCurrency, setPickupRateCurrency] = useState("EUR");
    const [deliveryRate, setDeliveryRate] = useState("");
    const [deliveryRateCurrency, setDeliveryRateCurrency] = useState("EUR");
    const [exportCustomsRate, setExportCustomsRate] = useState("");
    const [exportCustomsRateCurrency, setExportCustomsRateCurrency] = useState("EUR");
    const [importCustomsRate, setImportCustomsRate] = useState("");
    const [importCustomsRateCurrency, setImportCustomsRateCurrency] = useState("EUR");
    const [sellingRate, setSellingRate] = useState("");
    const [sellingRateCurrency, setSellingRateCurrency] = useState("EUR");
    const [selectedTransport, setSelectedTransport] = useState(null);
    const [gateInWithoutStorageDate, setGateInWithoutStorageDate] = useState(null);
    const [gateInWithoutStorageTime, setGateInWithoutStorageTime] = useState("");
    const [pickupServiceProvider, setPickupServiceProvider] = useState("");
    const [deliveryServiceProvider, setDeliveryServiceProvider] = useState("");
    const [vesselServiceType, setVesselServiceType] = useState("Direct");
    const [vesselPolOptions, setVesselPolOptions] = useState([]);
    const [vesselPodOptions, setVesselPodOptions] = useState([]);
    const [vesselPolLoading, setVesselPolLoading] = useState(false);
    const [vesselPodLoading, setVesselPodLoading] = useState(false);
    const [transshipmentPortOptions, setTransshipmentPortOptions] = useState({});
    const [transshipmentPortLoading, setTransshipmentPortLoading] = useState({});
    const [deliveryCarrierInvoice, setDeliveryCarrierInvoice] = useState(null);
    const [carrierImportCustomBrokerInvoice, setCarrierImportCustomBrokerInvoice] = useState(null);
    const [connectOmblOpen, setConnectOmblOpen] = useState(false);
    // OMBL this shipment is already connected to (sent by the backend as `linkedOmbl`).
    const [linkedOmbl, setLinkedOmbl] = useState(null);
    const linkedOmblLabel = linkedOmbl ? linkedOmbl.omblNumber || "an OMBL" : "";
    // Styled through sx like the app's other chips: the theme breaks on Chip variant/color props.
    const linkedOmblChipSx = {
        fontWeight: 600,
        color: "#1e3a8a",
        backgroundColor: "#FFFFFF",
        border: "1px solid #B6CCF5",
    };
    const [existingOmbls, setExistingOmbls] = useState([]);
    const [omblLoading, setOmblLoading] = useState(false);
    const [isCloneMode, setIsCloneMode] = useState(false);
    const [loadingAddress, setLoadingAddress] = useState(emptyServiceAddress);
    const [loadingAddressOptions, setLoadingAddressOptions] = useState([]);
    const [loadingAddressLoading, setLoadingAddressLoading] = useState(false);
    const [loadingDate, setLoadingDate] = useState(null);
    const [loadingTime, setLoadingTime] = useState("");
    const [additionalFees, setAdditionalFees] = useState([{ fee: "", rate: "", unit: 1, currency: "EUR" }]);
    const [finalSellingRate, setFinalSellingRate] = useState("");
    const FEE_OPTIONS_KEY = "ocean_additional_fee_options_v1";
    const [billOfLadingType, setBillOfLadingType] = useState("HBL");
    const [showDirectMblSection, setShowDirectMblSection] = useState(false);
    const isDirectBL = billOfLadingType === "DIRECT_BL";

    // "Edit DBL" from the shipment list opens this page with the shipment id only. Find the
    // shipment's DBL record so the embedded DBL form loads its saved data instead of a blank one.
    const [resolvedDmblId, setResolvedDmblId] = useState(null);
    const dmblId = urlDmblId || resolvedDmblId;

    useEffect(() => {
        if (urlDmblId || !isDirectBL || !dblShipmentId) return undefined;

        let cancelled = false;
        CrudService.getOMBLs({ shipmentId: dblShipmentId })
            .then((res) => {
                const list = Array.isArray(res?.data) ? res.data : Array.isArray(res?.data?.data) ? res.data.data : [];
                const isDbl = (attr = {}) =>
                    attr.billOfLadingType === "DIRECT_BL" || attr.isDirectBL === true || attr.sourceType === "DBL";
                const match = list.find((mbl) => isDbl(mbl?.attributes)) || (list.length === 1 ? list[0] : null);
                if (!cancelled && match?.id) setResolvedDmblId(match.id);
            })
            .catch((err) => console.error("DBL record lookup failed:", err));

        return () => {
            cancelled = true;
        };
    }, [urlDmblId, isDirectBL, dblShipmentId]);
    const [additionalFeeOptions, setAdditionalFeeOptions] = useState(() => {
        try {
            const saved = localStorage.getItem(FEE_OPTIONS_KEY);
            if (saved) return JSON.parse(saved);
        } catch {}

        return oceanAdditionalFeeOptions;
    });



    const [transshipments, setTransshipments] = useState([
        {
            country: "",
            port: "",
            transshipmentEtaDate: null,
            transshipmentEtaTime: "",
        },
    ]);

    const [vesselPol, setVesselPol] = useState({
        country: "",
        port: "",
    });

    const [vesselPod, setVesselPod] = useState({
        country: "",
        port: "",
    });


    useEffect(() => {
        if (!vesselPol.country) {
            setVesselPolOptions([]);
            return;
        }

        setVesselPolLoading(true);
        fetchOptionsByCountryAndType(vesselPol.country, "port")
            .then(setVesselPolOptions)
            .finally(() => setVesselPolLoading(false));
    }, [vesselPol.country]);

    useEffect(() => {
        if (!vesselPod.country) {
            setVesselPodOptions([]);
            return;
        }

        setVesselPodLoading(true);
        fetchOptionsByCountryAndType(vesselPod.country, "port")
            .then(setVesselPodOptions)
            .finally(() => setVesselPodLoading(false));
    }, [vesselPod.country]);

    useEffect(() => {
        transshipments.forEach((item, index) => {
            if (!item.country) {
                setTransshipmentPortOptions((prev) => ({
                    ...prev,
                    [index]: [],
                }));
                return;
            }

            setTransshipmentPortLoading((prev) => ({
                ...prev,
                [index]: true,
            }));

            fetchOptionsByCountryAndType(item.country, "port")
                .then((options) => {
                    setTransshipmentPortOptions((prev) => ({
                        ...prev,
                        [index]: options,
                    }));
                })
                .finally(() => {
                    setTransshipmentPortLoading((prev) => ({
                        ...prev,
                        [index]: false,
                    }));
                });
        });
    }, [transshipments.map((x) => x.country).join("|")]);

    useEffect(() => {
        if (!loadingAddress.country || !loadingAddress.type) {
            setLoadingAddressOptions([]);
            return;
        }

        setLoadingAddressLoading(true);
        fetchOptionsByCountryAndType(loadingAddress.country, loadingAddress.type)
            .then(setLoadingAddressOptions)
            .finally(() => setLoadingAddressLoading(false));
    }, [loadingAddress.country, loadingAddress.type]);

    const feeLabelOf = (option) => (typeof option === "string" ? option : option?.label || "");

    const saveNewFeeOption = (value) => {
        const label = String(value || "").trim();
        if (!label) return;

        setAdditionalFeeOptions((prev) => {
            const exists = prev.some(
                (item) =>
                    feeLabelOf(item)
                        .toLowerCase()
                        .trim() === label.toLowerCase()
            );

            if (exists) return prev;

            const updated = [...prev, { label }];
            localStorage.setItem(FEE_OPTIONS_KEY, JSON.stringify(updated));
            return updated;
        });

        setSnackbar({
            open: true,
            severity: "success",
            message: `"${label}" has been added to the fee list.`,
        });
    };

    // Saved fee names (the "Add" button) can be renamed or removed. Rows already
    // using a renamed fee follow the new name.
    const [feeOptionDialog, setFeeOptionDialog] = useState({ open: false, original: "", value: "" });

    const persistFeeOptions = (updated) => {
        try {
            localStorage.setItem(FEE_OPTIONS_KEY, JSON.stringify(updated));
        } catch {}
        return updated;
    };

    const renameFeeOption = (original, nextLabel) => {
        const label = String(nextLabel || "").trim();
        if (!label || label === original) return;

        const duplicate = additionalFeeOptions.some(
            (item) =>
                feeLabelOf(item) !== original &&
                feeLabelOf(item).toLowerCase().trim() === label.toLowerCase()
        );

        if (duplicate) {
            setSnackbar({ open: true, severity: "error", message: `"${label}" is already in the fee list.` });
            return;
        }

        setAdditionalFeeOptions((prev) =>
            persistFeeOptions(
                prev.map((item) =>
                    feeLabelOf(item) === original
                        ? typeof item === "string"
                            ? label
                            : { ...item, label }
                        : item
                )
            )
        );
        setAdditionalFees((prev) => prev.map((row) => (row.fee === original ? { ...row, fee: label } : row)));
        setSnackbar({ open: true, severity: "success", message: `"${original}" was renamed to "${label}".` });
    };

    const deleteFeeOption = (original) => {
        setAdditionalFeeOptions((prev) => persistFeeOptions(prev.filter((item) => feeLabelOf(item) !== original)));
        setSnackbar({ open: true, severity: "success", message: `"${original}" was removed from the fee list.` });
    };

    const addAdditionalFee = () => {
        setAdditionalFees((prev) => [
            ...prev,
            { fee: "", rate: "", unit: 1, currency: sellingRateCurrency || "EUR" },
        ]);
    };

    const removeAdditionalFee = (index) => {
        setAdditionalFees((prev) => prev.filter((_, i) => i !== index));
    };

    const updateAdditionalFee = (index, field, value) => {
        setAdditionalFees((prev) =>
            prev.map((row, i) =>
                i === index ? { ...row, [field]: value } : row
            )
        );
    };
    // A fee's amount is its rate times its unit count (legacy rows without a unit = 1).
    const getFeeUnits = (row) =>
        row.unit === undefined || row.unit === null ? 1 : Number(row.unit) || 0;
    const getFeeLineAmount = (row) => (Number(row.rate) || 0) * getFeeUnits(row);

    const convertedAdditionalTotal = additionalFees.reduce((sum, row) => {
        return (
            sum +
            convertCurrency(
                getFeeLineAmount(row),
                row.currency,
                sellingRateCurrency,
                exchangeRates
            )
        );
    }, 0);

    const totalAdditionalFeeRate = convertedAdditionalTotal.toFixed(2)

    useEffect(() => {
        const baseSellingRate = Number(sellingRate || 0);

        const additionalFeeTotal = additionalFees.reduce((sum, row) => {
            const convertedRate = convertCurrency(
                getFeeLineAmount(row),
                row.currency,
                sellingRateCurrency,
                exchangeRates
            );

            return sum + convertedRate;
        }, 0);

        setFinalSellingRate(baseSellingRate + additionalFeeTotal);
    }, [sellingRate, sellingRateCurrency, additionalFees, exchangeRates]);

    const addTransshipment = () => {
        setTransshipments((prev) => [
            ...prev,
            {
                country: "",
                port: "",
                transshipmentEtaDate: null,
                transshipmentEtaTime: "",
            },
        ]);
    };

    const removeTransshipment = (index) => {
        setTransshipments((prev) => prev.filter((_, i) => i !== index));
    };

    const updateTransshipment = (index, field, value) => {
        setTransshipments((prev) =>
            prev.map((item, i) =>
                i === index ? { ...item, [field]: value } : item
            )
        );
    };
    const showPricing = customDetail?.responsibility || customDetail?.responsibilityImport;
    const [selectedService, setSelectedService] = useState("Door to Door");
    const isPickupDisabled = selectedService === "Port to Port" || selectedService === "Port to Door";

    const isDeliveryDisabled = selectedService === "Door to Port" || selectedService === "Port to Port";
    const utikadNumberOptions = Array.from({ length: 19 }, (_, i) => {
        const number = 1233 + i;
        return {
            label: String(number).padStart(6, "0"),
        };
    });
    const disabledSectionSx = (disabled) => ({
        position: "relative",
        border: "1px solid",
        borderColor: disabled ? "rgba(0,0,0,0.08)" : "rgba(25,118,210,0.12)",
        backgroundColor: disabled ? "rgba(245,245,245,0.9)" : "#fff",
        borderRadius: 2,
        p: 2,
        opacity: disabled ? 0.72 : 1,
        pointerEvents: disabled ? "none" : "auto",
        transition: "all 0.2s ease",
        boxShadow: disabled ? "none" : "0 2px 8px rgba(0,0,0,0.04)",
    });
    const disabledHintSx = {
        mb: 1.5,
        px: 1.25,
        py: 0.75,
        borderRadius: 1.5,
        backgroundColor: "rgba(255,255,255,0.75)",
        border: "1px dashed rgba(0,0,0,0.12)",
    };

    const [pickupAddress1, setPickupAddress1] = useState(emptyServiceAddress);
    const [pickupAddress2, setPickupAddress2] = useState(emptyServiceAddress);
    const [deliveryAddress1, setDeliveryAddress1] = useState(emptyServiceAddress);
    const [deliveryAddress2, setDeliveryAddress2] = useState(emptyServiceAddress);

    const optionsCache = React.useRef(new Map());
    const [utikadNumber, setUtikadNumber] = useState("");
    const [pickupAddress1Options, setPickupAddress1Options] = useState([]);
    const [pickupAddress2Options, setPickupAddress2Options] = useState([]);
    const [deliveryAddress1Options, setDeliveryAddress1Options] = useState([]);
    const [deliveryAddress2Options, setDeliveryAddress2Options] = useState([]);

    const [pickupAddress1Loading, setPickupAddress1Loading] = useState(false);
    const [pickupAddress2Loading, setPickupAddress2Loading] = useState(false);
    const [deliveryAddress1Loading, setDeliveryAddress1Loading] = useState(false);
    const [deliveryAddress2Loading, setDeliveryAddress2Loading] = useState(false);

    const [bookingConfirmationDate, setBookingConfirmationDate] = useState(null);
    const [bookingConfirmationTime, setBookingConfirmationTime] = useState("");
    const [bookingConfirmationPdf, setBookingConfirmationPdf] = useState(null);
    const [vesselName, setVesselName] = useState("");
    const [voyageNumber, setVoyageNumber] = useState("");

    const [customsDeclarationCutoffDate, setCustomsDeclarationCutoffDate] = useState(null);
    const [customsDeclarationCutoffTime, setCustomsDeclarationCutoffTime] = useState("");

    const [shippingInstructionCutoffDate, setShippingInstructionCutoffDate] = useState(null);
    const [shippingInstructionCutoffTime, setShippingInstructionCutoffTime] = useState("");

    const [freeTimeDetention, setFreeTimeDetention] = useState("");
    const [freeTimeDemurrage, setFreeTimeDemurrage] = useState("");
    const [freightStatus, setFreightStatus] = useState("");

    const getServiceLayout = (service) => {
        switch ((service || "").trim()) {
            case "Door to Door":
                return {
                    pickup: [
                        { key: "pickupAddress1", type: "door", label: "Loading Address" },
                    ],
                    delivery: [
                        { key: "deliveryAddress2", type: "door", label: "Delivery Address" },
                    ],
                };

            case "Door to Port":
                return {
                    pickup: [
                        { key: "pickupAddress1", type: "door", label: "Loading Address" },
                    ],
                    delivery: [],
                };

            case "Port to Door":
                return {
                    pickup: [],
                    delivery: [
                        { key: "deliveryAddress2", type: "door", label: "Delivery Address" },
                    ],
                };

            case "Port to Port":
                return {
                    pickup: [],
                    delivery: [],
                };

            default:
                return {
                    pickup: [],
                    delivery: [],
                };
        }
    };
    const serviceLayout = useMemo(
        () => getServiceLayout(selectedService),
        [selectedService]
    );

    const normalizeOptions = (payload) => {
        const raw = payload?.data?.data || payload?.data || payload || [];
        const arr = Array.isArray(raw) ? raw : [];

        return arr
            .map((x) => {
                if (typeof x === "string") return x;
                return x?.name ?? x?.label ?? x?.title ?? x?.value ?? "";
            })
            .filter(Boolean);
    };

    const getLocationKindFromType = (type) => {
        if (type === "door") return "city";
        if (type === "port") return "seaport";
        return null;
    };


    const fetchOptionsByCountryAndType = async (country, type) => {
        if (!country || !type) return [];

        const kind = getLocationKindFromType(type);
        if (!kind) return [];

        const cacheKey = `${kind}:${country}`;
        const cached = optionsCache.current.get(cacheKey);

        if (cached && Array.isArray(cached) && cached.length > 0) {
            return cached;
        }

        try {
            let res;

            if (kind === "city") {
                res = await CrudService.getCitiesByCountry(country);
            } else if (kind === "seaport") {
                res = await CrudService.getSeaportsByCountry(country);
            } else {
                return [];
            }

            const list = normalizeOptions(res);

            if (list.length > 0) {
                optionsCache.current.set(cacheKey, list);
            } else {
                optionsCache.current.delete(cacheKey);
            }

            return list;
        } catch (e) {
            console.error("fetchOptionsByCountryAndType failed:", { country, type, e });
            optionsCache.current.delete(cacheKey);
            return [];
        }
    };

    useEffect(() => {
        const layout = getServiceLayout(selectedService);

        const pickupKeys = layout.pickup.map((x) => x.key);
        const deliveryKeys = layout.delivery.map((x) => x.key);

        if (!pickupKeys.includes("pickupAddress1")) setPickupAddress1(emptyServiceAddress);
        setPickupAddress2(emptyServiceAddress);

        setDeliveryAddress1(emptyServiceAddress);
        if (!deliveryKeys.includes("deliveryAddress2")) setDeliveryAddress2(emptyServiceAddress);
    }, [selectedService]);

    useEffect(() => {
        if (!pickupAddress1.country || !pickupAddress1.type) {
            setPickupAddress1Options([]);
            return;
        }

        setPickupAddress1Loading(true);
        fetchOptionsByCountryAndType(pickupAddress1.country, pickupAddress1.type)
            .then(setPickupAddress1Options)
            .finally(() => setPickupAddress1Loading(false));
    }, [pickupAddress1.country, pickupAddress1.type]);

    useEffect(() => {
        if (!pickupAddress2.country || !pickupAddress2.type) {
            setPickupAddress2Options([]);
            return;
        }

        setPickupAddress2Loading(true);
        fetchOptionsByCountryAndType(pickupAddress2.country, pickupAddress2.type)
            .then(setPickupAddress2Options)
            .finally(() => setPickupAddress2Loading(false));
    }, [pickupAddress2.country, pickupAddress2.type]);

    useEffect(() => {
        if (!deliveryAddress1.country || !deliveryAddress1.type) {
            setDeliveryAddress1Options([]);
            return;
        }

        setDeliveryAddress1Loading(true);
        fetchOptionsByCountryAndType(deliveryAddress1.country, deliveryAddress1.type)
            .then(setDeliveryAddress1Options)
            .finally(() => setDeliveryAddress1Loading(false));
    }, [deliveryAddress1.country, deliveryAddress1.type]);

    useEffect(() => {
        if (!deliveryAddress2.country || !deliveryAddress2.type) {
            setDeliveryAddress2Options([]);
            return;
        }

        setDeliveryAddress2Loading(true);
        fetchOptionsByCountryAndType(deliveryAddress2.country, deliveryAddress2.type)
            .then(setDeliveryAddress2Options)
            .finally(() => setDeliveryAddress2Loading(false));
    }, [deliveryAddress2.country, deliveryAddress2.type]);

    useEffect(() => {
        setPickupAddress1Options([]);
        setPickupAddress2Options([]);
        setDeliveryAddress1Options([]);
        setDeliveryAddress2Options([]);
    }, [selectedService]);

    const renderServiceAddressFields = (
        title,
        address,
        setAddress,
        type,
        dynamicOptions = [],
        loading = false
    ) => (
        <MDBox
            sx={{
                border: "1px solid #e0e0e0",
                borderRadius: 2,
                p: 2,
                height: "100%",
                backgroundColor: "#fff",
            }}
        >
            <MDTypography variant="subtitle2" mb={2}>
                {title}
            </MDTypography>

            <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                    <Autocomplete
                        options={countryOptions}
                        value={countryOptions.find((c) => c.label === address.country) || null}
                        onChange={(_e, newValue) =>
                            setAddress((prev) => ({
                                ...prev,
                                country: newValue?.label || "",
                                city: "",
                                port: "",
                                type,
                            }))
                        }
                        getOptionLabel={(option) => option?.label || ""}
                        isOptionEqualToValue={(option, value) => option?.label === value?.label}
                        renderOption={({ key: optionKey, ...props }, option) => (
                            <li key={optionKey} {...props} style={{ display: "flex", alignItems: "center" }}>
                                {option.flagUrl && (
                                    <img
                                        src={option.flagUrl}
                                        alt={option.label}
                                        width="20"
                                        height="15"
                                        style={{ marginRight: 8 }}
                                    />
                                )}
                                {option.label}
                            </li>
                        )}
                        renderInput={(params) => (
                            <TextField
                                {...params}
                                label="Country"
                                fullWidth
                                variant="outlined"
                                InputLabelProps={{ shrink: true }}
                            />
                        )}
                    />
                </Grid>

                {type === "door" && (
                    <Grid item xs={12} md={6}>
                        <Autocomplete
                            options={dynamicOptions}
                            loading={loading}
                            value={address.city || null}
                            onChange={(_e, newValue) =>
                                setAddress((prev) => ({
                                    ...prev,
                                    city: newValue || "",
                                    port: "",
                                    type,
                                }))
                            }
                            freeSolo
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="City"
                                    fullWidth
                                    variant="outlined"
                                    InputLabelProps={{ shrink: true }}
                                />
                            )}
                        />
                    </Grid>
                )}

                {type === "port" && (
                    <Grid item xs={12} md={6}>
                        <Autocomplete
                            options={dynamicOptions}
                            loading={loading}
                            value={address.port || null}
                            onChange={(_e, newValue) =>
                                setAddress((prev) => ({
                                    ...prev,
                                    port: newValue || "",
                                    city: "",
                                    type,
                                }))
                            }
                            freeSolo
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Port"
                                    fullWidth
                                    variant="outlined"
                                    InputLabelProps={{ shrink: true }}
                                />
                            )}
                        />
                    </Grid>
                )}
            </Grid>
        </MDBox>
    );
    const getPickupTitle = (key) => {
        if (key === "pickupAddress1") return "Loading Address";
        return "";
    };

    const getDeliveryTitle = (key) => {
        if (key === "deliveryAddress2") return "Delivery Address";
        return "";
    };


    // Generic state handler
    const handleStateChange = (setter, key, value) => {
        setter((prevState) => ({
            ...prevState,
            [key]: value,
        }));
    };

    useEffect(() => {
        const fetchShipmentNo = async () => {
            try {
                // Yeni gönderi için gereken `payload`'u burada tanımlayın
                const payload = {};

                if (payload._id && !mongoose.Types.ObjectId.isValid(payload._id)) {
                    return;
                }

                const response = await CrudService.getOceanShipmentNumber();
                const shipmentNoValue = response?.data?.attributes?.shipmentNo;

                if (shipmentNoValue) {
                    setShipmentNo(shipmentNoValue);
                } else {
                    console.error("Shipment number not found in response:", response);
                }
            } catch (error) {
                console.error("Failed to fetch shipment number:", error);
            }
        };

        fetchShipmentNo();
    }, []);

    const renderCountryAutocomplete = (
        label,
        options,
        value,
        onChange,
        setLocationState,
        handleStateChange,
        fieldName = "country"
    ) => (
        <Autocomplete
            value={value}
            onChange={(event, newValue) => {
                onChange(newValue);
                handleStateChange(
                    setLocationState,
                    fieldName,
                    newValue?.label || ""
                );
            }}
            options={options}
            getOptionLabel={(option) => option?.label || ""}
            isOptionEqualToValue={(option, value) =>
                option?.label === value?.label
            }
            renderOption={({ key: optionKey, ...props }, option) => (
                <li key={optionKey} {...props} style={{ display: "flex", alignItems: "center" }}>
                    {option.flagUrl && (
                        <img
                            src={option.flagUrl}
                            alt={`${option.label} flag`}
                            width="20"
                            height="15"
                            style={{ marginRight: 8 }}
                        />
                    )}
                    {option.label}
                </li>
            )}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label={label}
                    variant="outlined"
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    sx={{
                        "& .MuiInputBase-root": { height: 40 },
                        "& .MuiOutlinedInput-input": { padding: "0 14px" }
                    }}
                />
            )}
        />
    );

    const calculateTransitTime = () => {
        if (pickupDate && estimatedDeliveryDate) {
            const diffTime = estimatedDeliveryDate - pickupDate;
            const diffDays = diffTime / (1000 * 60 * 60 * 24);
            return Math.floor(diffDays);
        }
        return 0;
    };

    const calculateWeekNumber = () => {
        return pickupDate ? getISOWeek(pickupDate) : 0;
    };
    const showActionFeedback = (message, severity = "success") => {
        setSnackbar({
            open: true,
            severity,
            message,
        });

        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    const [cargoDetails, setCargoDetails] = useState(() => [newCargo()]);

    // Yeni bir cargo eklemek için fonksiyon
    const addCargoDetail = () => {
        setCargoDetails((prev) => [...prev, newCargo()]);
    };

    // Was `const updated = [...cargoDetails]; updated[index][field] = value;
    // setCargoDetails(updated)` -- that shallow-copies the ARRAY but still
    // mutates the SAME row object, and reads `cargoDetails` from this
    // closure rather than from the latest state. Under React's batching,
    // two updates fired close together (fast typing, or another
    // cargo-updating call in the same tick) both start from the same
    // pre-batch snapshot, so the second call's setCargoDetails silently
    // discards the first one's change -- a value the user just typed could
    // vanish, intermittently, with no error. The functional form + a fresh
    // row object fixes both.
    const updateCargoDetails = (index, field, value) => {
        setCargoDetails((prev) =>
            prev.map((cargo, i) => {
                if (i !== index) return cargo;

                const next = { ...cargo, [field]: value };

                // The cargo's packing type pre-fills the container rows that still use the old one.
                if (field === "selectedPackingType") {
                    next.containers = (cargo.containers || []).map((row) =>
                        !row.packingType || row.packingType === cargo.selectedPackingType
                            ? { ...row, packingType: value }
                            : row
                    );
                }

                return next;
            })
        );
    };

    const updateCargoAt = (index, updater) => {
        setCargoDetails((prev) => prev.map((cargo, i) => (i === index ? updater(cargo) : cargo)));
    };

    const addContainerGroup = (cargoIndex) => {
        updateCargoAt(cargoIndex, (cargo) =>
            syncContainerRows(cargo, [...(cargo.containerGroups || []), newContainerGroup()])
        );
    };

    const removeContainerGroup = (cargoIndex, groupId) => {
        updateCargoAt(cargoIndex, (cargo) =>
            syncContainerRows(cargo, (cargo.containerGroups || []).filter((group) => group.id !== groupId))
        );
    };

    const updateContainerGroup = (cargoIndex, groupId, field, value) => {
        updateCargoAt(cargoIndex, (cargo) =>
            syncContainerRows(
                cargo,
                (cargo.containerGroups || []).map((group) =>
                    group.id === groupId ? { ...group, [field]: value } : group
                )
            )
        );
    };

    const updateContainerRow = (cargoIndex, rowIndex, field, value) => {
        updateCargoAt(cargoIndex, (cargo) =>
            withContainerTotals({
                ...cargo,
                containers: (cargo.containers || []).map((row, i) =>
                    i === rowIndex ? { ...row, [field]: value } : row
                ),
            })
        );
    };


    const calculateTotals = () => {
        const totalCbm = cargoDetails.reduce((acc, cargo) => acc + Number(cargo.cbm || 0), 0);
        return { totalCbm };
    };

    useEffect(() => {
        const totals = calculateTotals();
        setTotals(totals);
    }, [cargoDetails]);

    const [totals, setTotals] = useState({
        totalCbm: 0,
    });

    useEffect(() => {
        const totals = calculateTotals(); // Toplamları hesapla
        setTotals(totals); // Toplamları state’e ata
    }, [cargoDetails]); // cargoDetails her güncellendiğinde çalışır




    const [snackbar, setSnackbar] = useState({
        open: false,
        message: "",
        severity: "error"
    });

    /*
     * Carrier auto-fill: once a Shipping Line and the first Container No are
     * entered, ask the carrier's Track & Trace API (Ocean Shipment Status
     * lookup, nothing is saved) and fill the vessel / route / date fields that
     * are still EMPTY. Values typed by the user are never overwritten.
     */
    const carrierLookupKeyRef = useRef("");
    // Shown in the Service Details hint: idle | loading | filled | skipped | info
    const [carrierLookup, setCarrierLookup] = useState({ state: "idle", message: "" });

    const firstContainerNo = useMemo(() => {
        for (const cargo of cargoDetails || []) {
            for (const container of cargo.containers || []) {
                if (container?.containerNo) return container.containerNo.replace(/[^A-Z0-9]/gi, "").toUpperCase();
            }
            if (cargo?.containerNo) return cargo.containerNo.replace(/[^A-Z0-9]/gi, "").toUpperCase();
        }
        return "";
    }, [cargoDetails]);

    // ISO 6346 size/type code (e.g. 45G1) -> this form's container type labels.
    const containerTypeFromIso = (iso) => {
        const code = String(iso || "").toUpperCase();
        if (code.length < 3) return "";
        const length = { 2: "20", 4: "40", L: "45" }[code[0]];
        const highCube = code[1] === "5";
        const group = code[2];
        if (!length) return "";
        if (group === "R") return length === "20" ? "20'Reefer" : "40'HC Reefer";
        if (group === "U") return length === "20" ? "20'Open-Top" : "40'Open-Top";
        if (group === "P") return length === "20" ? "20'Flatrack" : "40'Flatrack";
        if (group === "G") {
            if (length === "45") return "45'HC";
            if (length === "40") return highCube ? "40'HC" : "40'DC";
            return "20'DC";
        }
        return "";
    };

    const countryLabelOf = (code) => countryOptions.find((c) => c.code === code)?.label || "";

    // Carrier times (UTC) -> date picker + "HH:mm" in Türkiye time.
    const splitCarrierDate = (value) => istanbulPickerValue(value);

    const applyCarrierLookup = (data, typedContainerNo) => {
        if (!data) return;
        if (data.status === "UNSUPPORTED_CARRIER") {
            setCarrierLookup({ state: "info", message: `Auto-fill is not available for ${shippingLine}.` });
            return;
        }

        if (data.status !== "OK") {
            const reason = {
                NOT_CONFIGURED: "the carrier API is not connected yet",
                NOT_FOUND: "the carrier has no active record for this container",
            }[data.status] || data.error || "the carrier API did not answer";
            setCarrierLookup({ state: "skipped", message: `Not filled for ${data.containerNumber}: ${reason}.` });
            setSnackbar({
                open: true,
                severity: "info",
                message: `Carrier auto-fill skipped for ${data.containerNumber}: ${reason}.`,
            });
            return;
        }

        const filled = [];

        if (!vesselName && data.vesselName) {
            setVesselName(data.vesselName);
            filled.push("Vessel");
        }
        if (!voyageNumber && data.voyageNumber) {
            setVoyageNumber(data.voyageNumber);
            filled.push("Voyage");
        }
        if (!vesselPol.port && data.pol) {
            setVesselPol({ country: countryLabelOf(data.pol.countryCode), port: data.pol.port });
            filled.push("POL");
        }
        if (!vesselPod.port && data.pod) {
            setVesselPod({ country: countryLabelOf(data.pod.countryCode), port: data.pod.port });
            filled.push("POD");
        }

        const transshipmentsEmpty = transshipments.every((t) => !t.country && !t.port);
        if (transshipmentsEmpty && data.transshipments?.length) {
            setVesselServiceType("T/Shipment");
            setTransshipments(
                data.transshipments.map((t) => {
                    const eta = splitCarrierDate(t.eta);
                    return {
                        country: countryLabelOf(t.countryCode),
                        port: t.port,
                        transshipmentEtaDate: eta?.date || null,
                        transshipmentEtaTime: eta?.time || "",
                    };
                })
            );
            filled.push("T/Shipment");
        }

        const departure = splitCarrierDate(data.etd || data.atd);
        if (!estimatedDeparture && departure) {
            setEstimatedDeparture(departure.date);
            setEstimatedDepartureTime(departure.time);
            filled.push(data.etd ? "ETD" : "ETD (actual)");
        }
        const actualDep = splitCarrierDate(data.atd);
        if (!actualDeparture && actualDep) {
            setActualDeparture(actualDep.date);
            setActualDepartureTime(actualDep.time);
        }
        const arrival = splitCarrierDate(data.eta || data.ata);
        if (!estimatedDeliveryDate && arrival) {
            setEstimatedDeliveryDate(arrival.date);
            setEstimatedDeliveryTime(arrival.time);
            filled.push(data.eta ? "ETA" : "ETA (actual)");
        }

        // Container: complete a missing check digit, fill an empty type.
        const typeLabel = containerTypeFromIso(data.isoEquipmentCode);
        const completed = data.containerNumber && data.containerNumber !== typedContainerNo;
        if (completed || typeLabel) {
            setCargoDetails((prev) =>
                prev.map((cargo) => ({
                    ...cargo,
                    containers: (cargo.containers || []).map((c) => {
                        const no = String(c.containerNo || "").replace(/[^A-Z0-9]/gi, "").toUpperCase();
                        if (no !== typedContainerNo) return c;
                        return {
                            ...c,
                            containerNo: data.containerNumber || c.containerNo,
                            containerType: c.containerType || typeLabel,
                        };
                    }),
                }))
            );
            if (completed) filled.push(`Container No (${data.containerNumber})`);
        }

        setSnackbar({
            open: true,
            severity: filled.length ? "success" : "info",
            message: filled.length
                ? `Filled from ${shippingLine} API: ${filled.join(", ")}.`
                : `${shippingLine} API answered; all related fields were already filled.`,
        });
        const at = `${new Date().toLocaleTimeString("en-GB", { timeZone: "Europe/Istanbul", hour: "2-digit", minute: "2-digit", hourCycle: "h23" })} TRT`;
        setCarrierLookup({
            state: "filled",
            message: filled.length
                ? `Filled from ${shippingLine} for ${data.containerNumber} at ${at}: ${filled.join(", ")}.`
                : `Checked ${shippingLine} for ${data.containerNumber} at ${at}; all related fields were already filled.`,
        });
    };

    useEffect(() => {
        if (!shippingLine || !/^[A-Z]{4}\d{6,7}$/.test(firstContainerNo)) return undefined;

        const key = `${shippingLine}|${firstContainerNo}`;
        if (key === carrierLookupKeyRef.current) return undefined;

        // Wait until typing settles before calling the carrier.
        const timer = setTimeout(async () => {
            carrierLookupKeyRef.current = key;
            setCarrierLookup({ state: "loading", message: `Checking ${shippingLine} for ${firstContainerNo}…` });
            try {
                const response = await CrudService.lookupOceanTracking({
                    shippingLine,
                    containerNumber: firstContainerNo,
                });
                applyCarrierLookup(response?.data, firstContainerNo);
            } catch (error) {
                // Invalid number (400) or network error: the form stays as typed.
                const detail = error?.errors?.[0]?.detail;
                console.warn("Carrier auto-fill failed:", detail || error);
                setCarrierLookup({
                    state: "skipped",
                    message: detail || "The carrier could not be reached; please fill the fields manually.",
                });
            }
        }, 900);

        return () => clearTimeout(timer);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [shippingLine, firstContainerNo]);


    const getCleanCargoDetailsForPayload = () => (cargoDetails || []).map(cargoForPayload);

    const buildShipmentPayload = () => {
        const totals = calculateTotals();

        const carbonFootprintData = {
            plannedRouteCountries: selectedCountries
                .filter((country) => country && country.label)
                .map((country) => country.label),
            emissionFactor,
            totalCarbonEmissions,
        };
        const cleanCargoDetailsForPayload = getCleanCargoDetailsForPayload();

        return {
            customer: selectedCustomer?.name || "",
            salesRep: salesRep.map((rep) => rep.id),
            oceanTransportType: selectedOceanTransportSubOption?.label || "",
            incoterm: shipmentIncoterm,
            shipper,
            consignee,
            notify,
            manufacturer,
            billTo,
            commodity,
            quoteNo,
            hsCode,
            unit,
            grossWeight,
            cargoDetails: cleanCargoDetailsForPayload,
            totals: {
                totalCbm: totals.totalCbm,
            },
            notStackable,
            stackingFactor,
            operationType,
            pickupLocation: { ...pickupLocation },
            deliveryLocation: { ...deliveryLocation },
            exportLocation: { ...exportLocation },
            importLocation: { ...importLocation },
            countryOfOrigin,
            pickupDate,
            estimatedDeliveryDate,
            requestedDeliveryDate,
            estimatedDeparture,
            actualDeparture,
            actualDelivery,
            proofOfDelivery,
            appointmentDate,
            bookingConfirmationDate,
            pickupTime,
            estimatedDeliveryTime,
            requestedDeliveryTime,
            estimatedDepartureTime,
            actualDepartureTime,
            actualDeliveryTime,
            proofOfDeliveryTime,
            appointmentTime,
            bookingConfirmationTime,
            plateContainerNumber,
            cmrNumber,
            sealNumber,
            transitTime,
            week,
            carbonFootprint: carbonFootprintData,
            sallingRate,
            currency,
            profit,
            locationHistory,
            customDetail: {
                responsibility: customDetail?.responsibility || false,
                customNote: customDetail?.customNote || "",
                customRefNo: customDetail?.customRefNo || "",
                responsibilityImport: customDetail?.responsibilityImport || false,
                customNoteImport: customDetail?.customNoteImport || "",
            },
            adr: isADR,
            imco: imco || "",
            serviceProvider: selectedServiceProvider?.name || selectedServiceProvider || "",
            buyingRate,
            buyingRateCurrency,
            pickupRate,
            pickupRateCurrency,
            deliveryRate,
            deliveryRateCurrency,
            exportCustomsRate,
            exportCustomsRateCurrency,
            importCustomsRate,
            importCustomsRateCurrency,
            sellingRateCurrency,
            additionalFees,
            service: selectedService,
            pickupAddress1,
            pickupAddress2,
            deliveryAddress1,
            deliveryAddress2,
            vesselName,
            voyageNumber,
            customsDeclarationCutoffDate,
            customsDeclarationCutoffTime,
            shippingInstructionCutoffDate,
            shippingInstructionCutoffTime,
            freeTimeDetention,
            freeTimeDemurrage,
            gateInWithoutStorageDate,
            gateInWithoutStorageTime,
            pickupServiceProvider,
            deliveryServiceProvider,
            vesselServiceType,
            vesselPol,
            vesselPod,
            transshipments,
            shippingLine,
            bookingNumber: String(bookingNumber || "").trim(),
            freightStatus,
            utikadNumber,
            loadingAddress,
            loadingDate,
            loadingTime,
            sellingRate: sellingRate,
            baseSellingRate: sellingRate,
            finalSellingRate: finalSellingRate,
            billOfLadingType,
            isDirectBL
        };
    };

    const submitHandler = async (e, buttonType) => {
        e.preventDefault();

        // The customer is what the invoice is issued to; a shipment saved without one
        // ends up on the invoice pages as an unknown customer.
        if (!selectedCustomer?.name) {
            showActionFeedback("Please select a customer before saving the shipment.", "error");
            return;
        }

        const shipmentData = buildShipmentPayload();
        const willUpdate = isEditing && shipmentId && !isCloneMode;

        const formData = new FormData();

        const fileMap = {
            exportDeclaration,
            importDeclaration,
            atr,
            cmr,
            confirmationMail,
            t1t2,
            packingList,
            commercialInvoice,
            signedCmr,
            closedT1t2,
            linehaulCarrier,
            pickupCarrier,
            carrierBroker,
            bookingConfirmationPdf,
            deliveryCarrierInvoice,
            carrierImportCustomBrokerInvoice,
        };

        function appendFileSmart(fieldName, fileArray) {
            if (fileArray?.[0]) {
                formData.append(fieldName, fileArray[0]);
            } else if (willUpdate) {
                shipmentData[fieldName] = null;
            }
        }

        Object.entries(fileMap).forEach(([fieldName, fileArray]) => {
            appendFileSmart(fieldName, fileArray);
        });

        formData.append("data", JSON.stringify(shipmentData));

        try {
            setLoading(true);

            let response;

            if (willUpdate) {
                response = await CrudService.updateOceanShipment(formData, shipmentId);
            } else {
                response = await CrudService.createOceanShipment(formData);

                const createdId =
                    response?.data?.data?.id ||
                    response?.data?.id ||
                    response?.data?._id;

                if (createdId) {
                    setSavedShipmentId(createdId);
                }

                // The number shown before saving is only a preview; show the one actually assigned.
                const createdShipmentNo =
                    response?.data?.attributes?.shipmentNo || response?.data?.data?.attributes?.shipmentNo;
                if (createdShipmentNo) setShipmentNo(createdShipmentNo);
                setIsCloneMode(false);
                setIsEditing(false);

                // Open the saved shipment: the next save then updates it instead of creating
                // another copy, and every action on the page uses its id.
                if (createdId) {
                    navigate(`/shipping-order/create-ocean-shipment/details?id=${createdId}`, { replace: true });
                }
            }

            if (buttonType === "shipment") {
                setSuccessMessage("");
                setErrorMessage("");

                showActionFeedback(
                    willUpdate
                        ? "Shipment updated successfully."
                        : "Shipment created successfully.",
                    "success"
                );
                return;
            }

            setSnackbar({
                open: true,
                severity: "success",
                message: willUpdate
                    ? "Location history update was successfully completed."
                    : "Location history create was successfully completed.",
            });

            window.scrollTo({ top: 0, behavior: "smooth" });

            setLocationHistory(shipmentData.locationHistory);
            setPickupLocation({
                ...initialAddressState,
                ...shipmentData.pickupLocation,
            });
            setDeliveryLocation({
                ...initialAddressState,
                ...shipmentData.deliveryLocation,
            });
            setProofOfDelivery(shipmentData.proofOfDelivery);
            setProofOfDeliveryTime(shipmentData.proofOfDeliveryTime);
            setRefreshLocationHistory((prev) => !prev);
        } catch (err) {
            console.error("İstek başarısız oldu: ", err);

            setSnackbar({
                open: true,
                severity: "error",
                message: "Request failed. Please try again.",
            });

            window.scrollTo({ top: 0, behavior: "smooth" });
        } finally {
            setLoading(false);
        }
    };

    const handleCloneShipment = async () => {
        try {
            setLoading(true);

            const res = await CrudService.getOceanShipmentNumber();
            const nextShipmentNo = res?.data?.attributes?.shipmentNo || "";

            setIsCloneMode(true);
            setIsEditing(false);
            setShipmentNo(nextShipmentNo);

            // The clone gets its own DBL once saved; the source shipment's DBL is left alone.
            setSavedShipmentId("");
            setResolvedDmblId(null);
            setLinkedOmbl(null);
            setShowDirectMblSection(false);

            // The clone keeps what describes the goods (commodity, HS code, packing type,
            // description, origin); container numbers, seals, units and weights belong to each
            // file and start empty. The new container row takes the packing type, so it is not
            // printed / shown without one.
            setCargoDetails(
                (cargoDetails.length ? cargoDetails : [newCargo()]).map((cargo) => {
                    const fresh = newCargo();
                    const packingType = cargo.selectedPackingType || "";
                    return {
                        ...fresh,
                        commodity: cargo.commodity || "",
                        hsCode: cargo.hsCode || "",
                        selectedPackingType: packingType,
                        description: cargo.description || "",
                        goodsOriginCountry: cargo.goodsOriginCountry || "",
                        notStackable: cargo.notStackable ?? fresh.notStackable,
                        stackingFactor: cargo.stackingFactor ?? fresh.stackingFactor,
                        containers: fresh.containers.map((row) => ({ ...row, packingType })),
                    };
                })
            );

            // Through the router, so nothing on the page keeps using the source shipment's id
            // (saving, Connect OMBL, finance, DBL) while the clone is being edited.
            navigate("/shipping-order/create-ocean-shipment/details", { replace: true });

            setSuccessMessage("");
            setErrorMessage("");

            showActionFeedback(
                "Shipment cloned successfully. Cargo details cleared. You can now save it as a new shipment.",
                "success"
            );
        } catch (error) {
            console.error("Clone shipment error:", error?.response?.data || error);
            showActionFeedback("Clone shipment failed.", "error");
        } finally {
            setLoading(false);
        }
    };
    const handleOpenConnectOmbl = async () => {
        if (linkedOmbl) {
            showActionFeedback(`This HBL is already connected to ${linkedOmblLabel}.`, "warning");
            return;
        }

        setConnectOmblOpen(true);

        showActionFeedback(
            "Connect OMBL popup opened. Please select New OMBL or Existing OMBL.",
            "info"
        );
    };

    const handleNewOmbl = async () => {
        // Without a saved shipment id the OMBL would hold an unlinked copy of the shipment.
        if (!shipmentId) {
            setErrorMessage("Please save the shipment before connecting to a new OMBL.");
            return;
        }

        try {
            const shipmentPayload = buildShipmentPayload();

            const currentShipment = {
                id: shipmentId || "",
                attributes: {
                    ...shipmentPayload,

                    // Actual party fields
                    shipper: shipmentPayload.shipper || shipper || "",
                    consignee: shipmentPayload.consignee || consignee || "",

                    // POL / POD fields
                    vesselPol: shipmentPayload.vesselPol || vesselPol || { country: "", port: "" },
                    vesselPod: shipmentPayload.vesselPod || vesselPod || { country: "", port: "" },

                    // fallback address fields
                    pickupAddress1,
                    pickupAddress2,
                    deliveryAddress1,
                    deliveryAddress2,

                    shipmentNo,
                    cargoDetails,
                    sealNumber:
                        sealNumber ||
                        cargoDetails.find((cargo) => cargo?.sealNumber)?.sealNumber ||
                        "",
                },
            };

            navigate("/ocean-shipping-order/connect-ombl", {
                state: {
                    selectedShipments: [currentShipment],
                },
            });
        } catch (error) {
            console.error("Connect OMBL error:", error);
        }
    };
    const handleLoadExistingOmbls = async () => {
        try {
            setOmblLoading(true);
            const res = await CrudService.getOMBLs();

            const list = Array.isArray(res?.data)
                ? res.data
                : Array.isArray(res?.data?.data)
                    ? res.data.data
                    : Array.isArray(res?.data?.data?.data)
                        ? res.data.data.data
                        : [];

            setExistingOmbls(list);
        } catch (error) {
            console.error("getOMBLs error:", error);
            setExistingOmbls([]);
        } finally {
            setOmblLoading(false);
        }
    };

    const handleSelectExistingOmbl = async (omblId) => {
        try {
            if (!shipmentId) {
                setErrorMessage("Please save the shipment before connecting to an existing OMBL.");
                return;
            }

            setOmblLoading(true);

            const selectedOmbl = existingOmbls.find(
                (ombl) => String(ombl.id) === String(omblId)
            );

            if (!selectedOmbl) {
                setErrorMessage("Selected OMBL could not be found.");
                return;
            }

            const attr = selectedOmbl.attributes || {};
            const currentShipments = attr.shipments || attr.shipmentDetails || [];

            // The saved entry's own `id` is the shipment id; its attributes snapshot may have
            // none (OMBLs opened with "New OMBL"), which let the same shipment be added twice.
            const alreadyConnected = currentShipments.some((item) =>
                [item?.id, item?._id, item?.attributes?.id, item?.attributes?._id].some(
                    (value) => value && String(value) === String(shipmentId)
                )
            );

            if (alreadyConnected) {
                setSuccessMessage("This shipment is already connected to selected OMBL.");
                setConnectOmblOpen(false);
                return;
            }

            // Same-route rule: this shipment's POL/POD must match the shipments already
            // on the OMBL (the backend enforces it as well when the OMBL is saved).
            const routeConflict = currentShipments
                .map((item) => item?.attributes || item)
                .find((row) => row?.vesselPol || row?.vesselPod
                    ? !sameRoute(row, { vesselPol, vesselPod })
                    : false);

            if (routeConflict) {
                setErrorMessage(
                    `This shipment (${describeRoute({ vesselPol, vesselPod })}) cannot join ${
                        attr.omblNumber || "this OMBL"
                    }: its shipments sail ${describeRoute(routeConflict)}. Only shipments with the same POL and POD can share an OMBL.`
                );
                return;
            }

            const newShipment = {
                id: shipmentId,
                attributes: {
                    id: shipmentId,
                    _id: shipmentId,
                    vesselPol,
                    vesselPod,
                    shipmentNo,
                    customer: selectedCustomer?.name || "",
                    cargoDetails,
                    sealNumber:
                        sealNumber ||
                        cargoDetails.find((cargo) => cargo?.sealNumber)?.sealNumber ||
                        "",
                    pickupLocation,
                    deliveryLocation,
                    pickupDate,
                    pickupTime,
                    estimatedDeliveryDate,
                    estimatedDeliveryTime,
                    actualDeparture,
                    actualDepartureTime,
                    sellingRate,
                    sellingRateCurrency,
                    buyingRate,
                    buyingRateCurrency,
                    pickupRate,
                    pickupRateCurrency,
                    deliveryRate,
                    deliveryRateCurrency,
                    exportCustomsRate,
                    exportCustomsRateCurrency,
                    importCustomsRate,
                    importCustomsRateCurrency,
                    oceanTransportType: selectedOceanTransportSubOption?.label || "",
                    totals: {
                        totalCbm: cargoDetails.reduce((sum, c) => sum + Number(c.cbm || 0), 0),
                        totalGrossWeight: cargoDetails.reduce((sum, c) => sum + Number(c.grossWeight || 0), 0),
                        totalUnit: cargoDetails.reduce((sum, c) => sum + Number(c.unitQuantity || 0), 0),
                    },
                },
            };

            const updatedShipments = [...currentShipments, newShipment];

            const payload = {
                ...attr,
                shipments: updatedShipments,
                shipmentDetails: updatedShipments,
                cargoDetails: getCleanCargoDetailsForPayload()
            };

            const formData = new FormData();
            formData.append("data", JSON.stringify(payload));

            await CrudService.updateOMBL(formData, omblId);

            setConnectOmblOpen(false);

            showActionFeedback(
                "Shipment connected to existing OMBL successfully. Redirecting to OMBL page.",
                "success"
            );

            navigate(`/ocean-shipping-order/connect-ombl?id=${omblId}`);

        } catch (error) {
            console.error("Connect existing OMBL error:", error?.response?.data || error);
            showActionFeedback(
                error?.response?.data?.errors?.[0]?.detail ||
                "Shipment could not be connected to selected OMBL.",
                "error"
            );
        } finally {
            setOmblLoading(false);
        }
    };
    const removeCargoDetail = (index) => {
        const updatedCargoDetails = [...cargoDetails];
        updatedCargoDetails.splice(index, 1); // Belirli index'teki öğeyi kaldır
        setCargoDetails(updatedCargoDetails); // cargoDetails'i güncelle
    };

    const renderPackingTypeSelect = (label, options, value, onChange, { required = false, tooltip = "" } = {}) => (
        <TextField
            select
            label={label}
            value={value || ""}
            onChange={(e) => onChange(e.target.value)}
            fullWidth
            variant="outlined"
            InputLabelProps={{
                shrink: true,
                component: required
                    ? LabelWithTooltip({
                        label,
                        tooltip,
                    })
                    : undefined,
            }}
        >
            {options.map((option) => (
                <MenuItem key={option.label} value={option.label}>
                    {option.label}
                </MenuItem>
            ))}
        </TextField>
    );


    useEffect(() => {
        setWeek(calculateWeekNumber());
    }, [pickupDate]);

    useEffect(() => {
        setTransitTime(calculateTransitTime());
    }, [pickupDate, estimatedDeliveryDate]);

    useEffect(() => {
        // Eğer shipmentData ve carbonFootprint varsa plannedRouteCountries'yi günceller
        if (shipmentData && shipmentData.carbonFootprint) {
            setSelectedCountries(
                shipmentData.carbonFootprint.plannedRouteCountries || [],
            );
        }
    }, [shipmentData]); // shipmentData değiştiğinde çalışır


    // useEffect ile quoteNo verilerini çekiyoruz
    useEffect(() => {
        const loadQuoteNumbers = async () => {
            try {
                const response = await CrudService.getQuotingTools();
                const quoteNumbers = response.data.map((item) => ({
                    label: item.attributes.quoteNo, // Dropdown'da görünen metin
                    sallingRate: item.attributes.sallingRate, // Ek bilgi
                    currency: item.attributes.currency, // Ek bilgi
                }));
                setQuoteNoList(quoteNumbers); // Tüm bilgileri kaydet
            } catch (error) {
                console.error("Error fetching quote numbers:", error);
            }
        };

        loadQuoteNumbers();
    }, []);

    const handleQuoteNoChange = (newValue) => {
        setSelectedQuoteNo(newValue);
        if (newValue) {
            setSallingRate(newValue.sallingRate || "");
            setCurrency(newValue.currency || "");
            setQuoteNo(newValue.label || "");
        } else {
            setSallingRate("");
            setCurrency("");
            setQuoteNo("");
        }
    };

    useEffect(() => {
        if (selectedCustomer) {
            setBillTo(selectedCustomer.name || ""); // Müşteri adı "Bill To" alanına aktarılır
        }
    }, [selectedCustomer]); // selectedCustomer değiştiğinde çalışır

    const handleSwitchChange = () => {
        setIsADR(!isADR); // ADR/DG anahtarını değiştir
        if (isADR) {
            setImco(null);
        }
    };

    const handleIMCOChange = (event, newValue) => {setImco(newValue ? newValue.label : null); };

    useEffect(() => {
        const fetchServiceProviders = async () => {
            try {
                const response = await CrudService.getServiceProviders();

                const options = (response.data || []).map((sp) => ({
                    id: sp.id || sp._id,
                    ...(sp.attributes || sp),
                    type: "serviceProvider",
                }));

                setServiceProviders(options);
            } catch (error) {
                console.error("Service Provider verileri alınırken hata oluştu:", error);
                setServiceProviders([]);
            }
        };

        fetchServiceProviders();
    }, []);



    const TITLE_SX = {
        fontWeight: "bold",
        lineHeight: 1.15,
        height: 48,
        mb: 1,
        display: "-webkit-box",
        WebkitLineClamp: 2,
        WebkitBoxOrient: "vertical",
        overflow: "hidden",
        textOverflow: "ellipsis",
        textAlign: "center",
    };

    const DROPZONE_WRAPPER_SX = {
        width: "100%",
        maxWidth: "90px",
        height: "150px",
        overflow: "hidden",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    };

    const DZ_STYLE = {
        height: "80px",
        minHeight: "80px",
        maxHeight: "80px",
        fontSize: "8px",
        overflow: "hidden"
    };
    const normalizeTextInput = (value = "") => {
        const map = {ç: "c", ğ: "g", ı: "i", ö: "o", ş: "s", ü: "u", Ç: "C", Ğ: "G", İ: "I", Ö: "O", Ş: "S", Ü: "U",};
        return value
            .split("")
            .map((char) => map[char] || char)
            .join("")
            .toUpperCase();
    };

    useEffect(() => {
        if (!shipmentData || countryOptions.length === 0) return;
        const foundPickupCountry = countryOptions.find(
            (option) =>
                option.label === shipmentData.pickupLocation?.country ||
                option.code === shipmentData.pickupLocation?.country
        );
        const foundDeliveryCountry = countryOptions.find(
            (option) =>
                option.label === shipmentData.deliveryLocation?.country ||
                option.code === shipmentData.deliveryLocation?.country
        );
        const foundExportCountry = countryOptions.find(
            (option) =>
                option.label === shipmentData.exportLocation?.country ||
                option.code === shipmentData.exportLocation?.country
        );
        setSelectedCountry(foundPickupCountry || null);
        setSelectedDeliveryCountry(foundDeliveryCountry || null);
        setSelectedExportCountry(foundExportCountry || null);
    }, [shipmentData, countryOptions]);

    useEffect(() => {
        if (location.state?.mblCustomer) {
            const mblName = location.state.mblCustomer;

            const matchedCustomer = customerOptions.find(
                (opt) =>
                    opt.name?.trim().toLowerCase() === mblName.trim().toLowerCase()
            );
            setSelectedCustomer(matchedCustomer || { name: mblName });
        }
    }, [location.state, customerOptions]);

    const inputStyle = {
        "& .MuiInputBase-root": { height: 40 },
        "& .MuiOutlinedInput-input": { padding: "0 14px" },
        "& .MuiInputLabel-root": { fontSize: 14 },
    };

    const COMMON_INPUT_SX = {
        "& .MuiOutlinedInput-root": {
            height: 40,
        },
        "& .MuiInputBase-input": {
            padding: "8.5px 14px",
        },
    };

    const PRICING_INPUT_SX = {
        "& .MuiOutlinedInput-root": {
            height: 60,
            minHeight: 60,
            display: "flex",
            alignItems: "center",
        },
        "& .MuiInputBase-input": {
            height: "60px",
            boxSizing: "border-box",
            padding: "0 14px",
            display: "flex",
            alignItems: "center",
        },
        "& .MuiSelect-select": {
            height: "60px",
            boxSizing: "border-box",
            display: "flex",
            alignItems: "center",
            padding: "0 14px !important",
        },
    };

    const dialogPaperSx = {
        borderRadius: "20px",
        overflow: "hidden",
        boxShadow: "0 20px 60px rgba(0,0,0,0.18)",
        border: "1px solid rgba(25,118,210,0.12)",
    };

    const selectionCardSx = (active) => ({
        borderRadius: "18px",
        p: 2.25,
        cursor: "pointer",
        border: active ? "2px solid #1976d2" : "1px solid #e5e7eb",
        background: active
            ? "linear-gradient(135deg, rgba(25,118,210,0.10), rgba(25,118,210,0.03))"
            : "#fff",
        boxShadow: active
            ? "0 12px 30px rgba(25,118,210,0.18)"
            : "0 6px 18px rgba(15,23,42,0.06)",
        transition: "all 0.25s ease",
        minHeight: 150,
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        "&:hover": {
            transform: "translateY(-2px)",
            boxShadow: active
                ? "0 14px 34px rgba(25,118,210,0.22)"
                : "0 10px 24px rgba(15,23,42,0.10)",
        },
    });

    const readPdfSourceAsArrayBuffer = async (source) => {
        if (!source) {
            throw new Error("PDF source not found");
        }

        if (typeof source === "string") {
            const response = await fetch(source);
            if (!response.ok) {
                throw new Error(`PDF alınamadı: ${source}`);
            }
            return await response.arrayBuffer();
        }

        if (source instanceof File || source instanceof Blob) {
            return await source.arrayBuffer();
        }

        throw new Error("Unsupported PDF source type");
    };
    const createMergedFilledPdf = async (selectedType, texts) => {
        const frontPdfUrl = isDirectBL
            ? DIRECT_BL_FRONT_PDF
            : selectedType === "original" ? ORIGINAL_FRONT_PDF : SEAWAYBILL_FRONT_PDF;

        const backPdfUrl =
            selectedType === "original" ? ORIGINAL_BACK_PDF : SEAWAYBILL_BACK_PDF;

        const filledFrontBytes = await generateFilledFrontPdfBytes(frontPdfUrl, texts);

        const mergedPdf = await PDFDocument.create();

        const filledFrontDoc = await PDFDocument.load(filledFrontBytes);
        const filledFrontPages = await mergedPdf.copyPages(
            filledFrontDoc,
            filledFrontDoc.getPageIndices()
        );
        filledFrontPages.forEach((page) => mergedPdf.addPage(page));

        const backArrayBuffer = await readPdfSourceAsArrayBuffer(backPdfUrl);
        const backPdfDoc = await PDFDocument.load(backArrayBuffer);
        const backPages = await mergedPdf.copyPages(
            backPdfDoc,
            backPdfDoc.getPageIndices()
        );
        backPages.forEach((page) => mergedPdf.addPage(page));

        const mergedPdfBytes = await mergedPdf.save();
        const blob = new Blob([mergedPdfBytes], { type: "application/pdf" });

        return URL.createObjectURL(blob);
    };

    const handleOpenPrintDialog = () => {
        setPrintDialogOpen(true);
    };

    const handleClosePrintDialog = () => {
        setPrintDialogOpen(false);
    };

    const handlePreviewMergedPdf = async () => {
        try {
            setLoading(true);

            if (previewMergedPdfUrl) {
                URL.revokeObjectURL(previewMergedPdfUrl);
            }

            const texts = await buildBlPrintTexts();
            const mergedUrl = await createMergedFilledPdf(selectedPrintType, texts);

            setBlTexts(texts);
            setBlTextsDirty(false);
            setPreviewMergedPdfUrl(mergedUrl);
            setPrintDialogOpen(false);
            setPreviewDialogOpen(true);
        } catch (error) {
            console.error("PDF birleştirme hatası:", error);
            setSnackbar({
                open: true,
                severity: "error",
                message: "Merged PDF oluşturulamadı.",
            });
        } finally {
            setLoading(false);
        }
    };
    // Prints the corrected texts again into the preview.
    const handleApplyBlTexts = async () => {
        try {
            setLoading(true);
            const mergedUrl = await createMergedFilledPdf(selectedPrintType, blTexts);
            if (previewMergedPdfUrl) URL.revokeObjectURL(previewMergedPdfUrl);
            setPreviewMergedPdfUrl(mergedUrl);
            setBlTextsDirty(false);
        } catch (error) {
            console.error("PDF güncelleme hatası:", error);
            setSnackbar({ open: true, severity: "error", message: "Preview could not be updated." });
        } finally {
            setLoading(false);
        }
    };

    const handleClosePreviewDialog = () => {
        setPreviewDialogOpen(false);
        setBlTexts(null);
        setBlTextsDirty(false);

        if (previewMergedPdfUrl) {
            URL.revokeObjectURL(previewMergedPdfUrl);
            setPreviewMergedPdfUrl("");
        }
    };

    const handleDownloadMergedPdf = async () => {
        try {
            setLoading(true);

            const mergedUrl = await createMergedFilledPdf(selectedPrintType, blTexts || (await buildBlPrintTexts()));

            const link = document.createElement("a");
            link.href = mergedUrl;
            link.download =
                selectedPrintType === "original"
                    ? isCopyPrint() ? "copy-filled.pdf" : "original-filled.pdf"
                    : "seawaybill-filled.pdf";

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            URL.revokeObjectURL(mergedUrl);
        } catch (error) {
            console.error("Tek PDF indirme hatası:", error);
            setSnackbar({
                open: true,
                severity: "error",
                message: "PDF indirilemedi.",
            });
        } finally {
            setLoading(false);
        }
    };
    const buildPdfFieldData = () => {
        const placeOfReceipt =
            [pickupAddress1?.city || pickupAddress2?.city, pickupAddress1?.country || pickupAddress2?.country]
                .filter(Boolean)
                .join(", ");

        const placeOfDelivery =
            [deliveryAddress2?.city || deliveryAddress1?.city, deliveryAddress2?.country || deliveryAddress1?.country]
                .filter(Boolean)
                .join(", ");

        const pol = [vesselPol?.port, vesselPol?.country].filter(Boolean).join(", ");
        const pod = [vesselPod?.port, vesselPod?.country].filter(Boolean).join(", ");

        return {
            shipmentNo: shipmentNo ? `OHFL${shipmentNo}` : "",
            consignor: shipper || "",
            consignee: consignee || "",
            notify: consignee || "",
            placeOfReceipt,
            placeOfDelivery,
            pol,
            pod,
            vesselName: vesselName || "",
            utikadNumber: utikadNumber || "",
        };
    };

    const drawTextSafe = (page, text, x, y, options = {}) => {
        if (text === null || text === undefined || text === "") return;

        const safeText = normalizeTextInput(String(text));

        page.drawText(safeText, {
            x,
            y,
            size: options.size || 9,
            font: options.font,
            color: options.color || rgb(0, 0, 0),
            maxWidth: options.maxWidth,
            lineHeight: options.lineHeight || 10,
        });
    };

    // Helvetica cap height / descender as a share of the font size.
    const PDF_CAP_HEIGHT = 0.72;
    const PDF_DESCENT = 0.21;

    // Word-wraps text to maxWidth (explicit "\n" kept, over-long words split by character).
    const wrapPdfText = (text, font, size, maxWidth) => {
        const lines = [];
        const fits = (value) => font.widthOfTextAtSize(value, size) <= maxWidth;

        String(text).split("\n").forEach((paragraph) => {
            let line = "";
            paragraph.split(/\s+/).filter(Boolean).forEach((word) => {
                const candidate = line ? `${line} ${word}` : word;
                if (fits(candidate)) {
                    line = candidate;
                    return;
                }
                if (line) lines.push(line);
                line = "";
                let rest = word;
                while (!fits(rest) && rest.length > 1) {
                    let cut = rest.length - 1;
                    while (cut > 1 && !fits(rest.slice(0, cut))) cut -= 1;
                    lines.push(rest.slice(0, cut));
                    rest = rest.slice(cut);
                }
                line = rest;
            });
            lines.push(line);
        });

        return lines;
    };

    const pdfTextHeight = (lineCount, size, lineHeight) =>
        (lineCount - 1) * lineHeight + size * (PDF_CAP_HEIGHT + PDF_DESCENT);

    // Draws text inside a cell: `top` is where the first line's capitals start (just under
    // the printed label), `bottom` the lowest point the text may reach (just above the ruling
    // line). Long values wrap and the font shrinks until the whole value fits; lines are only
    // dropped if it would need a font smaller than 3 pt.
    const drawFittedField = (page, text, field, font) => {
        if (text === null || text === undefined || text === "") return;

        const safeText = normalizeTextInput(String(text));
        const available = field.top - field.bottom;
        const minSize = 3;
        let size = field.size;
        let lines = wrapPdfText(safeText, font, size, field.maxWidth);

        while (size > minSize && pdfTextHeight(lines.length, size, size * 1.15) > available) {
            size = Math.max(minSize, size - 0.25);
            lines = wrapPdfText(safeText, font, size, field.maxWidth);
        }

        const lineHeight = size * 1.15;
        const maxLines = Math.max(1, Math.floor((available - size * (PDF_CAP_HEIGHT + PDF_DESCENT)) / lineHeight) + 1);
        if (lines.length > maxLines) {
            lines = lines.slice(0, maxLines);
        }

        const firstBaseline = field.top - size * PDF_CAP_HEIGHT;
        lines.forEach((line, index) => {
            page.drawText(line, {
                x: field.x,
                y: firstBaseline - index * lineHeight,
                size,
                font,
                color: field.color || rgb(0, 0, 0),
            });
        });
    };

    const getPdfLayoutByType = (printType) => {
        // Direct BL: plain Filenders MBL form (DIRECT_BL_FRONT_PDF).
        if (isDirectBL) {
            return {
                topRightNumber: {
                    rect: { x: 482, y: 771, width: 81, height: 17, color: rgb(1, 1, 1) },
                    text: { x: 495, y: 775, size: 12, maxWidth: 55, color: rgb(1, 0, 0) },
                },

                // Party boxes fitted between the labels and the ruling lines (address, contact and tax lines).
                ...FILENDERS_MBL_PARTY_CELLS,

                // Below each label of this form, so values don't overlap the printed captions.
                placeOfReceipt: { x: 147, y: 579, size: 7, maxWidth: 145, lineHeight: 9 },
                vesselName: { x: 27, y: 550, size: 7, maxWidth: 115, lineHeight: 9 },
                pol: { x: 147, y: 550, size: 7, maxWidth: 145, lineHeight: 9 },
                pod: { x: 27, y: 521, size: 7, maxWidth: 115, lineHeight: 9 },
                placeOfDelivery: { x: 147, y: 521, size: 7, maxWidth: 145, lineHeight: 9 },
                // Under the "Place and date of issue" / "Freight payable at" labels of this form.
                estimatedDeparture: { x: 392, y: 130, size: 7, maxWidth: 170, lineHeight: 9 },
                freightStatus: { x: 246, y: 130, size: 7, maxWidth: 135, lineHeight: 9 },

                cargo: {
                    startY: 490,
                    rowHeight: 18,
                    xOffset: 50,
                    // Cargo box ends at "according to the declaration of the consignor" (~y 307).
                    minY: 315,
                    marksAndNumbers: { x: 5, size: 9, maxWidth: 70, lineHeight: 10 },
                    packages: { x: 130, size: 9, maxWidth: 110, lineHeight: 10 },
                    description: { x: 275, size: 9, maxWidth: 140, lineHeight: 10 },
                    grossWeight: { x: 425, size: 9, maxWidth: 55, lineHeight: 10 },
                    measurement: { x: 480, size: 9, maxWidth: 55, lineHeight: 10 },
                },
            };
        }

        // FBL / FWB: cells measured on the scanned templates. Each field starts just under
        // its printed label (`top`) and stays above the next ruling line (`bottom`); the
        // left column ends before the middle labels, the middle one before the divider.
        if (printType === "seawaybill") {
            return {
                // Number box inside x 437.3–569.5, y 793.5–812.75; the number is centred in it.
                topRightNumber: {
                    rect: { x: 438, y: 794.2, width: 131, height: 18, color: rgb(1, 1, 1) },
                    text: { size: 12, color: rgb(1, 0, 0) },
                },

                consignor: { x: 70, top: 804.5, bottom: 743.25, size: 9, maxWidth: 240 },
                consignee: { x: 70, top: 729.5, bottom: 671, size: 9, maxWidth: 240 },
                notify: { x: 70, top: 657.5, bottom: 600, size: 9, maxWidth: 240 },

                placeOfReceipt: { x: 176, top: 586.5, bottom: 576.5, size: 7, maxWidth: 134 },
                vesselName: { x: 57, top: 564.5, bottom: 553, size: 7, maxWidth: 112 },
                pol: { x: 176, top: 563, bottom: 553, size: 7, maxWidth: 134 },
                pod: { x: 57, top: 539.5, bottom: 529.25, size: 7, maxWidth: 112 },
                placeOfDelivery: { x: 176, top: 539, bottom: 529.25, size: 7, maxWidth: 134 },
                estimatedDeparture: { x: 384, top: 107.5, bottom: 95.5, size: 7, maxWidth: 180 },
                freightStatus: { x: 257, top: 107.5, bottom: 95.5, size: 7, maxWidth: 117 },

                // Header labels end at y 516.75; "according to the declaration..." starts at 261.
                cargo: {
                    startY: 506,
                    rowHeight: 18,
                    xOffset: 0,
                    minY: 266,
                    marksAndNumbers: { x: 55, size: 9, maxWidth: 112, lineHeight: 10 },
                    packages: { x: 174, size: 9, maxWidth: 145, lineHeight: 10 },
                    description: { x: 327, size: 9, maxWidth: 115, lineHeight: 10 },
                    grossWeight: { x: 449, size: 9, maxWidth: 75, lineHeight: 10 },
                    measurement: { x: 528, size: 9, maxWidth: 50, lineHeight: 10 },
                },
            };
        }

        return {
            // Number box inside x 438.3–551.5, y 800.25–818.5 (the "TR" box starts at 552).
            topRightNumber: {
                rect: {
                    x: 439,
                    y: 801,
                    width: 112,
                    height: 17,
                    color: rgb(0.8627, 0.9804, 0.9961), // current original
                },
                text: { size: 12, color: rgb(1, 0, 0) },
            },

            consignor: { x: 70, top: 812, bottom: 746.5, size: 9, maxWidth: 245 },
            consignee: { x: 70, top: 730, bottom: 674.5, size: 9, maxWidth: 245 },
            notify: { x: 70, top: 660, bottom: 605, size: 9, maxWidth: 245 },

            placeOfReceipt: { x: 198, top: 590.5, bottom: 580.5, size: 7, maxWidth: 118 },
            pol: { x: 198, top: 565.5, bottom: 557.25, size: 7, maxWidth: 118 },
            pod: { x: 61, top: 541.5, bottom: 534.25, size: 7, maxWidth: 130 },
            placeOfDelivery: { x: 198, top: 541.5, bottom: 534.25, size: 7, maxWidth: 118 },
            vesselName: { x: 61, top: 567, bottom: 557.25, size: 7, maxWidth: 130 },
            estimatedDeparture: { x: 390, top: 115.25, bottom: 104.5, size: 7, maxWidth: 190 },
            freightStatus: { x: 263, top: 115.25, bottom: 104.5, size: 7, maxWidth: 118 },

            // Header labels end at y 519.5; "according to the declaration..." starts at 271.5.
            cargo: {
                startY: 508.5,
                rowHeight: 18,
                xOffset: 0,
                minY: 276,
                marksAndNumbers: { x: 60, size: 9, maxWidth: 112, lineHeight: 10 },
                packages: { x: 181, size: 9, maxWidth: 145, lineHeight: 10 },
                description: { x: 333, size: 9, maxWidth: 115, lineHeight: 10 },
                grossWeight: { x: 455, size: 9, maxWidth: 70, lineHeight: 10 },
                measurement: { x: 531, size: 9, maxWidth: 55, lineHeight: 10 },
            },
        };
    };

    const drawField = (page, text, layoutField, font) => {
        if (!layoutField) return;

        if (layoutField.top !== undefined) {
            drawFittedField(page, text, layoutField, font);
            return;
        }

        drawTextSafe(page, text, layoutField.x, layoutField.y, {
            font,
            size: layoutField.size,
            maxWidth: layoutField.maxWidth,
            lineHeight: layoutField.lineHeight,
            color: layoutField.color,
        });
    };

    // A copy is asked for the original FBL only (the blue form with "ORIGINAL" on it).
    const isCopyPrint = () => blCopy && selectedPrintType === "original" && !isDirectBL;

    // What the B/L prints, before any correction in the preview: the number, the party boxes
    // with their address lines, the route, the footer and the cargo lines.
    const buildBlPrintTexts = async () => {
        const fieldData = buildPdfFieldData();
        const addressBook = await fetchPartyAddressBook().catch(() => null);

        // Direct BL: seal numbers typed on the DBL record for containers that have none here.
        const normalizeContainerNo = (value) => String(value || "").replace(/[^A-Z0-9]/gi, "").toUpperCase();
        const dblSeals = new Map();
        if (isDirectBL && dmblId) {
            const res = await CrudService.getOMBLById(dmblId).catch(() => null);
            const dbl = res?.data?.data?.attributes || res?.data?.attributes || {};
            [...(dbl.manualSealNumbers || []), ...(dbl.manualCarrierReferences || [])].forEach((item) => {
                const containerNo = normalizeContainerNo(item?.containerNumber);
                if (item?.sealNumber && !dblSeals.has(containerNo)) {
                    dblSeals.set(containerNo, item.sealNumber);
                }
            });
        }

        const hasCargo = cargoDetails.length > 0;
        return {
            number: fieldData.utikadNumber || "",
            blNumber: fieldData.utikadNumber || fieldData.shipmentNo,
            consignor: withBillingAddress(fieldData.consignor, addressBook) || "",
            consignee: withBillingAddress(fieldData.consignee, addressBook) || "",
            notify: withBillingAddress(fieldData.notify, addressBook) || "",
            placeOfReceipt: fieldData.placeOfReceipt,
            vesselName: fieldData.vesselName,
            pol: fieldData.pol,
            pod: fieldData.pod,
            placeOfDelivery: fieldData.placeOfDelivery,
            departure: hasCargo && dayjs(estimatedDeparture).isValid() ? dayjs(estimatedDeparture).format("DD.MM.YYYY") : "",
            freight: hasCargo ? freightStatus || "" : "",
            // Carrier-style cargo block: one line per container, totals under Gross weight /
            // Measurement.
            cargo: buildBlCargoContent(cargoDetails, {
                sealFor: (container) => dblSeals.get(normalizeContainerNo(container.containerNo)) || "",
            }),
        };
    };

    const generateFilledFrontPdfBytes = async (frontPdfUrl, texts) => {
        const t = texts || (await buildBlPrintTexts());
        const layout = getPdfLayoutByType(selectedPrintType);
        const copy = isCopyPrint();

        const arrayBuffer = await readPdfSourceAsArrayBuffer(frontPdfUrl);
        const pdfDoc = await PDFDocument.load(arrayBuffer);
        const font = await pdfDoc.embedFont(StandardFonts.Helvetica);
        const page = pdfDoc.getPage(0);

        // Copy: "COPY" in place of the white "ORIGINAL" (under the cargo text drawn later).
        if (copy) await drawCopyMark(pdfDoc, page);

        // Top-right number rectangle
        page.drawRectangle({
            x: layout.topRightNumber.rect.x,
            y: layout.topRightNumber.rect.y,
            width: layout.topRightNumber.rect.width,
            height: layout.topRightNumber.rect.height,
            color: layout.topRightNumber.rect.color,
            borderWidth: 0,
        });

        // Top-right number text: at a fixed point, or centred in the box when no x/y is set.
        const numberText = layout.topRightNumber.text;
        if (numberText.x !== undefined) {
            drawTextSafe(page, t.number, numberText.x, numberText.y, {
                font,
                size: numberText.size,
                maxWidth: numberText.maxWidth,
                lineHeight: 10,
                color: numberText.color,
            });
        } else if (t.number) {
            const box = layout.topRightNumber.rect;
            const number = normalizeTextInput(String(t.number));
            let size = numberText.size;
            while (size > 6 && font.widthOfTextAtSize(number, size) > box.width - 6) size -= 0.5;
            page.drawText(number, {
                x: box.x + (box.width - font.widthOfTextAtSize(number, size)) / 2,
                y: box.y + (box.height - size * PDF_CAP_HEIGHT) / 2,
                size,
                font,
                color: numberText.color,
            });
        }

        // Header fields
        // Shipper / consignee / notify boxes: name plus the billing address on its card.
        drawField(page, t.consignor, layout.consignor, font);
        drawField(page, t.consignee, layout.consignee, font);
        drawField(page, t.notify, layout.notify, font);

        // Route cells at one common size, one line each (a long port name used to shrink or
        // wrap on its own).
        drawRouteFields({ page, font, layout, fieldData: t, normalize: normalizeTextInput });

        // Cargo lines; overflow continues on attached sheets.
        await drawBlCargo({
            pdfDoc,
            page,
            // Direct BL prints on the Filenders MBL form; HBLs on the FBL / FWB templates.
            area: blCargoArea(layout.cargo, isDirectBL ? FILENDERS_MBL_CARGO_AREA : {}),
            content: t.cargo,
            blNumber: t.blNumber,
            normalize: normalizeTextInput,
            // Attached sheets: the form's background without its tables, only the cargo on it.
            background: await loadSheetBackground(frontPdfUrl),
            markSheet: copy ? (sheet) => drawCopyMark(pdfDoc, sheet, FBL_SHEET_TINT) : null,
        });

        drawField(page, t.departure, layout.estimatedDeparture, font);
        drawField(page, t.freight, layout.freightStatus, font);
        return await pdfDoc.save();
    };

    const PICKUP_FULL_ADDRESS_KEY = "ocean_pickup_full_addresses_v1";
    const EMPTY_RELEASE_FULL_ADDRESS_KEY = "ocean_empty_release_full_addresses_v1";

    const readSavedAddressOptions = (key) => {
        try {
            const saved = localStorage.getItem(key);
            const parsed = saved ? JSON.parse(saved) : [];

            return parsed.map((item) =>
                typeof item === "string"
                    ? {
                        id: crypto.randomUUID(),
                        name: item,
                        address: item,
                    }
                    : item
            );
        } catch {
            return [];
        }
    };

    const [pickupFullAddressOptions, setPickupFullAddressOptions] = useState(() =>
        readSavedAddressOptions(PICKUP_FULL_ADDRESS_KEY)
    );

    const [emptyReleaseFullAddressOptions, setEmptyReleaseFullAddressOptions] = useState(() =>
        readSavedAddressOptions(EMPTY_RELEASE_FULL_ADDRESS_KEY)
    );

    const [addressModalOpen, setAddressModalOpen] = useState(false);
    const [addressModalType, setAddressModalType] = useState("pickup"); // pickup | container
    const [editingAddressId, setEditingAddressId] = useState(null);
    const [addressForm, setAddressForm] = useState({
        name: "",
        address: "",
    });

    const getAddressConfig = (type = addressModalType) => {
        if (type === "pickup") {
            return {
                key: PICKUP_FULL_ADDRESS_KEY,
                options: pickupFullAddressOptions,
                setter: setPickupFullAddressOptions,
                title: "Pickup Full Address",
            };
        }

        return {
            key: EMPTY_RELEASE_FULL_ADDRESS_KEY,
            options: emptyReleaseFullAddressOptions,
            setter: setEmptyReleaseFullAddressOptions,
            title: "Empty Release Container Full Address",
        };
    };

    const openAddressModal = (type, item = null) => {
        setAddressModalType(type);
        setEditingAddressId(item?.id || null);
        setAddressForm({
            name: item?.name || "",
            address: item?.address || "",
        });
        setAddressModalOpen(true);
    };

    const closeAddressModal = () => {
        setAddressModalOpen(false);
        setEditingAddressId(null);
        setAddressForm({ name: "", address: "" });
    };

    const saveAddressFromModal = () => {
        const name = addressForm.name.trim();
        const address = addressForm.address.trim();

        if (!name || !address) {
            setSnackbar({
                open: true,
                severity: "error",
                message: "Address name and address are required.",
            });
            return;
        }

        const config = getAddressConfig();

        config.setter((prev) => {
            const updated = editingAddressId
                ? prev.map((item) =>
                    item.id === editingAddressId ? { ...item, name, address } : item
                )
                : [...prev, { id: crypto.randomUUID(), name, address }];

            localStorage.setItem(config.key, JSON.stringify(updated));
            return updated;
        });

        setSnackbar({
            open: true,
            severity: "success",
            message: editingAddressId ? "Address updated." : "Address saved.",
        });

        closeAddressModal();
    };

    const deleteAddressOption = (type, id) => {
        const config = getAddressConfig(type);

        config.setter((prev) => {
            const updated = prev.filter((item) => item.id !== id);
            localStorage.setItem(config.key, JSON.stringify(updated));
            return updated;
        });

        setSnackbar({
            open: true,
            severity: "success",
            message: "Address deleted.",
        });
    };


    const dmblSelectedShipments = useMemo(() => {
        if (!isDirectBL || !dblShipmentId) return [];

        return [
            {
                id: dblShipmentId,
                attributes: {
                    ...buildShipmentPayload(),
                    id: dblShipmentId,
                    _id: dblShipmentId,
                    shipmentNo,
                    billOfLadingType: "DIRECT_BL",
                    isDirectBL: true,
                    sourceType: "DBL",
                },
            },
        ];
    }, [
        isDirectBL,
        dblShipmentId,
        shipmentNo,
        billOfLadingType,
        // Containers / seal numbers typed here must reach the DBL form.
        cargoDetails,
        sealNumber,
    ]);


    return (
        <DashboardLayout>
            <DashboardNavbar/>
            <MDBox mb={1}>
                <Grid container justifyContent="center">
                    <Grid item xs={12} lg={12}>
                        <MDBox mb={2} textAlign="center">
                            <MDBox mb={1} mt={2}>
                                {successMessage && (
                                    <Alert
                                        severity="success"
                                        variant="filled"
                                        onClose={() => setSuccessMessage("")}
                                        style={{
                                            backgroundColor: successMessage ? "#7edd82" : "transparent",
                                            color: successMessage ? "#FFFFFF" : "transparent",
                                            padding: "10px",
                                            textAlign: "center",
                                            marginBottom: "10px",
                                            borderRadius: "5px",
                                            visibility: successMessage ? "visible" : "hidden",
                                        }}
                                    >
                                        {successMessage}
                                    </Alert>
                                )}

                                {errorMessage && (
                                    <Alert
                                        severity="error"
                                        variant="filled"
                                        onClose={() => setErrorMessage("")}
                                        sx={{width: "100%", mt: 2}}
                                    >
                                        {errorMessage}
                                    </Alert>
                                )}
                                <MDTypography variant="h3" fontWeight="bold">
                                    {isEditing
                                        ? " Edit Shipment Details"
                                        : " Add Shipment Details"}
                                </MDTypography>

                            </MDBox>
                            <MDTypography variant="h5" fontWeight="regular" color="secondary">
                                This information will describe more about the shipment.
                            </MDTypography>
                            {effectiveShipmentId && (
                                <MDBox display="flex" justifyContent="center">
                                    <NotificationsLauncher
                                        shipmentId={effectiveShipmentId}
                                        refreshKey={notificationsOpen}
                                        onOpen={() => setNotificationsOpen(true)}
                                    />
                                </MDBox>
                            )}
                            <Drawer
                                anchor="right"
                                open={notificationsOpen && !!effectiveShipmentId}
                                onClose={() => setNotificationsOpen(false)}
                                PaperProps={{ sx: { width: { xs: "100%", md: "min(1200px, 92vw)" }, p: 3, textAlign: "left" } }}
                            >
                                {notificationsOpen && effectiveShipmentId && <ShipmentNotifications shipmentId={effectiveShipmentId} />}
                            </Drawer>
                            <Snackbar
                                open={snackbar.open}
                                autoHideDuration={5000}
                                onClose={() => setSnackbar({...snackbar, open: false})}
                                anchorOrigin={{vertical: "top", horizontal: "right"}}
                                sx={{
                                    mt: 8,
                                    mr: 2,
                                    zIndex: 9999,
                                }}
                            >
                                <Alert
                                    severity={snackbar.severity}
                                    variant="filled"
                                    onClose={() => setSnackbar({...snackbar, open: false})}
                                    sx={{
                                        minWidth: 360,
                                        maxWidth: 520,
                                        fontSize: "15px",
                                        fontWeight: 600,
                                        borderRadius: "12px",
                                        boxShadow: "0 12px 35px rgba(0,0,0,0.25)",
                                        alignItems: "center",
                                        "& .MuiAlert-icon": {
                                            fontSize: "28px",
                                        },
                                        "& .MuiAlert-message": {
                                            padding: "8px 0",
                                        },
                                    }}
                                >
                                    {snackbar.message}
                                </Alert>
                            </Snackbar>
                        </MDBox>
                    </Grid>
                </Grid>
            </MDBox>

            {linkedOmbl && !isDirectBL && (
                <MDBox mb={2}>
                    <MDBox
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        flexWrap="wrap"
                        gap={2}
                        sx={{
                            p: 2,
                            borderRadius: 3,
                            background: "linear-gradient(135deg, #EEF4FF 0%, #E0EAFF 100%)",
                            border: "1px solid #B6CCF5",
                        }}
                    >
                        <MDBox display="flex" alignItems="center" gap={1.5} flexWrap="wrap">
                            <LinkIcon sx={{ color: "#1d4ed8" }} />
                            <MDTypography variant="button" fontWeight="bold" sx={{ color: "#1e3a8a" }}>
                                Connected to {linkedOmblLabel}
                            </MDTypography>
                            {(linkedOmbl.mblNumbers || []).map((mblNo) => (
                                <Chip key={mblNo} size="small" label={`MBL ${mblNo}`} sx={linkedOmblChipSx} />
                            ))}
                            {(linkedOmbl.vesselName || voyageNumber) && (
                                <Chip
                                    size="small"
                                    sx={linkedOmblChipSx}
                                    label={[
                                        linkedOmbl.vesselName && `Vessel ${linkedOmbl.vesselName}`,
                                        voyageNumber && `Voyage ${voyageNumber}`,
                                    ].filter(Boolean).join(" · ")}
                                />
                            )}
                        </MDBox>
                        <Button
                            variant="outlined"
                            size="small"
                            endIcon={<OpenInNewIcon />}
                            onClick={() => navigate(`/ocean-shipping-order/connect-ombl?id=${linkedOmbl.id}`)}
                            sx={{ color: "#1d4ed8 !important", borderColor: "#1d4ed8" }}
                        >
                            Open OMBL
                        </Button>
                    </MDBox>
                </MDBox>
            )}

            {readOnlyMode && (
                <MDBox mb={2}>
                    <Grid container justifyContent="center">
                        <Grid item xs={12} lg={12}>
                            <MDBox
                                display="flex"
                                alignItems="center"
                                justifyContent="space-between"
                                flexWrap="wrap"
                                gap={2}
                                sx={{
                                    p: 2,
                                    borderRadius: 3,
                                    background: "linear-gradient(135deg, #FFF8E1 0%, #FFECB3 100%)",
                                    border: "1px solid #FFD54F",
                                }}
                            >
                                <MDBox display="flex" alignItems="center" gap={1.5}>
                                    <LockOutlinedIcon sx={{ color: "#B8860B" }} />
                                    <MDTypography variant="button" fontWeight="bold" sx={{ color: "#7A5B00" }}>
                                        This shipment is in read-only view. Click Edit to make changes.
                                    </MDTypography>
                                </MDBox>
                                <Button
                                    variant="contained"
                                    startIcon={<EditIcon />}
                                    onClick={() => setReadOnlyMode(false)}
                                    style={{ backgroundColor: "#B8860B", color: "#FFFFFF" }}
                                >
                                    Edit
                                </Button>
                            </MDBox>
                        </Grid>
                    </Grid>
                </MDBox>
            )}

            {shipmentId && (
                <MDBox mb={2} display="flex" justifyContent="flex-end" gap={1} flexWrap="wrap">
                    {/* The form's own Print button sits in the read-only fieldset and cannot be
                        clicked while viewing; printing does not change the shipment. */}
                    {readOnlyMode && (
                        <Button
                            variant="contained"
                            onClick={handleOpenPrintDialog}
                            disabled={loading}
                            sx={{
                                backgroundColor: "#1976d2",
                                color: "#fff",
                                "&:hover": { backgroundColor: "#1565c0" },
                            }}
                        >
                            Print BILL OF LADING
                        </Button>
                    )}
                    <FinanceDetailsButton onClick={() => setFinanceModalOpen(true)} />
                </MDBox>
            )}

            <ShipmentFinanceModal
                open={financeModalOpen}
                onClose={() => setFinanceModalOpen(false)}
                shipmentId={shipmentId}
                shipmentNo={shipmentNo}
                sourceType="ocean"
            />

            <fieldset
                disabled={readOnlyMode}
                style={{
                    border: "none",
                    padding: 0,
                    margin: 0,
                    opacity: readOnlyMode ? 0.65 : 1,
                    // Belt-and-suspenders: fieldset[disabled] only auto-locks
                    // real form controls (input/select/textarea/button). Any
                    // custom div-based widget in this form (drag-drop zones,
                    // custom pickers) would otherwise stay clickable, so also
                    // cut off all pointer interaction while read-only.
                    pointerEvents: readOnlyMode ? "none" : "auto",
                    transition: "opacity .15s ease",
                }}
            >
            <MDBox mb={12}
                   sx={{
                       p: 3,
                       borderRadius: 3,
                       bgcolor: "background.paper",
                       boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                   }}>
                <Grid container justifyContent="center">
                    <Grid item xs={12} lg={12}>
                        <MDBox>
                            <MDBox mt={3}>
                                <Grid container spacing={3} alignItems="center" justifyContent="space-between">
                                    <Grid item xs={12} sm={6}>
                                        <MDTypography variant="h6" component="div">
                                            Shipment Details
                                            <br/>
                                            {shipmentNo ? ` Shipment No: OHFL${shipmentNo}` : ``}
                                        </MDTypography>
                                    </Grid>

                                    <Grid
                                        item
                                        xs={12}
                                        sm={6}
                                        sx={{display: "flex", justifyContent: {xs: "flex-start", sm: "flex-end"}}}
                                    >
                                        <Button
                                            variant="contained"
                                            onClick={handleOpenPrintDialog}
                                            disabled={loading}
                                            sx={{
                                                backgroundColor: "#1976d2",
                                                color: "#fff",
                                                "&:hover": {
                                                    backgroundColor: "#1565c0",
                                                },
                                                "&.Mui-disabled": {
                                                    backgroundColor: "#90caf9",
                                                    color: "#ffffff",
                                                    opacity: 0.7,
                                                },
                                            }}
                                        >
                                            Print BILL OF LADING
                                        </Button>
                                    </Grid>
                                </Grid>
                            </MDBox> <MDBox mt={3}>
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={1}>
                                    <Autocomplete
                                        options={quoteNoList}
                                        value={selectedQuoteNo}
                                        onChange={(_e, newValue) => handleQuoteNoChange(newValue)}
                                        getOptionLabel={(option) => option?.label || ""}
                                        isOptionEqualToValue={(option, value) => option?.label === value?.label}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Quote No"
                                                placeholder="Select Quote No"
                                                fullWidth
                                                variant="outlined"
                                                sx={inputStyle}
                                                InputLabelProps={{shrink: true}}
                                            />
                                        )}
                                    />
                                </Grid>
                                {/* Select Customer */}
                                <Grid item xs={12} sm={3}>
                                    <Autocomplete
                                        value={selectedCustomer}
                                        inputValue={inputValue}
                                        open={open}
                                        onOpen={() => setOpen(true)}
                                        onClose={() => setOpen(false)}
                                        options={[NEW_PARTY_OPTION, ...customerOptions]}
                                        getOptionLabel={(option) => option?.name || ""}
                                        isOptionEqualToValue={(opt, val) =>
                                            String(opt?.id) === String(val?.id) &&
                                            String(opt?.type) === String(val?.type)
                                        }
                                        onChange={(event, newValue) => {
                                            if (newValue?.type === "new") {
                                                setCustomerModalTarget("customer");
                                                setCustomerModalOpen(true);
                                                setOpen(false);
                                                return;
                                            }

                                            setSelectedCustomer(newValue);
                                            setInputValue(newValue?.name || "");
                                            setOpen(false);
                                        }}
                                        onInputChange={(event, newInputValue, reason) => {
                                            setInputValue(newInputValue);

                                            if (reason === "input" || reason === "clear") {
                                                setOpen(newInputValue.trim().length > 0);
                                            }

                                            if (reason === "clear" || newInputValue.trim().length === 0) {
                                                setSelectedCustomer(null);
                                            }
                                        }}
                                        renderOption={({ key: optionKey, ...props }, option) => (
                                            <li {...props} key={`${option.type}-${option.id}`}>
                                                {option.type === "new" ? (
                                                    <strong style={{ color: "#1976d2" }}>+ New Account</strong>
                                                ) : (
                                                    <>
                                                        {option.name}
                                                        <span style={{ marginLeft: 8, opacity: 0.7, fontSize: 12 }}>
                                                            {option.type === "agent" ? "(Global Agent)" : "(Customer)"}
                                                          </span>
                                                    </>
                                                )}
                                            </li>
                                        )}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label={isEditing ? "Selected Customer" : "Search Customer"}
                                                variant="outlined"
                                                fullWidth
                                                sx={inputStyle}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={2}>
                                    <Autocomplete
                                        value={selectedOceanTransportSubOption}
                                        onChange={(event, newValue) =>
                                            setSelectedOceanTransportSubOption(newValue)
                                        }
                                        options={oceanTransportSubOptions}
                                        getOptionLabel={(option) => option.label}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Ocean Transport Mode"
                                                placeholder="Ocean Transport Mode"
                                                fullWidth
                                                variant="outlined"
                                                sx={inputStyle}
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        )}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={2}>
                                    <Autocomplete
                                        options={[NEW_PARTY_OPTION, ...allPartyOptions]}
                                        value={findOptionByName(shipper)}
                                        getOptionLabel={(option) => option?.name || ""}
                                        isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
                                        onChange={(_e, newValue) => {
                                            if (newValue?.type === "new") {
                                                setCustomerModalTarget("shipper");
                                                setCustomerModalOpen(true);
                                                return;
                                            }

                                            setShipper(newValue?.name || "");
                                        }}
                                        renderOption={({ key: optionKey, ...props }, option) => (
                                            <li {...props} key={option.id}>
                                                {option.type === "new" ? (
                                                    <strong style={{color: "#1976d2"}}>+ New Account</strong>
                                                ) : (
                                                    <>
                                                        {option.name}
                                                        <span style={{marginLeft: 8, opacity: 0.7, fontSize: 12}}>
                                                            {option.type === "agent" ? "(Global Agent)" : "(Customer)"}
                                                        </span>
                                                    </>
                                                )}
                                            </li>
                                        )}
                                        renderInput={(params) => (
                                            <TextField {...params} label="Shipper" fullWidth/>
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={2}>
                                    <Autocomplete
                                        options={[NEW_PARTY_OPTION, ...allPartyOptions]}
                                        value={findOptionByName(consignee)}
                                        onChange={(_e, newValue) => {
                                            if (newValue?.type === "new") {
                                                setCustomerModalTarget("consignee");
                                                setCustomerModalOpen(true);
                                                return;
                                            }

                                            setConsignee(newValue?.name || "");
                                        }}
                                        getOptionLabel={(option) => option?.name || ""}
                                        isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
                                        renderOption={({ key: optionKey, ...props }, option) => (
                                            <li {...props} key={option.id}>
                                                {option.type === "new" ? (
                                                    <strong style={{color: "#1976d2"}}>+ New Account</strong>
                                                ) : (
                                                    <>
                                                        {option.name}
                                                        <span style={{marginLeft: 8, opacity: 0.7, fontSize: 12}}>
                                                                {option.type === "customer"
                                                                    ? "(Customer)"
                                                                    : option.type === "agent"
                                                                        ? "(Global Agent)"
                                                                        : "(Company)"}
                                                              </span>
                                                    </>
                                                )}
                                            </li>
                                        )}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Consignee"
                                                fullWidth
                                                InputLabelProps={{shrink: true}}
                                                sx={{"& .MuiInputBase-root": {height: 50}}}
                                            />
                                        )}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={2}>
                                    <Autocomplete
                                        options={[NEW_PARTY_OPTION, SAME_AS_CONSIGNEE_OPTION, ...allPartyOptions]}
                                        value={findOptionByName(notify)}
                                        onChange={(_e, newValue) => {
                                            if (newValue?.type === "new") {
                                                setCustomerModalTarget("notify");
                                                setCustomerModalOpen(true);
                                                return;
                                            }

                                            if (newValue?.type === "sameAsConsignee") {
                                                setNotify(consignee || "");
                                                return;
                                            }

                                            setNotify(newValue?.name || "");
                                        }}
                                        getOptionLabel={(option) => option?.name || ""}
                                        isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
                                        renderOption={({ key: optionKey, ...props }, option) => (
                                            <li {...props} key={option.id}>
                                                {option.type === "new" ? (
                                                    <strong style={{color: "#1976d2"}}>+ New Account</strong>
                                                ) : option.type === "sameAsConsignee" ? (
                                                    <strong style={{color: "#2e7d32"}}>Same as Consignee</strong>
                                                ) : (
                                                    <>
                                                        {option.name}
                                                        <span style={{marginLeft: 8, opacity: 0.7, fontSize: 12}}>
                                                              {option.type === "customer"
                                                                  ? "(Customer)"
                                                                  : option.type === "agent"
                                                                      ? "(Global Agent)"
                                                                      : "(Company)"}
                                                            </span>
                                                    </>
                                                )}
                                            </li>
                                        )}
                                        renderInput={(params) => (
                                            <TextField
                                                {...params}
                                                label="Notify"
                                                placeholder="Select Notify Party"
                                                fullWidth
                                                variant="outlined"
                                                sx={inputStyle}
                                                InputLabelProps={{shrink: true}}
                                            />
                                        )}
                                    />
                                </Grid>
                            </Grid>
                        </MDBox>
                            <MDBox mt={3}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={2}>
                                        <Autocomplete
                                            freeSolo
                                            options={[NEW_PARTY_OPTION, ...allPartyOptions]}
                                            filterOptions={filterManufacturerOptions}
                                            inputValue={manufacturer || ""}
                                            onInputChange={(_e, value, reason) => {
                                                if (reason === "input" || reason === "clear") setManufacturer(value);
                                            }}
                                            onChange={(_e, newValue) => {
                                                if (newValue?.type === "new") {
                                                    setCustomerModalTarget("manufacturer");
                                                    setCustomerModalOpen(true);
                                                    return;
                                                }

                                                if (newValue && typeof newValue === "object") {
                                                    setManufacturer(newValue.name || "");
                                                }
                                            }}
                                            getOptionLabel={(option) =>
                                                typeof option === "string" ? option : option?.name || ""
                                            }
                                            renderOption={({ key: optionKey, ...props }, option) => (
                                                <li {...props} key={option.id}>
                                                    {option.type === "new" ? (
                                                        <strong style={{ color: "#1976d2" }}>+ New Account</strong>
                                                    ) : (
                                                        <>
                                                            {option.name}
                                                            <span style={{ marginLeft: 8, opacity: 0.7, fontSize: 12 }}>
                                                                {option.type === "agent"
                                                                    ? "(Global Agent)"
                                                                    : option.type === "serviceProvider"
                                                                        ? "(Service Provider)"
                                                                        : "(Customer)"}
                                                            </span>
                                                        </>
                                                    )}
                                                </li>
                                            )}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Manufacturer"
                                                    placeholder="Enter Manufacturer"
                                                    fullWidth
                                                    variant="outlined"
                                                    sx={inputStyle}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            )}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={2}>
                                        <TextField
                                            label="Bill To"
                                            placeholder="Enter Bill To"
                                            value={billTo}
                                            onChange={(e) => setBillTo(e.target.value)}
                                            fullWidth
                                            variant="outlined"
                                            sx={inputStyle}
                                            InputLabelProps={{shrink: true}}
                                        />
                                    </Grid>
                                    {/* Sales Representative */}
                                    <Grid item xs={12} sm={2}>
                                        <Autocomplete
                                            multiple
                                            options={salesRepOptions}
                                            getOptionLabel={(option) => option.label}
                                            value={salesRep}
                                            onChange={(event, newValues) => setSalesRep(newValues)}
                                            isOptionEqualToValue={(option, value) => option.id === value.id}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Sales Rep"
                                                    placeholder="Select Sales Rep"
                                                    fullWidth
                                                    variant="outlined"
                                                    sx={inputStyle}
                                                    InputLabelProps={{shrink: true}}
                                                />
                                            )}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={2}>
                                        <Autocomplete
                                            options={serviceOptions}
                                            value={serviceOptions.find((opt) => opt.label === selectedService) || null}
                                            onChange={(_event, newValue) => setSelectedService(newValue?.label || "")}
                                            getOptionLabel={(option) => option?.label || ""}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Service Level"
                                                    placeholder="Select Service Level"
                                                    fullWidth
                                                    variant="outlined"
                                                    InputLabelProps={{shrink: true}}
                                                />
                                            )}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={2}>
                                        <Autocomplete
                                            options={incotermsOptions}
                                            value={incotermsOptions.find((opt) => opt.label === shipmentIncoterm) || null}
                                            onChange={(_e, newValue) => setShipmentIncoterm(newValue?.label || "")}
                                            getOptionLabel={(option) => option?.label || ""}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Incoterm"
                                                    placeholder="Select Incoterm"
                                                    fullWidth
                                                    variant="outlined"
                                                    sx={inputStyle}
                                                    InputLabelProps={{shrink: true}}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={2}>
                                        <Autocomplete
                                            options={freightStatusOptions}
                                            value={freightStatusOptions.find((opt) => opt.label === freightStatus) || null}
                                            onChange={(_e, newValue) => setFreightStatus(newValue?.label || "")}
                                            getOptionLabel={(option) => option?.label || ""}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    label="Freight Status"
                                                    placeholder="Select Status"
                                                    fullWidth
                                                    variant="outlined"
                                                    sx={inputStyle}
                                                    InputLabelProps={{shrink: true}}
                                                />
                                            )}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={2}>
                                        <TextField
                                            select
                                            label="Bill of Lading Type"
                                            value={billOfLadingType}
                                            onChange={(e) => {
                                                setBillOfLadingType(e.target.value);
                                                setShowDirectMblSection(false);
                                            }}
                                            fullWidth
                                            variant="outlined"
                                            InputLabelProps={{shrink: true}}
                                            sx={inputStyle}
                                        >
                                            <MenuItem value="HBL">HBL</MenuItem>
                                            <MenuItem value="DIRECT_BL">Direct BL</MenuItem>
                                        </TextField>
                                    </Grid>

                                </Grid>

                            </MDBox>


                            <MDBox mt={3}>
                                <MDTypography variant="h6">Customs Details</MDTypography>

                                <Grid container spacing={3} alignItems="flex-start" mt={1}>
                                    <Grid item xs={12} sm={3}>
                                        <TextField
                                            select
                                            label="Export Customs Responsibility"
                                            value={customDetail.responsibility ? "Filenders" : "Exporter"}
                                            onChange={(e) =>
                                                handleStateChange(setCustomDetail, "responsibility", e.target.value === "Filenders")
                                            }
                                            fullWidth
                                            variant="outlined"
                                            InputLabelProps={{shrink: true}}
                                        >
                                            <MenuItem value="Exporter">Exporter</MenuItem>
                                            <MenuItem value="Filenders">Filenders</MenuItem>
                                        </TextField>
                                    </Grid>

                                    {customDetail.responsibility && (
                                        <>
                                            <Grid item xs={12} sm={3}>
                                                <Autocomplete
                                                    options={[NEW_SERVICE_PROVIDER_OPTION, ...serviceProviders]}
                                                    filterOptions={filterServiceProviderOptions}
                                                    renderOption={renderServiceProviderOption}
                                                    value={
                                                        serviceProviders.find(
                                                            (sp) => sp.name === exportLocation.brokerageName
                                                        ) || null
                                                    }
                                                    onChange={(_e, newValue) => {
                                                        if (newValue?.type === "new") {
                                                            setServiceProviderModalTarget("exportBrokerage");
                                                            setServiceProviderModalOpen(true);
                                                            return;
                                                        }

                                                        handleStateChange(
                                                            setExportLocation,
                                                            "brokerageName",
                                                            typeof newValue === "string" ? newValue : newValue?.name || ""
                                                        );
                                                    }}
                                                    inputValue={exportLocation?.brokerageName || ""}
                                                    onInputChange={(_e, newInputValue, reason) => {
                                                        // picking "+ New Account" must not overwrite the field with its label
                                                        if (reason === "reset" && newInputValue === NEW_SERVICE_PROVIDER_OPTION.name) return;

                                                        handleStateChange(setExportLocation, "brokerageName", newInputValue || "");
                                                    }}
                                                    getOptionLabel={getOptionName}
                                                    isOptionEqualToValue={(option, value) =>
                                                        option?.id === value?.id || option?.name === value?.name
                                                    }
                                                    freeSolo
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Export Customs Brokerage Name"
                                                            fullWidth
                                                            variant="outlined"
                                                        />
                                                    )}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={3}>
                                                <Autocomplete
                                                    multiple
                                                    options={customsOfficeOptions}
                                                    value={exportLocation?.additionalInfo || []}
                                                    onChange={(event, newValue) =>
                                                        setExportLocation((prev) => ({
                                                            ...prev,
                                                            additionalInfo: newValue,
                                                        }))
                                                    }
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Export Exit Customs"
                                                            placeholder="Select one or more"
                                                            variant="outlined"
                                                            fullWidth
                                                        />
                                                    )}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={3}>
                                                {renderCountryAutocomplete(
                                                    "Export Country",
                                                    countryOptions,
                                                    selectedExportCountry,
                                                    setSelectedExportCountry,
                                                    setExportLocation,
                                                    handleStateChange,
                                                    "country"
                                                )}
                                            </Grid>

                                            <Grid item xs={12} sm={3}>
                                                <TextField
                                                    label="Export Customs Office Code"
                                                    value={exportLocation.officeCode || ""}
                                                    onChange={(e) =>
                                                        handleStateChange(setExportLocation, "officeCode", e.target.value)
                                                    }
                                                    fullWidth
                                                    variant="outlined"
                                                    InputLabelProps={{shrink: true}}
                                                />
                                            </Grid>
                                        </>
                                    )}
                                </Grid>
                            </MDBox>


                            <MDBox mt={3}>
                                <Grid container spacing={3} alignItems="flex-start" mt={1}>
                                    <Grid item xs={12} sm={3}>
                                        <TextField
                                            select
                                            label="Import Customs Responsibility"
                                            value={customDetail.responsibilityImport ? "Filenders" : "Importer"}
                                            onChange={(e) =>
                                                handleStateChange(setCustomDetail, "responsibilityImport", e.target.value === "Filenders")
                                            }
                                            fullWidth
                                            variant="outlined"
                                            InputLabelProps={{shrink: true}}
                                        >
                                            <MenuItem value="Importer">Importer</MenuItem>
                                            <MenuItem value="Filenders">Filenders</MenuItem>
                                        </TextField>
                                    </Grid>

                                    {customDetail.responsibilityImport && (
                                        <>
                                            <Grid item xs={12} sm={3}>
                                                <Autocomplete
                                                    options={[NEW_SERVICE_PROVIDER_OPTION, ...serviceProviders]}
                                                    filterOptions={filterServiceProviderOptions}
                                                    renderOption={renderServiceProviderOption}
                                                    value={
                                                        serviceProviders.find(
                                                            (sp) => sp.name === importLocation.brokerageName
                                                        ) || null
                                                    }
                                                    onChange={(_e, newValue) => {
                                                        if (newValue?.type === "new") {
                                                            setServiceProviderModalTarget("importBrokerage");
                                                            setServiceProviderModalOpen(true);
                                                            return;
                                                        }

                                                        handleStateChange(
                                                            setImportLocation,
                                                            "brokerageName",
                                                            typeof newValue === "string" ? newValue : newValue?.name || ""
                                                        );
                                                    }}
                                                    inputValue={importLocation?.brokerageName || ""}
                                                    onInputChange={(_e, newInputValue, reason) => {
                                                        // picking "+ New Account" must not overwrite the field with its label
                                                        if (reason === "reset" && newInputValue === NEW_SERVICE_PROVIDER_OPTION.name) return;

                                                        handleStateChange(setImportLocation, "brokerageName", newInputValue || "");
                                                    }}
                                                    getOptionLabel={getOptionName}
                                                    isOptionEqualToValue={(option, value) =>
                                                        option?.id === value?.id || option?.name === value?.name
                                                    }
                                                    freeSolo
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Import Customs Brokerage Name"
                                                            fullWidth
                                                            variant="outlined"
                                                        />
                                                    )}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={3}>
                                                <Autocomplete
                                                    multiple
                                                    options={customsOfficeOptions}
                                                    value={importLocation?.additionalInfo || []}
                                                    onChange={(event, newValue) =>
                                                        setImportLocation((prev) => ({
                                                            ...prev,
                                                            additionalInfo: newValue,
                                                        }))
                                                    }
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Import Entry Customs"
                                                            placeholder="Select one or more"
                                                            variant="outlined"
                                                            fullWidth
                                                        />
                                                    )}
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={3}>
                                                {renderCountryAutocomplete(
                                                    "Import Country",
                                                    countryOptions,
                                                    selectedImportCountry,
                                                    setSelectedImportCountry,
                                                    setImportLocation,
                                                    handleStateChange,
                                                    "country"
                                                )}
                                            </Grid>

                                            <Grid item xs={12} sm={3}>
                                                <TextField
                                                    label="Import Customs Office Code"
                                                    value={importLocation.officeCode || ""}
                                                    onChange={(e) =>
                                                        handleStateChange(setImportLocation, "officeCode", e.target.value)
                                                    }
                                                    fullWidth
                                                    variant="outlined"
                                                    InputLabelProps={{shrink: true}}
                                                />
                                            </Grid>
                                        </>
                                    )}
                                </Grid>
                            </MDBox>

                            <LocalizationProvider dateAdapter={AdapterDateFns} locale={tr}>
                                <MDBox mt={4}>
                                    <MDTypography variant="h6">Service Details</MDTypography>

                                    <MDBox
                                        mt={1.5}
                                        px={2}
                                        py={1.25}
                                        display="flex"
                                        alignItems="flex-start"
                                        gap={1.5}
                                        sx={{
                                            borderRadius: "10px",
                                            border: "1px solid #dbe7fb",
                                            borderLeft: "3px solid #1a73e8",
                                            backgroundColor: "#f5f9ff",
                                        }}
                                    >
                                        {carrierLookup.state === "loading" ? (
                                            <CircularProgress size={18} sx={{ mt: "2px", color: "#1a73e8" }} />
                                        ) : (
                                            <AutoAwesomeOutlinedIcon sx={{ mt: "2px", color: "#1a73e8", fontSize: "20px !important" }} />
                                        )}
                                        <MDBox lineHeight={1.35}>
                                            <MDTypography variant="button" fontWeight="medium" color="dark" display="block">
                                                Carrier auto-fill
                                            </MDTypography>
                                            <MDTypography variant="caption" color="text" display="block">
                                                Select a <strong>Shipping Line</strong> and enter the first{" "}
                                                <strong>Container No</strong> in Cargo Details. Vessel, voyage, POL/POD,
                                                transshipment and ETD/ETA are then filled from the carrier&apos;s
                                                tracking data. Only empty fields are filled; your entries are never
                                                overwritten.
                                            </MDTypography>
                                            {carrierLookup.message && (
                                                <MDTypography
                                                    variant="caption"
                                                    display="block"
                                                    mt={0.5}
                                                    fontWeight="medium"
                                                    sx={{
                                                        color: {
                                                            loading: "#1a73e8",
                                                            filled: "#15803d",
                                                            skipped: "#b45309",
                                                        }[carrierLookup.state] || "#64748b",
                                                    }}
                                                >
                                                    {carrierLookup.message}
                                                </MDTypography>
                                            )}
                                        </MDBox>
                                    </MDBox>

                                    <Grid container spacing={3} mt={1}>
                                        <Grid item xs={12} md={3}>
                                            <Autocomplete
                                                options={countryOptions}
                                                value={countryOptions.find((c) => c.label === vesselPol.country) || null}
                                                onChange={(_e, newValue) =>
                                                    setVesselPol((prev) => ({
                                                        ...prev,
                                                        country: newValue?.label || "",
                                                        port: "",
                                                    }))
                                                }
                                                getOptionLabel={(option) => option?.label || ""}
                                                renderOption={({ key: optionKey, ...props }, option) => (
                                                    <li key={optionKey} {...props} style={{display: "flex", alignItems: "center"}}>
                                                        {option.flagUrl && (
                                                            <img
                                                                src={option.flagUrl}
                                                                alt={option.label}
                                                                width="20"
                                                                height="15"
                                                                style={{marginRight: 8}}
                                                            />
                                                        )}
                                                        {option.label}
                                                    </li>
                                                )}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="POL Country" fullWidth
                                                               InputLabelProps={{shrink: true}}/>
                                                )}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={3}>
                                            <Autocomplete
                                                options={vesselPolOptions}
                                                loading={vesselPolLoading}
                                                freeSolo
                                                value={vesselPol.port || null}
                                                onChange={(_e, newValue) =>
                                                    setVesselPol((prev) => ({
                                                        ...prev,
                                                        port: newValue || "",
                                                    }))
                                                }
                                                renderInput={(params) => (
                                                    <TextField {...params} label="POL Port" fullWidth
                                                               InputLabelProps={{shrink: true}}/>
                                                )}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={3}>
                                            <Autocomplete
                                                options={countryOptions}
                                                value={countryOptions.find((c) => c.label === vesselPod.country) || null}
                                                onChange={(_e, newValue) =>
                                                    setVesselPod((prev) => ({
                                                        ...prev,
                                                        country: newValue?.label || "",
                                                        port: "",
                                                    }))
                                                }
                                                getOptionLabel={(option) => option?.label || ""}
                                                renderOption={({ key: optionKey, ...props }, option) => (
                                                    <li key={optionKey} {...props} style={{display: "flex", alignItems: "center"}}>
                                                        {option.flagUrl && (
                                                            <img
                                                                src={option.flagUrl}
                                                                alt={option.label}
                                                                width="20"
                                                                height="15"
                                                                style={{marginRight: 8}}
                                                            />
                                                        )}
                                                        {option.label}
                                                    </li>
                                                )}
                                                renderInput={(params) => (
                                                    <TextField {...params} label="POD Country" fullWidth
                                                               InputLabelProps={{shrink: true}}/>
                                                )}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={3}>
                                            <Autocomplete
                                                options={vesselPodOptions}
                                                loading={vesselPodLoading}
                                                freeSolo
                                                value={vesselPod.port || null}
                                                onChange={(_e, newValue) =>
                                                    setVesselPod((prev) => ({
                                                        ...prev,
                                                        port: newValue || "",
                                                    }))
                                                }
                                                renderInput={(params) => (
                                                    <TextField {...params} label="POD Port" fullWidth
                                                               InputLabelProps={{shrink: true}}/>
                                                )}
                                            />
                                        </Grid>
                                    </Grid>

                                    <Grid container spacing={2} mt={1} alignItems="center">
                                        <Grid item xs={12} md={3}>
                                            <Autocomplete
                                                freeSolo
                                                options={DEFAULT_LINE_OPTIONS}
                                                value={
                                                    DEFAULT_LINE_OPTIONS.find((opt) => opt.name === shippingLine) || null
                                                }
                                                onChange={(_e, newValue) =>
                                                    setShippingLine(newValue?.name || "")
                                                }
                                                getOptionLabel={(option) => option?.name || ""}
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        label="Shipping Line"
                                                        fullWidth
                                                        InputLabelProps={{shrink: true}}
                                                    />
                                                )}
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={3}>
                                            <TextField
                                                label="Booking Number"
                                                value={bookingNumber}
                                                onChange={(e) => setBookingNumber(e.target.value.toUpperCase())}
                                                fullWidth
                                                InputLabelProps={{shrink: true}}
                                            />
                                        </Grid>
                                    </Grid>

                                    <Grid container spacing={3} mt={1}>
                                        <Grid item xs={12} md={3}>
                                            <DatePicker
                                                label="Gate-in Without Storage Date"
                                                value={gateInWithoutStorageDate}
                                                onChange={setGateInWithoutStorageDate}
                                                format="dd/MM/yyyy"
                                                slotProps={{
                                                    textField: {
                                                        fullWidth: true,
                                                        InputLabelProps: {shrink: true},
                                                    },
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={3}>
                                            <TextField
                                                label="Gate-in Without Storage Time"
                                                type="time"
                                                value={gateInWithoutStorageTime}
                                                onChange={(e) => setGateInWithoutStorageTime(e.target.value)}
                                                fullWidth
                                                InputLabelProps={{shrink: true}}
                                                inputProps={{step: 900}}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={3}>
                                            <DatePicker
                                                label="Shipping Cutoff Date"
                                                value={shippingInstructionCutoffDate}
                                                onChange={setShippingInstructionCutoffDate}
                                                format="dd/MM/yyyy"
                                                slotProps={{
                                                    textField: {
                                                        fullWidth: true,
                                                        InputLabelProps: {shrink: true},
                                                    },
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={3}>
                                            <TextField
                                                label="Shipping Cutoff Time"
                                                type="time"
                                                value={shippingInstructionCutoffTime}
                                                onChange={(e) => setShippingInstructionCutoffTime(e.target.value)}
                                                fullWidth
                                                InputLabelProps={{shrink: true}}
                                                inputProps={{step: 900}}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={3}>
                                            <DatePicker
                                                label="Customs Dec Cutoff Date"
                                                value={customsDeclarationCutoffDate}
                                                onChange={setCustomsDeclarationCutoffDate}
                                                format="dd/MM/yyyy"
                                                slotProps={{
                                                    textField: {
                                                        fullWidth: true,
                                                        InputLabelProps: {shrink: true},
                                                    },
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={3}>
                                            <TextField
                                                label="Customs Dec Cutoff Time"
                                                type="time"
                                                value={customsDeclarationCutoffTime}
                                                onChange={(e) => setCustomsDeclarationCutoffTime(e.target.value)}
                                                fullWidth
                                                InputLabelProps={{shrink: true}}
                                                inputProps={{step: 900}}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={3}>
                                            <DatePicker
                                                label="ETD"
                                                value={estimatedDeparture}
                                                onChange={setEstimatedDeparture}
                                                format="dd/MM/yyyy"
                                                slotProps={{
                                                    textField: {
                                                        fullWidth: true,
                                                        InputLabelProps: {shrink: true},
                                                    },
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={3}>
                                            <TextField
                                                label="ETD Time"
                                                type="time"
                                                value={estimatedDepartureTime}
                                                onChange={(e) => setEstimatedDepartureTime(e.target.value)}
                                                fullWidth
                                                InputLabelProps={{shrink: true}}
                                                inputProps={{step: 900}}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={3}>
                                            <DatePicker
                                                label="ETA"
                                                value={estimatedDeliveryDate}
                                                onChange={setEstimatedDeliveryDate}
                                                format="dd/MM/yyyy"
                                                slotProps={{
                                                    textField: {
                                                        fullWidth: true,
                                                        InputLabelProps: {shrink: true},
                                                    },
                                                }}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={3}>
                                            <TextField
                                                label="ETA Time"
                                                type="time"
                                                value={estimatedDeliveryTime}
                                                onChange={(e) => setEstimatedDeliveryTime(e.target.value)}
                                                fullWidth
                                                InputLabelProps={{shrink: true}}
                                                inputProps={{step: 900}}
                                            />
                                        </Grid>
                                    </Grid>

                                </MDBox>
                            </LocalizationProvider>

                            {/* Pickup ve Delivery adresleri Service Details'in hemen altında */}
                            <LocalizationProvider dateAdapter={AdapterDateFns} locale={tr}>
                                <MDBox mt={4}>
                                    <MDTypography variant="h6">Pickup Details</MDTypography>
                                    <MDBox mt={2} sx={disabledSectionSx(isPickupDisabled)}>
                                        {isPickupDisabled && (
                                            <MDBox sx={disabledHintSx}>
                                                <Alert severity="info" sx={{mb: 2}}>
                                                    Pickup service details are not applicable for the selected service
                                                    level.
                                                </Alert>
                                            </MDBox>
                                        )}

                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={3}>
                                                <Autocomplete
                                                    options={[NEW_PARTY_OPTION, ...allPartyOptions]}
                                                    value={
                                                        serviceProviderPartyOptions.find(
                                                            (opt) => opt.name === pickupServiceProvider
                                                        ) || null
                                                    }
                                                    onChange={(_e, newValue) => {
                                                        if (newValue?.type === "new") {
                                                            setServiceProviderModalTarget("pickupServiceProvider");
                                                            setServiceProviderModalOpen(true);
                                                            return;
                                                        }

                                                        setPickupServiceProvider(newValue?.name || "");
                                                    }}
                                                    getOptionLabel={(option) => option?.name || ""}
                                                    isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
                                                    disabled={isPickupDisabled}
                                                    renderOption={({ key: optionKey, ...props }, option) => (
                                                        <li {...props} key={option.id}>
                                                            {option.type === "new" ? (
                                                                <strong style={{color: "#1976d2"}}>+ New
                                                                    Account</strong>
                                                            ) : (
                                                                <>
                                                                    {option.name}
                                                                    <span style={{
                                                                        marginLeft: 8,
                                                                        opacity: 0.7,
                                                                        fontSize: 12
                                                                    }}>
                                                                      {option.type === "customer"
                                                                          ? "(Customer)"
                                                                          : option.type === "agent" || option.type === "globalAgent"
                                                                              ? "(Global Agent)"
                                                                              : option.type === "serviceProvider"
                                                                                  ? "(Service Provider)"
                                                                                  : "(Company)"}
                                                                    </span>
                                                                </>
                                                            )}
                                                        </li>
                                                    )}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Pickup Service Provider"
                                                            placeholder="Select Pickup Service Provider"
                                                            fullWidth
                                                            variant="outlined"
                                                            InputLabelProps={{shrink: true}}
                                                        />
                                                    )}
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={3}>
                                                <TextField
                                                    type="number"
                                                    label="Pickup Cost"
                                                    value={pickupRate}
                                                    onChange={(e) => setPickupRate(e.target.value)}
                                                    fullWidth
                                                    variant="outlined"
                                                    disabled={isPickupDisabled}
                                                    InputLabelProps={{shrink: true}}
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={2}>
                                                <TextField
                                                    select
                                                    label="Currency"
                                                    value={pickupRateCurrency}
                                                    onChange={(e) => setPickupRateCurrency(e.target.value)}
                                                    fullWidth
                                                    variant="outlined"
                                                    disabled={isPickupDisabled}
                                                    InputLabelProps={{shrink: true}}
                                                >
                                                    {["USD", "EUR", "GBP", "TRY"].map((c) => (
                                                        <MenuItem key={c} value={c}>{c}</MenuItem>
                                                    ))}
                                                </TextField>
                                            </Grid>

                                            <Grid item xs={12} md={4}>
                                                <MDBox
                                                    display="flex"
                                                    justifyContent="flex-end"
                                                    alignItems="center"
                                                    height="100%"
                                                >
                                                    <Button
                                                        variant="contained"
                                                        startIcon={<SendRoundedIcon/>}
                                                        onClick={handleOpenPickupNotificationPreview}
                                                        disabled={isPickupDisabled || !pickupServiceProvider}
                                                        sx={{
                                                            height: 42,
                                                            px: 3,
                                                            borderRadius: "12px",
                                                            textTransform: "none",
                                                            fontWeight: 700,
                                                            letterSpacing: "0.2px",
                                                            background: "linear-gradient(135deg, #2e7d32, #43a047)",
                                                            color: "#fff",
                                                            boxShadow: "0 8px 18px rgba(46,125,50,0.25)",
                                                            "&:hover": {
                                                                background: "linear-gradient(135deg, #1b5e20, #388e3c)",
                                                                color: "#fff",
                                                                boxShadow: "0 10px 22px rgba(46,125,50,0.32)",
                                                            },
                                                            "&.Mui-disabled": {
                                                                background: "#a5d6a7",
                                                                color: "#fff",
                                                                opacity: 0.75,
                                                            },
                                                        }}
                                                    >
                                                        SEND NOTIFICATION
                                                    </Button>
                                                </MDBox>
                                            </Grid>

                                        </Grid>
                                        <Grid container spacing={2} mt={2}>
                                            <Grid item xs={12} md={3}>
                                                <DatePicker
                                                    label="Pickup Date"
                                                    value={pickupDate}
                                                    onChange={setPickupDate}
                                                    format="dd/MM/yyyy"
                                                    disabled={isPickupDisabled}
                                                    slotProps={{
                                                        textField: {
                                                            variant: "outlined",
                                                            fullWidth: true,
                                                            InputLabelProps: {shrink: true},
                                                        },
                                                        actionBar: {actions: ["clear", "accept"]},
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={3}>
                                                <TextField
                                                    label="Pickup Time"
                                                    type="time"
                                                    value={pickupTime}
                                                    onChange={(e) => setPickupTime(e.target.value)}
                                                    fullWidth
                                                    variant="outlined"
                                                    disabled={isPickupDisabled}
                                                    InputLabelProps={{shrink: true}}
                                                    inputProps={{step: 900}}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={3}>
                                                <DatePicker
                                                    label="Empty Release Container Date"
                                                    value={loadingDate}
                                                    onChange={setLoadingDate}
                                                    format="dd/MM/yyyy"
                                                    slotProps={{
                                                        textField: {
                                                            variant: "outlined",
                                                            fullWidth: true,
                                                            InputLabelProps: {shrink: true},
                                                        },
                                                        actionBar: {actions: ["clear", "accept"]},
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={3}>
                                                <TextField
                                                    label="Empty Release Container Time"
                                                    type="time"
                                                    value={loadingTime}
                                                    onChange={(e) => setLoadingTime(e.target.value)}
                                                    fullWidth
                                                    variant="outlined"
                                                    InputLabelProps={{shrink: true}}
                                                    inputProps={{step: 900}}
                                                />
                                            </Grid>
                                        </Grid>
                                    </MDBox>

                                    <Grid container spacing={2} mt={1}>
                                        {serviceLayout.pickup.some((x) => x.key === "pickupAddress1") && (
                                            <Grid item xs={12} md={6}>
                                                {renderServiceAddressFields(
                                                    getPickupTitle("pickupAddress1"),
                                                    pickupAddress1,
                                                    setPickupAddress1,
                                                    "door",
                                                    pickupAddress1Options,
                                                    pickupAddress1Loading
                                                )}
                                            </Grid>
                                        )}

                                        <Grid item xs={12} md={6}>
                                            {renderServiceAddressFields(
                                                "Empty Release Container Address",
                                                loadingAddress,
                                                setLoadingAddress,
                                                "door",
                                                loadingAddressOptions,
                                                loadingAddressLoading
                                            )}
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2} mt={1}>
                                        {/* Pickup Full Address */}
                                        <Grid item xs={12} md={6}>
                                            <Grid container spacing={1} alignItems="flex-start">
                                                <Grid item xs>
                                                    <Autocomplete
                                                        options={pickupFullAddressOptions}
                                                        value={
                                                            pickupFullAddressOptions.find(
                                                                (item) => item.address === pickupLocation.additionalInfo
                                                            ) || null
                                                        }
                                                        onChange={(_e, newValue) =>
                                                            setPickupLocation((prev) => ({
                                                                ...prev,
                                                                additionalInfo: newValue?.address || "",
                                                            }))
                                                        }
                                                        getOptionLabel={(option) => option?.name || ""}
                                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                                        renderOption={({ key: optionKey, ...props }, option) => (
                                                            <li {...props} key={option.id}>
                                                                <MDBox
                                                                    sx={{
                                                                        display: "flex",
                                                                        width: "100%",
                                                                        alignItems: "center",
                                                                        gap: 1,
                                                                    }}
                                                                >
                                                                    <MDBox sx={{flex: 1}}>
                                                                        <strong>{option.name}</strong>
                                                                        <div style={{fontSize: 12, opacity: 0.7}}>
                                                                            {option.address}
                                                                        </div>
                                                                    </MDBox>

                                                                    <IconButton
                                                                        size="small"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            openAddressModal("pickup", option);
                                                                        }}
                                                                    >
                                                                        <EditIcon fontSize="small"/>
                                                                    </IconButton>

                                                                    <IconButton
                                                                        size="small"
                                                                        color="error"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            deleteAddressOption("pickup", option.id);
                                                                        }}
                                                                    >
                                                                        <DeleteIcon fontSize="small"/>
                                                                    </IconButton>
                                                                </MDBox>
                                                            </li>
                                                        )}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Pickup Full Address"
                                                                placeholder="Select Pickup Full Address"
                                                                fullWidth
                                                                variant="outlined"
                                                                InputLabelProps={{shrink: true}}
                                                            />
                                                        )}
                                                    />
                                                </Grid>

                                                <Grid item xs="auto">
                                                    <Button
                                                        variant="contained"
                                                        onClick={() => openAddressModal("pickup")}
                                                        sx={{height: 55, color: "#fff"}}
                                                    >
                                                        Add
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        {/* Empty Release Container Full Address */}
                                        <Grid item xs={12} md={6}>
                                            <Grid container spacing={1} alignItems="flex-start">
                                                <Grid item xs>
                                                    <Autocomplete
                                                        options={emptyReleaseFullAddressOptions}
                                                        value={
                                                            emptyReleaseFullAddressOptions.find(
                                                                (item) => item.address === loadingAddress.additionalInfo
                                                            ) || null
                                                        }
                                                        onChange={(_e, newValue) =>
                                                            setLoadingAddress((prev) => ({
                                                                ...prev,
                                                                additionalInfo: newValue?.address || "",
                                                            }))
                                                        }
                                                        getOptionLabel={(option) => option?.name || ""}
                                                        isOptionEqualToValue={(option, value) => option.id === value.id}
                                                        renderOption={({ key: optionKey, ...props }, option) => (
                                                            <li {...props} key={option.id}>
                                                                <MDBox
                                                                    sx={{
                                                                        display: "flex",
                                                                        width: "100%",
                                                                        alignItems: "center",
                                                                        gap: 1,
                                                                    }}
                                                                >
                                                                    <MDBox sx={{flex: 1}}>
                                                                        <strong>{option.name}</strong>
                                                                        <div style={{fontSize: 12, opacity: 0.7}}>
                                                                            {option.address}
                                                                        </div>
                                                                    </MDBox>

                                                                    <IconButton
                                                                        size="small"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            openAddressModal("container", option);
                                                                        }}
                                                                    >
                                                                        <EditIcon fontSize="small"/>
                                                                    </IconButton>

                                                                    <IconButton
                                                                        size="small"
                                                                        color="error"
                                                                        onClick={(e) => {
                                                                            e.stopPropagation();
                                                                            deleteAddressOption("container", option.id);
                                                                        }}
                                                                    >
                                                                        <DeleteIcon fontSize="small"/>
                                                                    </IconButton>
                                                                </MDBox>
                                                            </li>
                                                        )}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="Empty Release Container Full Address"
                                                                placeholder="Select Empty Release Container Full Address"
                                                                fullWidth
                                                                variant="outlined"
                                                                InputLabelProps={{shrink: true}}
                                                            />
                                                        )}
                                                    />
                                                </Grid>

                                                <Grid item xs="auto">
                                                    <Button
                                                        variant="contained"
                                                        onClick={() => openAddressModal("container")}
                                                        sx={{height: 55, color: "#fff"}}
                                                    >
                                                        Add
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid> </MDBox>
                                <MDBox mt={4}>
                                    <MDTypography variant="h6">Delivery Details</MDTypography>

                                    <MDBox mt={2} sx={disabledSectionSx(isDeliveryDisabled)}>
                                        {isDeliveryDisabled && (
                                            <MDBox sx={disabledHintSx}>
                                                <Alert severity="info" sx={{mb: 2}}>
                                                    Delivery service details are not applicable for the selected service
                                                    level.
                                                </Alert>
                                            </MDBox>
                                        )}

                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={4}>
                                                <Autocomplete
                                                    options={[NEW_PARTY_OPTION, ...allPartyOptions]}
                                                    value={findOptionByName(deliveryServiceProvider)}
                                                    onChange={(_e, newValue) => {
                                                        if (newValue?.type === "new") {
                                                            setServiceProviderModalTarget("deliveryServiceProvider");
                                                            setServiceProviderModalOpen(true);
                                                            return;
                                                        }

                                                        setDeliveryServiceProvider(newValue?.name || "");
                                                    }}
                                                    getOptionLabel={(option) => option?.name || ""}
                                                    isOptionEqualToValue={(opt, val) => opt?.id === val?.id}
                                                    disabled={isDeliveryDisabled}
                                                    renderOption={({ key: optionKey, ...props }, option) => (
                                                        <li {...props} key={option.id}>
                                                            {option.type === "new" ? (
                                                                <strong style={{color: "#1976d2"}}>+ New
                                                                    Account</strong>
                                                            ) : (
                                                                <>
                                                                    {option.name}
                                                                    <span style={{
                                                                        marginLeft: 8,
                                                                        opacity: 0.7,
                                                                        fontSize: 12
                                                                    }}>
                                                                          {option.type === "customer"
                                                                              ? "(Customer)"
                                                                              : option.type === "agent" || option.type === "globalAgent"
                                                                                  ? "(Global Agent)"
                                                                                  : option.type === "serviceProvider"
                                                                                      ? "(Service Provider)"
                                                                                      : "(Company)"}
                                                                        </span>
                                                                </>
                                                            )}
                                                        </li>
                                                    )}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Delivery Service Provider"
                                                            placeholder="Select Delivery Service Provider"
                                                            fullWidth
                                                            variant="outlined"
                                                            InputLabelProps={{shrink: true}}
                                                        />
                                                    )}
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    type="number"
                                                    label="Delivery Cost"
                                                    value={deliveryRate}
                                                    onChange={(e) => setDeliveryRate(e.target.value)}
                                                    fullWidth
                                                    variant="outlined"
                                                    disabled={isDeliveryDisabled}
                                                    InputLabelProps={{shrink: true}}
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={4}>
                                                <TextField
                                                    select
                                                    label="Currency"
                                                    value={deliveryRateCurrency}
                                                    onChange={(e) => setDeliveryRateCurrency(e.target.value)}
                                                    fullWidth
                                                    variant="outlined"
                                                    disabled={isDeliveryDisabled}
                                                    InputLabelProps={{shrink: true}}
                                                >
                                                    {["USD", "EUR", "GBP", "TRY"].map((c) => (
                                                        <MenuItem key={c} value={c}>{c}</MenuItem>
                                                    ))}
                                                </TextField>
                                            </Grid>
                                        </Grid>
                                    </MDBox>

                                    <Grid container spacing={2} mt={1}>
                                        {serviceLayout.delivery.some((x) => x.key === "deliveryAddress2") && (
                                            <Grid item xs={12} md={6}>
                                                {renderServiceAddressFields(
                                                    getDeliveryTitle("deliveryAddress2"),
                                                    deliveryAddress2,
                                                    setDeliveryAddress2,
                                                    "door",
                                                    deliveryAddress2Options,
                                                    deliveryAddress2Loading
                                                )}
                                            </Grid>
                                        )}
                                    </Grid>
                                    <Grid container spacing={2} mt={1}>
                                        <Grid item xs={12}>
                                            <TextField
                                                label="Delivery Full Address"
                                                placeholder="Enter Delivery Full Address"
                                                value={deliveryLocation.additionalInfo || ""}
                                                onChange={(e) =>
                                                    setDeliveryLocation((prev) => ({
                                                        ...prev,
                                                        additionalInfo: e.target.value,
                                                    }))
                                                }
                                                fullWidth
                                                variant="outlined"
                                                multiline
                                                minRows={1}
                                                InputLabelProps={{shrink: true}}
                                                disabled={isDeliveryDisabled}
                                            />
                                        </Grid>
                                    </Grid>
                                </MDBox>
                            </LocalizationProvider>


                            <MDBox
                                mt={3}
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                            >
                                <MDTypography variant="h6">Cargo Details</MDTypography>
                                <AddRowButton onClick={addCargoDetail} label="Add Cargo" />
                            </MDBox>

                            <MDBox mt={3}>
                                {cargoDetails.map((cargo, index) => (
                                    <MDBox key={index} mt={4} p={2} borderRadius={2} border="1px solid #eee">
                                        {/* DELETE */}
                                        {index > 0 && (
                                            <MDBox display="flex" justifyContent="flex-end" mb={2}>
                                                <RemoveRowButton onClick={() => removeCargoDetail(index)} tooltip="Remove cargo" />
                                            </MDBox>
                                        )}

                                        <Grid container spacing={3}>
                                            {/* Commodity */}
                                            <Grid item xs={12} sm={3}>
                                                <TextField
                                                    label="Commodity Name"
                                                    value={cargo.commodity}
                                                    onChange={(e) =>
                                                        updateCargoDetails(index, "commodity", e.target.value)
                                                    }
                                                    fullWidth
                                                    variant="outlined"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                        component: LabelWithTooltip({
                                                            label: "Commodity Name",
                                                            tooltip: "Commercial name of cargo"
                                                        })
                                                    }}
                                                />
                                            </Grid>
                                            <Grid item xs={12} sm={3}>
                                                <Autocomplete
                                                    options={countryOptions}
                                                    getOptionLabel={(option) => option?.label || ""}
                                                    value={
                                                        cargo.goodsOriginCountry
                                                            ? countryOptions.find((o) => o.label === cargo.goodsOriginCountry) || null
                                                            : null
                                                    }
                                                    onChange={(_e, newValue) =>
                                                        updateCargoDetails(index, "goodsOriginCountry", newValue?.label || "")
                                                    }
                                                    isOptionEqualToValue={(opt, val) => opt?.label === val?.label}
                                                    renderOption={({ key: optionKey, ...props }, option) => (
                                                        <li key={optionKey} {...props} style={{display: "flex", alignItems: "center"}}>
                                                            {option.flagUrl && (
                                                                <img
                                                                    src={option.flagUrl}
                                                                    alt={option.label}
                                                                    width="20"
                                                                    height="15"
                                                                    style={{marginRight: 8}}
                                                                />
                                                            )}
                                                            {option.label}
                                                        </li>
                                                    )}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Goods of Origin Country"
                                                            placeholder="Select Country"
                                                            variant="outlined"
                                                            fullWidth
                                                            InputLabelProps={{shrink: true}}
                                                            sx={PRICING_INPUT_SX}
                                                        />
                                                    )}
                                                />
                                            </Grid>


                                            {/* HS Code */}
                                            <Grid item xs={12} sm={3}>
                                                <TextField
                                                    label="HS Code"
                                                    value={cargo.hsCode}
                                                    onChange={(e) =>
                                                        updateCargoDetails(index, "hsCode", e.target.value)
                                                    }
                                                    fullWidth
                                                    variant="outlined"
                                                />
                                            </Grid>

                                            {/* Packing Type */}
                                            <Grid item xs={12} sm={3} sx={PRICING_INPUT_SX}>
                                                {renderPackingTypeSelect(
                                                    "Packing Type",
                                                    packingOptions,
                                                    cargo.selectedPackingType,
                                                    (val) => updateCargoDetails(index, "selectedPackingType", val)
                                                )}
                                            </Grid>

                                            {/* Stackable */}
                                            <Grid item xs={12} sm={3}>
                                                <MDBox display="flex" alignItems="center">
                                                    <MDTypography variant="button">
                                                        {cargo.notStackable ? "Not Stackable" : "Stackable"}
                                                    </MDTypography>
                                                    <Switch
                                                        checked={!cargo.notStackable}
                                                        onChange={() =>
                                                            updateCargoDetails(
                                                                index,
                                                                "notStackable",
                                                                !cargo.notStackable
                                                            )
                                                        }
                                                    />
                                                </MDBox>
                                            </Grid>

                                            {/* Stacking Factor */}
                                            {!cargo.notStackable && (
                                                <Grid item xs={12} sm={3}>
                                                    <TextField
                                                        label="Stacking Factor"
                                                        type="number"
                                                        value={cargo.stackingFactor}
                                                        onChange={(e) =>
                                                            updateCargoDetails(
                                                                index,
                                                                "stackingFactor",
                                                                Number(e.target.value)
                                                            )
                                                        }
                                                        fullWidth
                                                        variant="outlined"
                                                    />
                                                </Grid>
                                            )}

                                        </Grid>

                                        {/* Containers: one line per container type, rows generated per piece */}
                                        <MDBox
                                            mt={3}
                                            p={2}
                                            sx={{border: "1px solid #e0e0e0", borderRadius: "12px", backgroundColor: "#fafafa"}}
                                        >
                                            <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                                <MDTypography variant="h6" fontWeight="bold">
                                                    Containers
                                                </MDTypography>
                                                <MDBox display="flex" alignItems="center" gap={2}>
                                                    <MDTypography variant="button" color="text">
                                                        Total Container: {cargo.containers?.length || 0}
                                                    </MDTypography>
                                                    <AddRowButton onClick={() => addContainerGroup(index)} label="Add Container Type" />
                                                </MDBox>
                                            </MDBox>

                                            {(cargo.containerGroups || []).map((group) => (
                                                <Grid container spacing={2} alignItems="center" mb={1} key={group.id}>
                                                    <Grid item xs={12} md={4}>
                                                        <Autocomplete
                                                            options={containerType}
                                                            getOptionLabel={(option) => option.label}
                                                            value={containerType.find((o) => o.label === group.containerType) || null}
                                                            onChange={(_e, newValue) =>
                                                                updateContainerGroup(index, group.id, "containerType", newValue ? newValue.label : "")
                                                            }
                                                            isOptionEqualToValue={(opt, val) => opt.label === val.label}
                                                            renderInput={(params) => (
                                                                <TextField
                                                                    {...params}
                                                                    label="Container Type"
                                                                    placeholder="Select Container Type"
                                                                    variant="outlined"
                                                                    fullWidth
                                                                    InputLabelProps={{shrink: true}}
                                                                    sx={PRICING_INPUT_SX}
                                                                />
                                                            )}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={8} md={2}>
                                                        <TextField
                                                            label="Container PCS"
                                                            type="number"
                                                            value={group.containerPcs}
                                                            onChange={(e) =>
                                                                updateContainerGroup(
                                                                    index,
                                                                    group.id,
                                                                    "containerPcs",
                                                                    Math.min(MAX_CONTAINER_PCS, Math.max(1, Number(e.target.value) || 1))
                                                                )
                                                            }
                                                            inputProps={{min: 1, max: MAX_CONTAINER_PCS}}
                                                            fullWidth
                                                            variant="outlined"
                                                            InputLabelProps={{shrink: true}}
                                                            sx={PRICING_INPUT_SX}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={4} md="auto">
                                                        <RemoveRowButton onClick={() => removeContainerGroup(index, group.id)} tooltip="Remove container type" disabled={(cargo.containerGroups || []).length === 1} />
                                                    </Grid>
                                                </Grid>
                                            ))}

                                            {(cargo.containers || []).map((container, containerIndex) => (
                                                <MDBox
                                                    key={`${container.groupId}-${containerIndex}`}
                                                    mt={2}
                                                    p={2}
                                                    sx={{border: "1px solid #ddd", borderRadius: "10px", backgroundColor: "#fff"}}
                                                >
                                                    <MDTypography variant="subtitle2" fontWeight="bold" mb={2}>
                                                        Container #{containerIndex + 1}
                                                        {container.containerType ? ` - ${container.containerType}` : ""}
                                                    </MDTypography>

                                                    <Grid container spacing={2} alignItems="flex-start">
                                                        <Grid item xs={12} md={3}>
                                                            <TextField
                                                                label="Container No"
                                                                value={container.containerNo || ""}
                                                                onChange={(e) =>
                                                                    updateContainerRow(index, containerIndex, "containerNo", e.target.value.toUpperCase())
                                                                }
                                                                fullWidth
                                                                InputLabelProps={{shrink: true}}
                                                                sx={COMMON_INPUT_SX}
                                                            />
                                                        </Grid>

                                                        <Grid item xs={12} md={3}>
                                                            <TextField
                                                                label="Seal Number"
                                                                value={container.sealNumber || ""}
                                                                onChange={(e) =>
                                                                    updateContainerRow(index, containerIndex, "sealNumber", e.target.value.toUpperCase())
                                                                }
                                                                fullWidth
                                                                InputLabelProps={{shrink: true}}
                                                                sx={COMMON_INPUT_SX}
                                                            />
                                                        </Grid>

                                                        <Grid item xs={12} md={3}>
                                                            <TextField
                                                                label="VGM"
                                                                value={container.vgm || ""}
                                                                onChange={(e) =>
                                                                    updateContainerRow(index, containerIndex, "vgm", e.target.value)
                                                                }
                                                                fullWidth
                                                                InputLabelProps={{shrink: true}}
                                                                sx={COMMON_INPUT_SX}
                                                            />
                                                        </Grid>

                                                        <Grid item xs={12} md={3} sx={PRICING_INPUT_SX}>
                                                            {renderPackingTypeSelect(
                                                                "Packing Type",
                                                                packingOptions,
                                                                container.packingType,
                                                                (val) => updateContainerRow(index, containerIndex, "packingType", val)
                                                            )}
                                                        </Grid>

                                                        <Grid item xs={12} md={3}>
                                                            <TextField
                                                                label="Unit"
                                                                type="number"
                                                                value={container.unitQuantity ?? ""}
                                                                onChange={(e) =>
                                                                    updateContainerRow(index, containerIndex, "unitQuantity", e.target.value)
                                                                }
                                                                inputProps={{min: 0}}
                                                                helperText={container.packingType ? `Number of ${container.packingType}` : "Number of packages"}
                                                                fullWidth
                                                                InputLabelProps={{shrink: true}}
                                                                sx={COMMON_INPUT_SX}
                                                            />
                                                        </Grid>

                                                        <Grid item xs={12} md={3}>
                                                            <DecimalTextField
                                                                label="Gross Weight (kg)"
                                                                decimals={3}
                                                                value={container.grossWeight ?? ""}
                                                                onChange={(e) =>
                                                                    updateContainerRow(index, containerIndex, "grossWeight", e.target.value)
                                                                }
                                                                fullWidth
                                                                InputLabelProps={{shrink: true}}
                                                                sx={COMMON_INPUT_SX}
                                                            />
                                                        </Grid>

                                                        <Grid item xs={12} md={3}>
                                                            <DecimalTextField
                                                                label="CBM"
                                                                decimals={4}
                                                                value={container.cbm ?? ""}
                                                                onChange={(e) =>
                                                                    updateContainerRow(index, containerIndex, "cbm", e.target.value)
                                                                }
                                                                fullWidth
                                                                InputLabelProps={{shrink: true}}
                                                                sx={COMMON_INPUT_SX}
                                                            />
                                                        </Grid>

                                                        <Grid item xs={12} md={6}>
                                                            <TextField
                                                                label="Description"
                                                                value={container.description || ""}
                                                                onChange={(e) =>
                                                                    updateContainerRow(index, containerIndex, "description", e.target.value)
                                                                }
                                                                fullWidth
                                                                InputLabelProps={{shrink: true}}
                                                                sx={COMMON_INPUT_SX}
                                                            />
                                                        </Grid>

                                                    </Grid>
                                                </MDBox>
                                            ))}
                                        </MDBox>

                                        {/* Description + ADR */}
                                        <Grid container spacing={3} mt={1} alignItems="center">
                                            <Grid item xs={12} sm={6}>
                                                <TextField
                                                    label="Description"
                                                    value={cargo.description}
                                                    onChange={(e) =>
                                                        updateCargoDetails(index, "description", e.target.value)
                                                    }
                                                    fullWidth
                                                    variant="outlined"
                                                />
                                            </Grid>

                                            <Grid item xs={12} sm={3}>
                                                <FormControlLabel
                                                    control={
                                                        <Switch
                                                            checked={isADR}
                                                            onChange={handleSwitchChange}
                                                        />
                                                    }
                                                    label="ADR / DG"
                                                />
                                            </Grid>

                                            {isADR && (
                                                <Grid item xs={12} sm={3}>
                                                    <Autocomplete
                                                        options={imcoOptions}
                                                        value={
                                                            imcoOptions.find(
                                                                (opt) => opt.label === imco
                                                            ) || null
                                                        }
                                                        onChange={handleIMCOChange}
                                                        getOptionLabel={(opt) => opt.label}
                                                        renderInput={(params) => (
                                                            <TextField
                                                                {...params}
                                                                label="IMCO Class"
                                                                variant="outlined"
                                                                fullWidth
                                                            />
                                                        )}
                                                    />
                                                </Grid>
                                            )}
                                        </Grid>
                                    </MDBox>
                                ))}
                            </MDBox>

                            {/* TOTALS */}
                            {["LTL-IMPORT", "LTL-EXPORT", "LTL-DOMESTIC", "LTL-TRANSIT"].includes(
                                selectedOceanTransportSubOption?.label
                            ) && (
                                <MDBox mt={4}>
                                    <MDTypography variant="h6">Total Values</MDTypography>
                                    <Grid container spacing={3} mt={1}>
                                        {[
                                            ["Total CBM", "totalCbm"]
                                        ].map(([label, key]) => (
                                            <Grid item xs={12} sm={3} key={key}>
                                                <TextField
                                                    label={label}
                                                    value={calculateTotals()[key]}
                                                    InputProps={{readOnly: true}}
                                                    fullWidth
                                                    variant="outlined"
                                                />
                                            </Grid>
                                        ))}
                                    </Grid>
                                </MDBox>
                            )}


                            <LocalizationProvider dateAdapter={AdapterDateFns} locale={tr}>
                                <MDBox mt={4}>
                                    <MDTypography variant="h6">Vessel Details</MDTypography>

                                    <Grid container spacing={3} mt={1}>
                                        <Grid item xs={12} md={3}>
                                            <TextField
                                                label="Vessel Name"
                                                value={vesselName}
                                                onChange={(e) => setVesselName(e.target.value)}
                                                fullWidth
                                                InputLabelProps={{shrink: true}}
                                            />
                                        </Grid>

                                        <Grid item xs={12} md={3}>
                                            <TextField
                                                label="Voyage Number"
                                                value={voyageNumber}
                                                onChange={(e) => setVoyageNumber(e.target.value)}
                                                fullWidth
                                                InputLabelProps={{shrink: true}}
                                            />
                                        </Grid>
                                    </Grid>

                                    <Grid container spacing={2} mt={1} alignItems="center">
                                        <Grid item xs={12} md={3}>
                                            <TextField
                                                select
                                                label="Services"
                                                value={vesselServiceType}
                                                onChange={(e) => setVesselServiceType(e.target.value)}
                                                fullWidth
                                                InputLabelProps={{shrink: true}}
                                            >
                                                <MenuItem value="Direct">Direct</MenuItem>
                                                <MenuItem value="T/Shipment">T/Shipment</MenuItem>
                                            </TextField>
                                        </Grid>

                                        {vesselServiceType === "T/Shipment" && (
                                            <Grid item xs={12} md="auto">
                                                <AddRowButton onClick={addTransshipment} label="Add T/Shipment" />
                                            </Grid>
                                        )}
                                    </Grid>

                                    {vesselServiceType === "T/Shipment" && (
                                        <MDBox mt={2}>
                                            {transshipments.map((item, index) => (
                                                <MDBox key={index} mt={2} p={2} border="1px solid #eee"
                                                       borderRadius={2}>
                                                    <Grid container spacing={2} alignItems="center">
                                                        <Grid item xs={12} md={3}>
                                                            <Autocomplete
                                                                options={countryOptions}
                                                                value={countryOptions.find((c) => c.label === item.country) || null}
                                                                onChange={(_e, newValue) => {
                                                                    updateTransshipment(index, "country", newValue?.label || "");
                                                                    updateTransshipment(index, "port", "");
                                                                }}
                                                                getOptionLabel={(option) => option?.label || ""}
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Country"
                                                                        fullWidth
                                                                        InputLabelProps={{shrink: true}}
                                                                    />
                                                                )}
                                                            />
                                                        </Grid>

                                                        <Grid item xs={12} md={3}>
                                                            <Autocomplete
                                                                freeSolo
                                                                options={transshipmentPortOptions[index] || []}
                                                                loading={!!transshipmentPortLoading[index]}
                                                                value={item.port || null}
                                                                onChange={(_e, newValue) =>
                                                                    updateTransshipment(index, "port", newValue || "")
                                                                }
                                                                onInputChange={(_e, newInputValue) =>
                                                                    updateTransshipment(index, "port", newInputValue || "")
                                                                }
                                                                renderInput={(params) => (
                                                                    <TextField
                                                                        {...params}
                                                                        label="Port"
                                                                        fullWidth
                                                                        InputLabelProps={{shrink: true}}
                                                                    />
                                                                )}
                                                            />
                                                        </Grid>

                                                        <Grid item xs={12} md={3}>
                                                            <DatePicker
                                                                label="ETA Date"
                                                                value={item.transshipmentEtaDate}
                                                                onChange={(newValue) =>
                                                                    updateTransshipment(index, "transshipmentEtaDate", newValue)
                                                                }
                                                                format="dd/MM/yyyy"
                                                                slotProps={{
                                                                    textField: {
                                                                        fullWidth: true,
                                                                        InputLabelProps: {shrink: true},
                                                                    },
                                                                }}
                                                            />
                                                        </Grid>

                                                        <Grid item xs={12} md={2}>
                                                            <TextField
                                                                label="ETA Time"
                                                                type="time"
                                                                value={item.transshipmentEtaTime}
                                                                onChange={(e) =>
                                                                    updateTransshipment(index, "transshipmentEtaTime", e.target.value)
                                                                }
                                                                fullWidth
                                                                InputLabelProps={{shrink: true}}
                                                                inputProps={{step: 900}}
                                                            />
                                                        </Grid>

                                                        <Grid item xs={12} md={1}>
                                                            <RemoveRowButton onClick={() => removeTransshipment(index)} tooltip="Remove transshipment" disabled={transshipments.length === 1} />
                                                        </Grid>
                                                    </Grid>
                                                </MDBox>
                                            ))}
                                        </MDBox>
                                    )}
                                </MDBox>
                            </LocalizationProvider>


                            {showPricing && (
                                <>
                                    {/* ================= PRICING DETAILS ================= */}
                                    <MDBox mt={3}>
                                        <MDTypography variant="h6">Pricing Details</MDTypography>
                                    </MDBox>

                                    <Grid container spacing={2} mt={1}>
                                        {customDetail?.responsibility && (
                                            <>
                                                <Grid item xs={3}>
                                                    <TextField
                                                        type="number"
                                                        label="Export Customs Clearance Rate"
                                                        placeholder="Enter Export Customs Rate"
                                                        value={exportCustomsRate}
                                                        onChange={(e) => setExportCustomsRate(e.target.value)}
                                                        fullWidth
                                                        variant="outlined"
                                                        InputLabelProps={{shrink: true}}
                                                        sx={PRICING_INPUT_SX}
                                                    />
                                                </Grid>

                                                <Grid item xs={3}>
                                                    <TextField
                                                        select
                                                        label="Currency"
                                                        value={exportCustomsRateCurrency}
                                                        onChange={(e) => setExportCustomsRateCurrency(e.target.value)}
                                                        fullWidth
                                                        variant="outlined"
                                                        InputLabelProps={{shrink: true}}
                                                        sx={PRICING_INPUT_SX}
                                                    >
                                                        {["USD", "EUR", "GBP", "TRY"].map((c) => (
                                                            <MenuItem key={c} value={c}>{c}</MenuItem>
                                                        ))}
                                                    </TextField>
                                                </Grid>
                                            </>
                                        )}

                                        {customDetail?.responsibilityImport && (
                                            <>
                                                <Grid item xs={3}>
                                                    <TextField
                                                        type="number"
                                                        label="Import Customs Clearance Rate"
                                                        placeholder="Enter Import Customs Rate"
                                                        value={importCustomsRate}
                                                        onChange={(e) => setImportCustomsRate(e.target.value)}
                                                        fullWidth
                                                        variant="outlined"
                                                        InputLabelProps={{shrink: true}}
                                                        sx={PRICING_INPUT_SX}
                                                    />
                                                </Grid>

                                                <Grid item xs={3}>
                                                    <TextField
                                                        select
                                                        label="Currency"
                                                        value={importCustomsRateCurrency}
                                                        onChange={(e) => setImportCustomsRateCurrency(e.target.value)}
                                                        fullWidth
                                                        variant="outlined"
                                                        InputLabelProps={{shrink: true}}
                                                        sx={PRICING_INPUT_SX}
                                                    >
                                                        {["USD", "EUR", "GBP", "TRY"].map((c) => (
                                                            <MenuItem key={c} value={c}>{c}</MenuItem>
                                                        ))}
                                                    </TextField>
                                                </Grid>
                                            </>
                                        )}
                                    </Grid>
                                </>
                            )}

                            {/* ================= SELLING RATE ================= */}
                            <MDBox
                                mt={4}
                                sx={{
                                    p: {xs: 2, md: 2.5},
                                    borderRadius: "18px",
                                    border: "1px solid rgba(203,213,225,0.9)",
                                    background:
                                        "linear-gradient(180deg, rgba(255,255,255,0.96) 0%, rgba(248,250,252,0.98) 100%)",
                                    boxShadow:
                                        "0 12px 30px rgba(15,23,42,0.06), inset 0 1px 0 rgba(255,255,255,0.85)",
                                    position: "relative",
                                    overflow: "hidden",
                                    "&::before": {
                                        content: '""',
                                        position: "absolute",
                                        left: 0,
                                        top: 0,
                                        bottom: 0,
                                        width: "5px",
                                        background: "linear-gradient(180deg, #22c55e, #0ea5e9)",
                                    }
                                }}>
                                <MDBox display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                                    <MDBox>
                                        <MDTypography variant="h6" fontWeight="bold">
                                            Ocean Freight Selling Rate
                                        </MDTypography>
                                        <MDTypography variant="caption" color="text">
                                            Base selling rate and additional ocean fee breakdown
                                        </MDTypography>
                                    </MDBox>

                                    <MDBox
                                        sx={{
                                            px: 2,
                                            py: 1,
                                            borderRadius: "14px",
                                            backgroundColor: "rgba(25,118,210,0.08)",
                                            border: "1px solid rgba(25,118,210,0.18)",
                                            textAlign: "right",
                                        }}
                                    >
                                        <MDTypography variant="caption" color="text">
                                            Final Selling Rate
                                        </MDTypography>
                                        <MDTypography variant="h6" fontWeight="bold" color="info">
                                            {Number(finalSellingRate || 0).toFixed(2)} {sellingRateCurrency}
                                        </MDTypography>
                                    </MDBox>
                                </MDBox>

                                <Grid container spacing={2}>
                                    <Grid item xs={12} md={3}>
                                        <TextField
                                            type="number"
                                            label="Base Ocean Freight Selling Rate"
                                            placeholder="Enter Selling Rate"
                                            value={sellingRate}
                                            onChange={(e) => setSellingRate(e.target.value)}
                                            fullWidth
                                            variant="outlined"
                                            InputLabelProps={{shrink: true}}
                                            sx={PRICING_INPUT_SX}
                                        />
                                    </Grid>

                                    <Grid item xs={12} md={2}>
                                        <TextField
                                            select
                                            label="Currency"
                                            value={sellingRateCurrency}
                                            onChange={(e) => setSellingRateCurrency(e.target.value)}
                                            fullWidth
                                            variant="outlined"
                                            InputLabelProps={{shrink: true}}
                                            sx={PRICING_INPUT_SX}
                                        >
                                            {["USD", "EUR", "GBP", "TRY"].map((c) => (
                                                <MenuItem key={c} value={c}>
                                                    {c}
                                                </MenuItem>
                                            ))}
                                        </TextField>
                                    </Grid>

                                    <Grid item xs={12} md={1}>
                                        <AddRowButton onClick={addAdditionalFee} label="Add Fee" />
                                    </Grid>
                                </Grid>

                                <MDBox mt={3}>
                                    <MDTypography variant="button" fontWeight="bold">
                                        Additional Fees
                                    </MDTypography>
                                </MDBox>

                                {additionalFees.map((row, index) => (
                                    <MDBox
                                        key={index}
                                        mt={1.5}
                                        sx={{
                                            p: 2,
                                            borderRadius: "16px",
                                            border: "1px solid rgba(226,232,240,0.9)",
                                            backgroundColor: "#fff",
                                        }}
                                    >
                                        <Grid container spacing={2} alignItems="center">
                                            <Grid item xs={12} md={1}>
                                                <MDBox
                                                    sx={{
                                                        width: 34,
                                                        height: 34,
                                                        borderRadius: "10px",
                                                        backgroundColor: "rgba(15,23,42,0.06)",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        fontWeight: "bold",
                                                    }}
                                                >
                                                    {index + 1}
                                                </MDBox>
                                            </Grid>

                                            <Grid item xs={12} md={3}>
                                                <Autocomplete
                                                    freeSolo
                                                    options={additionalFeeOptions}
                                                    renderOption={({ key: optionKey, ...props }, option) => (
                                                        <li {...props} key={feeLabelOf(option)}>
                                                            <span style={{flex: 1}}>{feeLabelOf(option)}</span>
                                                            <IconButton
                                                                size="small"
                                                                title="Rename this fee"
                                                                onClick={(event) => {
                                                                    event.stopPropagation();
                                                                    setFeeOptionDialog({
                                                                        open: true,
                                                                        original: feeLabelOf(option),
                                                                        value: feeLabelOf(option),
                                                                    });
                                                                }}
                                                            >
                                                                <EditIcon fontSize="small"/>
                                                            </IconButton>
                                                            <IconButton
                                                                size="small"
                                                                title="Remove this fee from the list"
                                                                onClick={(event) => {
                                                                    event.stopPropagation();
                                                                    deleteFeeOption(feeLabelOf(option));
                                                                }}
                                                            >
                                                                <DeleteIcon fontSize="small"/>
                                                            </IconButton>
                                                        </li>
                                                    )}
                                                    sx={{
                                                        "& .MuiOutlinedInput-root": {
                                                            minHeight: 56,
                                                            alignItems: "center",
                                                            pr: "8px !important",
                                                        },
                                                        "& .MuiAutocomplete-endAdornment": {
                                                            right: "72px !important",
                                                        },
                                                    }}
                                                    value={row.fee || ""}
                                                    inputValue={row.fee || ""}
                                                    getOptionLabel={(option) =>
                                                        typeof option === "string" ? option : option?.label || ""
                                                    }
                                                    onInputChange={(_event, newInputValue) => {
                                                        updateAdditionalFee(index, "fee", newInputValue);
                                                    }}
                                                    onChange={(_event, newValue) => {
                                                        const value =
                                                            typeof newValue === "string" ? newValue : newValue?.label || "";

                                                        updateAdditionalFee(index, "fee", value);
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            label="Fee"
                                                            fullWidth
                                                            InputLabelProps={{shrink: true}}
                                                            InputProps={{
                                                                ...params.InputProps,
                                                                endAdornment: (
                                                                    <MDBox
                                                                        display="flex"
                                                                        alignItems="center"
                                                                        gap={0.75}
                                                                        sx={{
                                                                            height: "100%",
                                                                            mr: 0.5,
                                                                            "& .MuiAutocomplete-endAdornment": {
                                                                                position: "static",
                                                                                transform: "none",
                                                                            },
                                                                        }}
                                                                    >
                                                                        {params.InputProps.endAdornment}

                                                                        <Button
                                                                            size="small"
                                                                            variant="contained"
                                                                            onMouseDown={(e) => e.preventDefault()}
                                                                            onClick={() => saveNewFeeOption(row.fee)}
                                                                            sx={{
                                                                                minWidth: 56,
                                                                                height: 28,
                                                                                px: 1.25,
                                                                                borderRadius: "8px",
                                                                                textTransform: "none",
                                                                                fontSize: "12px",
                                                                                lineHeight: 1,
                                                                                backgroundColor: "#1976d2",
                                                                                color: "#fff",
                                                                                boxShadow: "0 3px 8px rgba(25,118,210,0.25)",
                                                                                "&:hover": {
                                                                                    backgroundColor: "#1565c0",
                                                                                },
                                                                            }}
                                                                        >
                                                                            Add
                                                                        </Button>
                                                                    </MDBox>
                                                                )
                                                            }}
                                                        />
                                                    )}
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={1.5}>
                                                <TextField
                                                    type="number"
                                                    label="Unit"
                                                    value={row.unit ?? 1}
                                                    onChange={(e) => updateAdditionalFee(index, "unit", e.target.value)}
                                                    inputProps={{min: 0, step: 1}}
                                                    fullWidth
                                                    InputLabelProps={{shrink: true}}
                                                    sx={PRICING_INPUT_SX}
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={2}>
                                                <TextField
                                                    type="number"
                                                    label="Rate"
                                                    value={row.rate}
                                                    onChange={(e) => updateAdditionalFee(index, "rate", e.target.value)}
                                                    fullWidth
                                                    InputLabelProps={{shrink: true}}
                                                    sx={PRICING_INPUT_SX}
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={1.5}>
                                                <TextField
                                                    select
                                                    label="Currency"
                                                    value={row.currency}
                                                    onChange={(e) => updateAdditionalFee(index, "currency", e.target.value)}
                                                    fullWidth
                                                    InputLabelProps={{shrink: true}}
                                                    sx={PRICING_INPUT_SX}
                                                >
                                                    {["USD", "EUR", "GBP", "TRY"].map((c) => (
                                                        <MenuItem key={c} value={c}>
                                                            {c}
                                                        </MenuItem>
                                                    ))}
                                                </TextField>
                                            </Grid>

                                            <Grid item xs={12} md={2}>
                                                <TextField
                                                    label="Total"
                                                    value={`${getFeeLineAmount(row).toFixed(2)} ${row.currency || ""}`}
                                                    InputProps={{readOnly: true}}
                                                    fullWidth
                                                    InputLabelProps={{shrink: true}}
                                                    sx={PRICING_INPUT_SX}
                                                />
                                            </Grid>

                                            <Grid item xs={12} md={1}>
                                                <RemoveRowButton onClick={() => removeAdditionalFee(index)} tooltip="Remove fee" disabled={additionalFees.length === 1} />
                                            </Grid>
                                        </Grid>
                                    </MDBox>
                                ))}

                                <MDBox
                                    mt={3}
                                    sx={{
                                        p: {xs: 2, md: 2.5},
                                        borderRadius: "18px",
                                        border: "1px solid rgba(203,213,225,0.9)",
                                        background:
                                            "linear-gradient(180deg, rgba(255,255,255,0.96) 0%, rgba(248,250,252,0.98) 100%)",
                                        boxShadow:
                                            "0 12px 30px rgba(15,23,42,0.06), inset 0 1px 0 rgba(255,255,255,0.85)",
                                        position: "relative",
                                        overflow: "hidden",
                                        "&::before": {
                                            content: '""',
                                            position: "absolute",
                                            left: 0,
                                            top: 0,
                                            bottom: 0,
                                            width: "5px",
                                            background: "linear-gradient(180deg, #22c55e, #0ea5e9)",
                                        }
                                    }}
                                >
                                    <Grid container spacing={2}>

                                        {/* BASE */}
                                        <Grid item xs={12} md={4}>
                                            <MDTypography variant="caption" color="text">
                                                Base Selling Rate
                                            </MDTypography>
                                            <MDTypography variant="button" fontWeight="bold" display="block">
                                                {Number(sellingRate || 0).toFixed(2)} {sellingRateCurrency}
                                            </MDTypography>
                                        </Grid>

                                        {/* ADDITIONAL */}
                                        <Grid item xs={12} md={4}>
                                            <MDTypography variant="caption" color="text">
                                                Additional Fees (Converted)
                                            </MDTypography>
                                            <MDTypography variant="button" fontWeight="bold" display="block">
                                                {convertedAdditionalTotal.toFixed(2)} {sellingRateCurrency}
                                            </MDTypography>

                                            <MDTypography variant="caption" sx={{opacity: 0.7}}>
                                                Multi-currency normalized (rate x unit)
                                            </MDTypography>
                                        </Grid>

                                        {/* FINAL */}
                                        <Grid item xs={12} md={4}>
                                            <MDTypography variant="caption" color="text">
                                                Final Selling Rate
                                            </MDTypography>

                                            <MDTypography
                                                variant="h6"
                                                fontWeight="bold"
                                                sx={{
                                                    color: "#16a34a",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: 0.5,
                                                }}
                                            >
                                                {Number(finalSellingRate || 0).toFixed(2)} {sellingRateCurrency}
                                            </MDTypography>
                                        </Grid>

                                    </Grid>
                                </MDBox>
                            </MDBox>

                            <MDBox mt={3}>
                                <MDTypography variant="h6"> Shipment History Details</MDTypography>
                            </MDBox>

                            <MDBox mt={5}>
                                <Grid container spacing={3}>
                                    <LocalizationProvider dateAdapter={AdapterDateFns} locale={tr}>
                                        {/* First Row */}
                                        <Grid container spacing={3} ml={0}>
                                            {/* ========== ADD ========= */}
                                            <Grid item xs={6} md={2}>
                                                <DatePicker
                                                    label="ADD"
                                                    value={actualDelivery}
                                                    onChange={setActualDelivery}
                                                    format="dd/MM/yyyy"
                                                    slotProps={{
                                                        textField: {
                                                            variant: "outlined",
                                                            fullWidth: true,
                                                            InputLabelProps: {
                                                                shrink: true,
                                                                component: LabelWithTooltip({
                                                                    label: "ADD",
                                                                    tooltip: "Actual Delivery Date",
                                                                }),
                                                            },
                                                            sx: COMMON_INPUT_SX,
                                                        },
                                                        actionBar: {actions: ["clear", "accept"]},
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item xs={1}>
                                                <TextField
                                                    variant="outlined"
                                                    label="Time"
                                                    type="time"
                                                    value={actualDeliveryTime}
                                                    onChange={(e) => setActualDeliveryTime(e.target.value)}
                                                    InputLabelProps={{shrink: true}}
                                                    inputProps={{step: 900}}
                                                    placeholder="hh:mm"
                                                    fullWidth
                                                    sx={COMMON_INPUT_SX}
                                                />
                                            </Grid>

                                            <Grid item xs={6} md={2}>
                                                <DatePicker
                                                    label="POD"
                                                    value={proofOfDelivery}
                                                    onChange={setProofOfDelivery}
                                                    format="dd/MM/yyyy"
                                                    slotProps={{
                                                        textField: {
                                                            variant: "outlined",
                                                            fullWidth: true,
                                                            InputLabelProps: {
                                                                shrink: true,
                                                                component: LabelWithTooltip({
                                                                    label: "POD",
                                                                    tooltip: "Proof of Delivery",
                                                                }),
                                                            },
                                                            sx: COMMON_INPUT_SX,
                                                        },
                                                        actionBar: {actions: ["clear", "accept"]},
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item xs={1}>
                                                <TextField
                                                    variant="outlined"
                                                    label="Time"
                                                    type="time"
                                                    value={proofOfDeliveryTime}
                                                    onChange={(e) => setProofOfDeliveryTime(e.target.value)}
                                                    InputLabelProps={{shrink: true}}
                                                    inputProps={{step: 900}}
                                                    placeholder="hh:mm"
                                                    fullWidth
                                                    sx={COMMON_INPUT_SX}
                                                />
                                            </Grid>

                                            <Grid item xs={6} md={2}>
                                                <DatePicker
                                                    label="APT"
                                                    value={appointmentDate}
                                                    onChange={setAppointmentDate}
                                                    format="dd/MM/yyyy"
                                                    slotProps={{
                                                        textField: {
                                                            variant: "outlined",
                                                            fullWidth: true,
                                                            InputLabelProps: {
                                                                shrink: true,
                                                                component: LabelWithTooltip({
                                                                    label: "APT",
                                                                    tooltip: "Appointment Date",
                                                                }),
                                                            },
                                                            sx: COMMON_INPUT_SX,
                                                        },
                                                        actionBar: {actions: ["clear", "accept"]},
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item xs={1}>
                                                <TextField
                                                    variant="outlined"
                                                    label="Time"
                                                    type="time"
                                                    value={appointmentTime}
                                                    onChange={(e) => setAppointmentTime(e.target.value)}
                                                    InputLabelProps={{shrink: true}}
                                                    inputProps={{step: 900}}
                                                    placeholder="hh:mm"
                                                    fullWidth
                                                    sx={COMMON_INPUT_SX}
                                                />
                                            </Grid>
                                            <Grid item xs={6} md={2}>
                                                <DatePicker
                                                    label="BC"
                                                    value={bookingConfirmationDate}
                                                    onChange={setBookingConfirmationDate}
                                                    format="dd/MM/yyyy"
                                                    slotProps={{
                                                        textField: {
                                                            variant: "outlined",
                                                            fullWidth: true,
                                                            InputLabelProps: {
                                                                shrink: true,
                                                                component: LabelWithTooltip({
                                                                    label: "BC",
                                                                    tooltip: "Booking Confirmation Date",
                                                                }),
                                                            },
                                                            sx: COMMON_INPUT_SX,
                                                        },
                                                        actionBar: {actions: ["clear", "accept"]},
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item xs={1}>
                                                <TextField
                                                    variant="outlined"
                                                    label="Time"
                                                    type="time"
                                                    value={bookingConfirmationTime}
                                                    onChange={(e) => setBookingConfirmationTime(e.target.value)}
                                                    InputLabelProps={{shrink: true}}
                                                    inputProps={{step: 900}}
                                                    placeholder="hh:mm"
                                                    fullWidth
                                                    sx={COMMON_INPUT_SX}
                                                />
                                            </Grid>
                                            <Grid item xs={6} md={2}>
                                                <DatePicker
                                                    label="Gate-in Without Storage"
                                                    value={gateInWithoutStorageDate}
                                                    onChange={setGateInWithoutStorageDate}
                                                    format="dd/MM/yyyy"
                                                    slotProps={{
                                                        textField: {
                                                            variant: "outlined",
                                                            fullWidth: true,
                                                            InputLabelProps: {
                                                                shrink: true,
                                                                component: LabelWithTooltip({
                                                                    label: "Gate-in Without Storage",
                                                                    tooltip: "Gate-in Without Storage Date",
                                                                }),
                                                            },
                                                            sx: COMMON_INPUT_SX,
                                                        },
                                                        actionBar: {actions: ["clear", "accept"]},
                                                    }}
                                                />
                                            </Grid>

                                            <Grid item xs={1}>
                                                <TextField
                                                    variant="outlined"
                                                    label="Time"
                                                    type="time"
                                                    value={gateInWithoutStorageTime}
                                                    onChange={(e) => setGateInWithoutStorageTime(e.target.value)}
                                                    InputLabelProps={{shrink: true}}
                                                    inputProps={{step: 900}}
                                                    placeholder="hh:mm"
                                                    fullWidth
                                                    sx={COMMON_INPUT_SX}
                                                />
                                            </Grid>

                                            <Grid item xs={6} md={1}>
                                                <TextField
                                                    variant="outlined"
                                                    type="number"
                                                    label="ETT (days)"
                                                    value={transitTime}
                                                    InputProps={{readOnly: true}}
                                                    fullWidth
                                                    InputLabelProps={{
                                                        shrink: true,
                                                        component: LabelWithTooltip({
                                                            label: "ETT (days)",
                                                            tooltip: "Estimated Transit Time (Days)",
                                                        }),
                                                    }}
                                                    sx={COMMON_INPUT_SX}
                                                />
                                            </Grid>

                                            <Grid item xs={6} md={1}>
                                                <TextField
                                                    variant="outlined"
                                                    type="number"
                                                    label="Week"
                                                    value={calculateWeekNumber()}
                                                    InputProps={{readOnly: true}}
                                                    fullWidth
                                                    InputLabelProps={{shrink: true}}
                                                    sx={COMMON_INPUT_SX}
                                                />
                                            </Grid>
                                        </Grid>

                                        {/* Second Row */}
                                        <Grid container spacing={3} ml={0} mt={2}>

                                        </Grid>
                                    </LocalizationProvider>
                                </Grid>
                            </MDBox>

                            <MDBox mt={4} ml={3}>
                                <MDTypography variant="h6">DOCUMENTS</MDTypography>
                            </MDBox>
                            <MDBox mt={4}>
                                <MDBox
                                    sx={{
                                        display: "flex",
                                        flexWrap: "nowrap",
                                        gap: 2,
                                        overflowX: "auto",
                                        alignItems: "flex-start",
                                        pb: 1,
                                    }}
                                >
                                    {customDetail.responsibility && (
                                        <MDBox sx={{minWidth: 120, maxWidth: 120, flex: "0 0 120px"}}>
                                            <MDBox display="flex" flexDirection="column" alignItems="center">
                                                <MDTypography variant="caption" display="block" sx={TITLE_SX}>
                                                    Export Declaration
                                                </MDTypography>
                                                <MDBox sx={DROPZONE_WRAPPER_SX}>
                                                    <MDDropzone
                                                        options={{
                                                            addRemoveLinks: true,
                                                            maxFilesize: 10000,
                                                            maxFiles: 1,
                                                            acceptedFiles: ".pdf,.doc,.docx,.png,.jpg",
                                                            timeout: 0
                                                        }}
                                                        onChange={(files) => setExportDeclaration(files)}
                                                        style={DZ_STYLE}
                                                    />
                                                </MDBox>
                                                <UploadedFilePreview
                                                    file={exportDeclaration}
                                                    layout="stack"
                                                    onRemove={() => setExportDeclaration(null)}
                                                />
                                            </MDBox>
                                        </MDBox>
                                    )}

                                    {customDetail.responsibilityImport && (
                                        <MDBox sx={{minWidth: 120, maxWidth: 120, flex: "0 0 120px"}}>
                                            <MDBox display="flex" flexDirection="column" alignItems="center">
                                                <MDTypography variant="caption" display="block" sx={TITLE_SX}>
                                                    Import Declaration
                                                </MDTypography>
                                                <MDBox sx={DROPZONE_WRAPPER_SX}>
                                                    <MDDropzone
                                                        options={{
                                                            addRemoveLinks: true,
                                                            maxFilesize: 10000,
                                                            maxFiles: 1,
                                                            acceptedFiles: ".pdf,.doc,.docx,.png,.jpg",
                                                            timeout: 0
                                                        }}
                                                        onChange={(files) => setImportDeclaration(files)}
                                                        style={DZ_STYLE}
                                                    />
                                                </MDBox>
                                                <UploadedFilePreview
                                                    file={importDeclaration}
                                                    layout="stack"
                                                    onRemove={() => setImportDeclaration([])}
                                                />
                                            </MDBox>
                                        </MDBox>
                                    )}

                                    <MDBox sx={{minWidth: 120, maxWidth: 120, flex: "0 0 120px"}}>
                                        <MDBox display="flex" flexDirection="column" alignItems="center">
                                            <MDTypography variant="caption" display="block" sx={TITLE_SX}>
                                                ATR
                                            </MDTypography>
                                            <MDBox sx={DROPZONE_WRAPPER_SX}>
                                                <MDDropzone
                                                    options={{
                                                        addRemoveLinks: true,
                                                        maxFilesize: 10000,
                                                        maxFiles: 1,
                                                        acceptedFiles: ".pdf,.doc,.docx,.png,.jpg",
                                                        timeout: 0
                                                    }}
                                                    onChange={(file) => setAtr(file)}
                                                    style={DZ_STYLE}
                                                />
                                            </MDBox>
                                            <UploadedFilePreview file={atr} layout="stack" onRemove={() => setAtr([])}/>
                                        </MDBox>
                                    </MDBox>

                                    <MDBox sx={{minWidth: 120, maxWidth: 120, flex: "0 0 120px"}}>
                                        <MDBox display="flex" flexDirection="column" alignItems="center">
                                            <MDTypography variant="caption" display="block" sx={TITLE_SX}>
                                                Approved Mail
                                            </MDTypography>
                                            <MDBox sx={DROPZONE_WRAPPER_SX}>
                                                <MDDropzone
                                                    options={{
                                                        addRemoveLinks: true,
                                                        maxFilesize: 10000,
                                                        maxFiles: 1,
                                                        acceptedFiles: ".pdf,.doc,.docx,.png,.jpg",
                                                        timeout: 0
                                                    }}
                                                    onChange={(files) => setConfirmationMail(files)}
                                                    style={DZ_STYLE}
                                                />
                                            </MDBox>
                                            <UploadedFilePreview
                                                file={confirmationMail}
                                                layout="stack"
                                                onRemove={() => setConfirmationMail([])}
                                            />
                                        </MDBox>
                                    </MDBox>

                                    <MDBox sx={{minWidth: 120, maxWidth: 120, flex: "0 0 120px"}}>
                                        <MDBox display="flex" flexDirection="column" alignItems="center">
                                            <MDTypography variant="caption" display="block" sx={TITLE_SX}>
                                                Packing List
                                            </MDTypography>
                                            <MDBox sx={DROPZONE_WRAPPER_SX}>
                                                <MDDropzone
                                                    options={{
                                                        addRemoveLinks: true,
                                                        maxFilesize: 10000,
                                                        maxFiles: 1,
                                                        acceptedFiles: ".pdf,.doc,.docx,.png,.jpg",
                                                        timeout: 0
                                                    }}
                                                    onChange={(files) => setPackingList(files)}
                                                    style={DZ_STYLE}
                                                />
                                            </MDBox>
                                            <UploadedFilePreview
                                                file={packingList}
                                                layout="stack"
                                                onRemove={() => setPackingList([])}
                                            />
                                        </MDBox>
                                    </MDBox>

                                    <MDBox sx={{minWidth: 120, maxWidth: 120, flex: "0 0 120px"}}>
                                        <MDBox display="flex" flexDirection="column" alignItems="center">
                                            <MDTypography variant="caption" display="block" sx={TITLE_SX}>
                                                Commercial Invoice
                                            </MDTypography>
                                            <MDBox sx={DROPZONE_WRAPPER_SX}>
                                                <MDDropzone
                                                    options={{
                                                        addRemoveLinks: true,
                                                        maxFilesize: 10000,
                                                        maxFiles: 1,
                                                        acceptedFiles: ".pdf,.doc,.docx,.png,.jpg",
                                                        timeout: 0
                                                    }}
                                                    onChange={(files) => setCommercialInvoice(files)}
                                                    style={DZ_STYLE}
                                                />
                                            </MDBox>
                                            <UploadedFilePreview
                                                file={commercialInvoice}
                                                layout="stack"
                                                onRemove={() => setCommercialInvoice([])}
                                            />
                                        </MDBox>
                                    </MDBox>

                                    <MDBox sx={{minWidth: 120, maxWidth: 120, flex: "0 0 120px"}}>
                                        <MDBox display="flex" flexDirection="column" alignItems="center">
                                            <MDTypography variant="caption" display="block" sx={TITLE_SX}>
                                                Booking Confirmation
                                            </MDTypography>
                                            <MDBox sx={DROPZONE_WRAPPER_SX}>
                                                <MDDropzone
                                                    options={{
                                                        addRemoveLinks: true,
                                                        maxFilesize: 10000,
                                                        maxFiles: 1,
                                                        acceptedFiles: ".pdf,.doc,.docx,.png,.jpg",
                                                        timeout: 0
                                                    }}
                                                    onChange={(files) => setBookingConfirmationPdf(files)}
                                                    style={DZ_STYLE}
                                                />
                                            </MDBox>
                                            <UploadedFilePreview
                                                file={bookingConfirmationPdf}
                                                layout="stack"
                                                onRemove={() => setBookingConfirmationPdf([])}
                                            />
                                        </MDBox>
                                    </MDBox>

                                    <MDBox sx={{minWidth: 150, maxWidth: 150, flex: "0 0 120px"}}>
                                        <MDBox display="flex" flexDirection="column" alignItems="center">
                                            <MDTypography variant="caption" display="block" sx={TITLE_SX}>
                                                Linehaul Carrier
                                            </MDTypography>
                                            <MDBox sx={DROPZONE_WRAPPER_SX}>
                                                <MDDropzone
                                                    options={{
                                                        addRemoveLinks: true,
                                                        maxFilesize: 10000,
                                                        maxFiles: 1,
                                                        acceptedFiles: ".pdf,.doc,.docx,.png,.jpg",
                                                        timeout: 0
                                                    }}
                                                    onChange={(files) => setLinehaulCarrier(files)}
                                                    style={DZ_STYLE}
                                                />
                                            </MDBox>
                                            <UploadedFilePreview
                                                file={linehaulCarrier}
                                                layout="stack"
                                                onRemove={() => setLinehaulCarrier([])}
                                            />
                                        </MDBox>
                                    </MDBox>

                                    <MDBox sx={{minWidth: 150, maxWidth: 150, flex: "0 0 120px"}}>
                                        <MDBox display="flex" flexDirection="column" alignItems="center">
                                            <MDTypography variant="caption" display="block" sx={TITLE_SX}>
                                                Vendor Invoice (Pickup Carrier)
                                            </MDTypography>
                                            <MDBox sx={DROPZONE_WRAPPER_SX}>
                                                <MDDropzone
                                                    options={{
                                                        addRemoveLinks: true,
                                                        maxFilesize: 10000,
                                                        maxFiles: 1,
                                                        acceptedFiles: ".pdf,.doc,.docx,.png,.jpg",
                                                        timeout: 0
                                                    }}
                                                    onChange={(files) => setPickupCarrier(files)}
                                                    style={DZ_STYLE}
                                                />
                                            </MDBox>
                                            <UploadedFilePreview
                                                file={pickupCarrier}
                                                layout="stack"
                                                onRemove={() => setPickupCarrier([])}
                                            />
                                        </MDBox>
                                    </MDBox>

                                    <MDBox sx={{minWidth: 150, maxWidth: 150, flex: "0 0 120px"}}>
                                        <MDBox display="flex" flexDirection="column" alignItems="center">
                                            <MDTypography variant="caption" display="block" sx={TITLE_SX}>
                                                Vendor Invoice (Delivery Carrier)
                                            </MDTypography>
                                            <MDBox sx={DROPZONE_WRAPPER_SX}>
                                                <MDDropzone
                                                    options={{
                                                        addRemoveLinks: true,
                                                        maxFilesize: 10000,
                                                        maxFiles: 1,
                                                        acceptedFiles: ".pdf,.doc,.docx,.png,.jpg",
                                                        timeout: 0
                                                    }}
                                                    onChange={(files) => setDeliveryCarrierInvoice(files)}
                                                    style={DZ_STYLE}
                                                />
                                            </MDBox>
                                            <UploadedFilePreview
                                                file={deliveryCarrierInvoice}
                                                layout="stack"
                                                onRemove={() => setDeliveryCarrierInvoice([])}
                                            />
                                        </MDBox>
                                    </MDBox>

                                    {customDetail?.responsibility && (
                                        <MDBox sx={{minWidth: 160, maxWidth: 160, flex: "0 0 120px"}}>
                                            <MDBox display="flex" flexDirection="column" alignItems="center">
                                                <MDTypography variant="caption" display="block" sx={TITLE_SX}>
                                                    Vendor Invoice (Carrier Export Custom Broker)
                                                </MDTypography>
                                                <MDBox sx={DROPZONE_WRAPPER_SX}>
                                                    <MDDropzone
                                                        options={{
                                                            addRemoveLinks: true,
                                                            maxFilesize: 10000,
                                                            maxFiles: 1,
                                                            acceptedFiles: ".pdf,.doc,.docx,.png,.jpg",
                                                            timeout: 0,
                                                        }}
                                                        onChange={(files) => setCarrierBroker(files)}
                                                        style={DZ_STYLE}
                                                    />
                                                </MDBox>
                                                <UploadedFilePreview
                                                    file={carrierBroker}
                                                    layout="stack"
                                                    onRemove={() => setCarrierBroker([])}
                                                />
                                            </MDBox>
                                        </MDBox>
                                    )}

                                    {customDetail?.responsibilityImport && (
                                        <MDBox sx={{minWidth: 180, maxWidth: 180, flex: "0 0 120px"}}>
                                            <MDBox display="flex" flexDirection="column" alignItems="center">
                                                <MDTypography variant="caption" display="block" sx={TITLE_SX}>
                                                    Vendor Invoice (Carrier Import Custom Broker)
                                                </MDTypography>
                                                <MDBox sx={DROPZONE_WRAPPER_SX}>
                                                    <MDDropzone
                                                        options={{
                                                            addRemoveLinks: true,
                                                            maxFilesize: 10000,
                                                            maxFiles: 1,
                                                            acceptedFiles: ".pdf,.doc,.docx,.png,.jpg",
                                                            timeout: 0,
                                                        }}
                                                        onChange={(files) => setCarrierImportCustomBrokerInvoice(files)}
                                                        style={DZ_STYLE}
                                                    />
                                                </MDBox>
                                                <UploadedFilePreview
                                                    file={carrierImportCustomBrokerInvoice}
                                                    layout="stack"
                                                    onRemove={() => setCarrierImportCustomBrokerInvoice([])}
                                                />
                                            </MDBox>
                                        </MDBox>
                                    )}

                                    {proofOfDelivery && (
                                        <MDBox sx={{minWidth: 120, maxWidth: 120, flex: "0 0 120px"}}>
                                            <MDBox display="flex" flexDirection="column" alignItems="center">
                                                <MDTypography variant="caption" display="block" sx={TITLE_SX}>
                                                    Proof of Delivery
                                                </MDTypography>
                                                <MDBox sx={DROPZONE_WRAPPER_SX}>
                                                    <MDDropzone
                                                        options={{
                                                            addRemoveLinks: true,
                                                            maxFilesize: 10000,
                                                            maxFiles: 1,
                                                            acceptedFiles: ".pdf,.doc,.docx,.png,.jpg",
                                                            timeout: 0
                                                        }}
                                                        onChange={(files) => setSignedCmr(files)}
                                                        style={DZ_STYLE}
                                                    />
                                                </MDBox>
                                                <UploadedFilePreview
                                                    file={signedCmr}
                                                    layout="stack"
                                                    onRemove={() => setSignedCmr([])}
                                                />
                                            </MDBox>
                                        </MDBox>
                                    )}

                                    {proofOfDelivery && (
                                        <MDBox sx={{minWidth: 120, maxWidth: 120, flex: "0 0 120px"}}>
                                            <MDBox display="flex" flexDirection="column" alignItems="center">
                                                <MDTypography variant="caption" display="block" sx={TITLE_SX}>
                                                    Closed T1/T2
                                                </MDTypography>
                                                <MDBox sx={DROPZONE_WRAPPER_SX}>
                                                    <MDDropzone
                                                        options={{
                                                            addRemoveLinks: true,
                                                            maxFilesize: 10000,
                                                            maxFiles: 1,
                                                            acceptedFiles: ".pdf,.doc,.docx,.png,.jpg",
                                                            timeout: 0
                                                        }}
                                                        onChange={(files) => setClosedT1t2(files)}
                                                        style={DZ_STYLE}
                                                    />
                                                </MDBox>
                                                <UploadedFilePreview
                                                    file={closedT1t2}
                                                    layout="stack"
                                                    onRemove={() => setClosedT1t2([])}
                                                />
                                            </MDBox>
                                        </MDBox>
                                    )}
                                </MDBox>
                            </MDBox> </MDBox>
                    </Grid>
                </Grid>
            </MDBox>
            <div style={{display: "flex", gap: "10px", flexWrap: "wrap"}}>
                <Button
                    variant="contained"
                    onClick={(e) => submitHandler(e, "shipment")}
                    disabled={loading}
                    style={{backgroundColor: "#4CAF50", color: "#FFFFFF"}}
                >
                    {isEditing ? "Update Shipment" : "Create Shipment"}
                </Button>

                <Button
                    variant="contained"
                    onClick={handleCloneShipment}
                    disabled={!shipmentId}
                    style={{backgroundColor: "#1976d2", color: "#FFFFFF"}}
                >
                    Clone Shipment
                </Button>

                {!isDirectBL && (
                    <Tooltip
                        arrow
                        title={linkedOmbl ? `This HBL is already connected to ${linkedOmblLabel}.` : ""}
                    >
                        {/* span: a disabled button fires no events, so the tooltip needs a wrapper */}
                        <span>
                            <Button
                                variant="contained"
                                onClick={handleOpenConnectOmbl}
                                disabled={Boolean(linkedOmbl)}
                                style={{
                                    backgroundColor: linkedOmbl ? "#94a3b8" : "#0f172a",
                                    color: "#FFFFFF",
                                }}
                            >
                                Connect OMBL
                            </Button>
                        </span>
                    </Tooltip>
                )}

                {isDirectBL && (
                    <Button
                        variant="contained"
                        onClick={() => setShowDirectMblSection(true)}
                        // A clone needs to be saved first: its DBL is linked to its own id.
                        disabled={loading || !dblShipmentId}
                        style={{backgroundColor: "#0f172a", color: "#FFFFFF"}}
                    >
                        DBL
                    </Button>
                )}
            </div>

            {isDirectBL && showDirectMblSection && (
                <MDBox mt={4}>
                    <ConnectOMBL
                        key={dblShipmentId}
                        embedded
                        selectedShipments={dmblSelectedShipments}
                        embeddedOmblId={dmblId}
                    />
                </MDBox>
            )}
            </fieldset>

            <Dialog
                open={customerModalOpen}
                onClose={() => setCustomerModalOpen(false)}
                maxWidth="xl"
                fullWidth
            >
                <DialogTitle>
                    Create Customer
                    <IconButton
                        onClick={() => setCustomerModalOpen(false)}
                        sx={{position: "absolute", right: 12, top: 8}}
                    >
                        <CloseIcon/>
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    <CreateCustomer
                        isModal
                        onClose={() => setCustomerModalOpen(false)}
                        onCreated={handleCustomerCreatedFromModal}
                    />
                </DialogContent>
            </Dialog>

            <Dialog
                open={serviceProviderModalOpen}
                onClose={() => setServiceProviderModalOpen(false)}
                maxWidth="xl"
                fullWidth
            >
                <DialogTitle>
                    Create Service Provider
                    <IconButton
                        onClick={() => setServiceProviderModalOpen(false)}
                        sx={{ position: "absolute", right: 12, top: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>

                <DialogContent dividers>
                    <CreateServiceProvider
                        isModal
                        onClose={() => setServiceProviderModalOpen(false)}
                        onCreated={handleServiceProviderCreatedFromModal}
                    />
                </DialogContent>
            </Dialog>

            <Dialog
                open={feeOptionDialog.open}
                onClose={() => setFeeOptionDialog((prev) => ({ ...prev, open: false }))}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle>Rename fee</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        fullWidth
                        margin="dense"
                        label="Fee name"
                        value={feeOptionDialog.value}
                        onChange={(e) => setFeeOptionDialog((prev) => ({ ...prev, value: e.target.value }))}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                renameFeeOption(feeOptionDialog.original, feeOptionDialog.value);
                                setFeeOptionDialog((prev) => ({ ...prev, open: false }));
                            }
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setFeeOptionDialog((prev) => ({ ...prev, open: false }))}>Cancel</Button>
                    <Button
                        variant="contained"
                        onClick={() => {
                            renameFeeOption(feeOptionDialog.original, feeOptionDialog.value);
                            setFeeOptionDialog((prev) => ({ ...prev, open: false }));
                        }}
                    >
                        Save
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={connectOmblOpen}
                onClose={() => setConnectOmblOpen(false)}
                maxWidth="md"
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: "18px",
                        overflow: "hidden",
                        boxShadow: "0 24px 70px rgba(15,23,42,0.25)",
                    },
                }}
            >
                <DialogTitle
                    sx={{
                        px: 3,
                        py: 2.5,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        borderBottom: "1px solid #e5e7eb",
                        background: "linear-gradient(135deg, #0f172a, #1e293b)",
                        color: "#fff",
                    }}
                >
                    <MDBox>
                        <MDTypography variant="h5" fontWeight="bold" color="white">
                            Connect OMBL
                        </MDTypography>
                        <MDTypography variant="caption" color="white" sx={{opacity: 0.75}}>
                            Create a new OMBL file or connect this shipment to an existing OMBL.
                        </MDTypography>
                    </MDBox>

                    <IconButton
                        onClick={() => setConnectOmblOpen(false)}
                        sx={{
                            color: "#fff",
                            backgroundColor: "rgba(255,255,255,0.12)",
                            "&:hover": {
                                backgroundColor: "rgba(255,255,255,0.22)",
                            },
                        }}
                    >
                        <CloseIcon/>
                    </IconButton>
                </DialogTitle>

                <DialogContent sx={{p: 3, backgroundColor: "#f8fafc"}}>
                    <MDBox
                        display="grid"
                        gridTemplateColumns={{xs: "1fr", sm: "1fr 1fr"}}
                        gap={2}
                        mb={3}
                    >
                        <MDBox
                            onClick={handleNewOmbl}
                            sx={{
                                p: 2.5,
                                borderRadius: "16px",
                                cursor: "pointer",
                                backgroundColor: "#ffffff",
                                border: "1px solid #dcfce7",
                                boxShadow: "0 10px 25px rgba(22,163,74,0.10)",
                                transition: "all 0.2s ease",
                                "&:hover": {
                                    transform: "translateY(-2px)",
                                    boxShadow: "0 14px 32px rgba(22,163,74,0.18)",
                                    borderColor: "#22c55e",
                                },
                            }}
                        >
                            <MDTypography variant="h6" fontWeight="bold" color="success">
                                New OMBL
                            </MDTypography>
                            <MDTypography variant="caption" color="text">
                                Start a new OMBL document using this shipment.
                            </MDTypography>

                            <Button
                                variant="contained"
                                fullWidth
                                onClick={handleNewOmbl}
                                sx={{
                                    mt: 2,
                                    height: 42,
                                    borderRadius: "10px",
                                    backgroundColor: "#16a34a !important",
                                    color: "#ffffff !important",
                                    fontWeight: 700,
                                    boxShadow: "0 8px 18px rgba(22,163,74,0.25)",
                                    "&:hover": {
                                        backgroundColor: "#15803d !important",
                                    },
                                }}
                            >
                                Create New OMBL
                            </Button>
                        </MDBox>

                        <MDBox
                            onClick={handleLoadExistingOmbls}
                            sx={{
                                p: 2.5,
                                borderRadius: "16px",
                                cursor: "pointer",
                                backgroundColor: "#ffffff",
                                border: "1px solid #dbeafe",
                                boxShadow: "0 10px 25px rgba(37,99,235,0.10)",
                                transition: "all 0.2s ease",
                                "&:hover": {
                                    transform: "translateY(-2px)",
                                    boxShadow: "0 14px 32px rgba(37,99,235,0.18)",
                                    borderColor: "#3b82f6",
                                },
                            }}
                        >
                            <MDTypography variant="h6" fontWeight="bold" color="info">
                                Existing OMBL
                            </MDTypography>
                            <MDTypography variant="caption" color="text">
                                Select an existing OMBL and attach this shipment.
                            </MDTypography>

                            <Button
                                variant="contained"
                                fullWidth
                                onClick={handleLoadExistingOmbls}
                                sx={{
                                    mt: 2,
                                    height: 42,
                                    borderRadius: "10px",
                                    backgroundColor: "#2563eb !important",
                                    color: "#ffffff !important",
                                    fontWeight: 700,
                                    boxShadow: "0 8px 18px rgba(37,99,235,0.25)",
                                    "&:hover": {
                                        backgroundColor: "#1d4ed8 !important",
                                    },
                                }}
                            >
                                Load Existing OMBLs
                            </Button>
                        </MDBox>
                    </MDBox>

                    {omblLoading && (
                        <MDBox
                            p={3}
                            textAlign="center"
                            sx={{
                                borderRadius: "14px",
                                backgroundColor: "#fff",
                                border: "1px solid #e5e7eb",
                            }}
                        >
                            <MDTypography variant="button" fontWeight="bold">
                                Loading OMBL records...
                            </MDTypography>
                        </MDBox>
                    )}

                    {!omblLoading && existingOmbls.length > 0 && (
                        <MDBox>
                            <MDTypography variant="subtitle2" fontWeight="bold" mb={1.5}>
                                Existing OMBL Records
                            </MDTypography>

                            <MDBox
                                sx={{
                                    maxHeight: 360,
                                    overflowY: "auto",
                                    pr: 0.5,
                                }}
                            >
                                {existingOmbls.map((ombl) => {
                                    const attr = ombl.attributes || {};
                                    const linkedCount = (attr.shipments || attr.shipmentDetails || []).length;

                                    return (
                                        <MDBox
                                            key={ombl.id}
                                            display="flex"
                                            justifyContent="space-between"
                                            alignItems="center"
                                            p={2}
                                            mb={1.25}
                                            sx={{
                                                border: "1px solid #e5e7eb",
                                                borderRadius: "14px",
                                                background: "#fff",
                                                boxShadow: "0 6px 18px rgba(15,23,42,0.06)",
                                                transition: "all 0.2s ease",
                                                "&:hover": {
                                                    borderColor: "#2563eb",
                                                    boxShadow: "0 10px 26px rgba(37,99,235,0.12)",
                                                },
                                            }}
                                        >
                                            <MDBox sx={{minWidth: 0, flex: 1}}>
                                                <MDBox display="flex" alignItems="center" gap={1} flexWrap="wrap"
                                                       mb={0.75}>
                                                    <MDTypography variant="button" fontWeight="bold"
                                                                  sx={{color: "#0f172a"}}>
                                                        {attr.omblNumber || "Unnamed OMBL"}
                                                    </MDTypography>

                                                    <MDBox
                                                        sx={{
                                                            px: 1,
                                                            py: 0.35,
                                                            borderRadius: "999px",
                                                            backgroundColor: "rgba(37,99,235,0.08)",
                                                            border: "1px solid rgba(37,99,235,0.16)",
                                                        }}
                                                    >
                                                        <MDTypography variant="caption" fontWeight="bold"
                                                                      sx={{color: "#2563eb"}}>
                                                            {linkedCount} Shipment{linkedCount > 1 ? "s" : ""}
                                                        </MDTypography>
                                                    </MDBox>
                                                </MDBox>

                                                {(() => {
                                                    const linkedShipments = attr.shipments || attr.shipmentDetails || [];
                                                    const firstShipment = linkedShipments[0]?.attributes || linkedShipments[0] || {};

                                                    const pol = [
                                                        firstShipment?.vesselPol?.port,
                                                        firstShipment?.vesselPol?.country,
                                                    ].filter(Boolean).join(", ");

                                                    const pod = [
                                                        firstShipment?.vesselPod?.port,
                                                        firstShipment?.vesselPod?.country,
                                                    ].filter(Boolean).join(", ");

                                                    const shipper = firstShipment?.shipper || "-";

                                                    return (
                                                        <MDBox display="flex" gap={1} flexWrap="wrap" mt={0.75}>
                                                            {[
                                                                {label: "POL", value: pol || "-"},
                                                                {label: "POD", value: pod || "-"},
                                                                {label: "Shipper", value: shipper},
                                                            ].map((item) => (
                                                                <MDBox
                                                                    key={item.label}
                                                                    sx={{
                                                                        px: 1.25,
                                                                        py: 0.65,
                                                                        borderRadius: "10px",
                                                                        backgroundColor: "#f8fafc",
                                                                        border: "1px solid #e2e8f0",
                                                                        maxWidth: item.label === "Shipper" ? 260 : 180,
                                                                    }}
                                                                >
                                                                    <MDTypography
                                                                        variant="caption"
                                                                        sx={{
                                                                            color: "#64748b",
                                                                            fontWeight: 700,
                                                                            display: "block",
                                                                            lineHeight: 1,
                                                                        }}
                                                                    >
                                                                        {item.label}
                                                                    </MDTypography>

                                                                    <MDTypography
                                                                        variant="caption"
                                                                        fontWeight="bold"
                                                                        sx={{
                                                                            color: "#0f172a",
                                                                            display: "block",
                                                                            whiteSpace: "nowrap",
                                                                            overflow: "hidden",
                                                                            textOverflow: "ellipsis",
                                                                        }}
                                                                    >
                                                                        {item.value}
                                                                    </MDTypography>
                                                                </MDBox>
                                                            ))}
                                                        </MDBox>
                                                    );
                                                })()}

                                                {attr.createdAt && (
                                                    <MDTypography
                                                        variant="caption"
                                                        color="text"
                                                        display="block"
                                                        mt={0.75}
                                                        sx={{opacity: 0.8}}
                                                    >
                                                        Created: {new Date(attr.createdAt).toLocaleDateString()}
                                                    </MDTypography>
                                                )}
                                            </MDBox>

                                            <Button
                                                variant="contained"
                                                onClick={() => handleSelectExistingOmbl(ombl.id)}
                                                sx={{
                                                    minWidth: 110,
                                                    height: 38,
                                                    borderRadius: "10px",
                                                    backgroundColor: "#0f172a !important",
                                                    color: "#ffffff !important",
                                                    fontWeight: 700,
                                                    boxShadow: "0 6px 16px rgba(15,23,42,0.18)",
                                                    "&:hover": {
                                                        backgroundColor: "#1e293b !important",
                                                    },
                                                }}
                                            >
                                                Connect
                                            </Button>
                                        </MDBox>
                                    );
                                })}
                            </MDBox>
                        </MDBox>
                    )}

                    {!omblLoading && existingOmbls.length === 0 && (
                        <MDBox
                            p={3}
                            textAlign="center"
                            sx={{
                                borderRadius: "14px",
                                backgroundColor: "#fff",
                                border: "1px dashed #cbd5e1",
                            }}
                        >
                            <MDTypography variant="button" fontWeight="bold">
                                No OMBL records loaded yet.
                            </MDTypography>
                            <MDTypography variant="caption" color="text" display="block">
                                Click “Load Existing OMBLs” to list available records.
                            </MDTypography>
                        </MDBox>
                    )}
                </DialogContent>

                <DialogActions
                    sx={{
                        px: 3,
                        py: 2,
                        borderTop: "1px solid #e5e7eb",
                        backgroundColor: "#fff",
                    }}
                >
                    <Button
                        onClick={() => setConnectOmblOpen(false)}
                        variant="contained"
                        sx={{
                            borderRadius: "10px",
                            backgroundColor: "#ef4444 !important",
                            color: "#ffffff !important",
                            fontWeight: 700,
                            px: 3,
                            "&:hover": {
                                backgroundColor: "#dc2626 !important",
                            },
                        }}
                    >
                        Close
                    </Button>
                </DialogActions>
            </Dialog> <br/><br/>
            <Footer/>

            <Dialog open={emailPreviewOpen} onClose={() => setEmailPreviewOpen(false)} maxWidth="md" fullWidth>
                <DialogTitle>Email Draft Preview</DialogTitle>

                <DialogContent dividers>
                    {["to", "cc", "subject"].map((field) => (
                        <div key={field} style={{marginBottom: 16}}>
                            <strong>{field.toUpperCase()}:</strong>
                            <div
                                contentEditable
                                suppressContentEditableWarning
                                onBlur={(e) =>
                                    setEmailPreviewData((prev) => ({
                                        ...prev,
                                        [field]: e.target.innerText.trim(),
                                    }))
                                }
                                style={{
                                    border: "1px solid #ccc",
                                    padding: "8px",
                                    minHeight: "30px",
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                }}
                            >
                                {emailPreviewData[field]}
                            </div>
                        </div>
                    ))}

                    <div>
                        <strong>BODY:</strong>
                        <div
                            contentEditable
                            suppressContentEditableWarning
                            onBlur={(e) =>
                                setEmailPreviewData((prev) => ({
                                    ...prev,
                                    body: e.target.innerHTML,
                                }))
                            }
                            dangerouslySetInnerHTML={{__html: emailPreviewData.body}}
                            style={{
                                border: "1px solid #ccc",
                                padding: "16px",
                                minHeight: "300px",
                                borderRadius: "4px",
                                backgroundColor: "#f9f9f9",
                                fontFamily: "Segoe UI, sans-serif",
                                fontSize: "15px",
                                lineHeight: "1.6",
                                color: "#333",
                                marginTop: "4px",
                            }}
                        />
                    </div>
                </DialogContent>

                <DialogActions>
                    <Button onClick={() => setEmailPreviewOpen(false)}>Cancel</Button>
                    <Button
                        variant="contained"
                        onClick={confirmAndSendPickupNotification}
                        sx={{backgroundColor: "#4CAF50", color: "#fff"}}
                    >
                        APPROVE AND SEND
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={printDialogOpen}
                onClose={handleClosePrintDialog}
                maxWidth="sm"
                fullWidth
                TransitionComponent={Zoom}
                PaperProps={{sx: dialogPaperSx}}
            >
                <MDBox
                    sx={{
                        px: 3,
                        py: 2.5,
                        background: "linear-gradient(135deg, #1976d2 0%, #1565c0 100%)",
                        color: "#fff",
                        position: "relative",
                    }}
                >
                    <MDTypography variant="h5" fontWeight="bold" color="white">
                        Print BILL OF LADING Document
                    </MDTypography>
                    <MDTypography variant="button" color="white" sx={{opacity: 0.9}}>
                        Choose which document type you want to preview and download
                    </MDTypography>

                    <IconButton
                        onClick={handleClosePrintDialog}
                        sx={{
                            position: "absolute",
                            right: 14,
                            top: 14,
                            color: "#fff",
                            backgroundColor: "rgba(255,255,255,0.10)",
                            "&:hover": {
                                backgroundColor: "rgba(255,255,255,0.18)",
                            },
                        }}
                    >
                        <CloseIcon/>
                    </IconButton>
                </MDBox>

                <DialogContent sx={{px: 3, py: 3, backgroundColor: "#f8fafc"}}>
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={6}>
                            <MDBox
                                sx={selectionCardSx(selectedPrintType === "original")}
                                onClick={() => setSelectedPrintType("original")}
                            >
                                <MDBox display="flex" alignItems="center" gap={1.5}>
                                    <MDBox
                                        sx={{
                                            width: 46,
                                            height: 46,
                                            borderRadius: "12px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            background: "rgba(25,118,210,0.12)",
                                            color: "#1976d2",
                                        }}
                                    >
                                        <DescriptionOutlinedIcon/>
                                    </MDBox>

                                    <MDBox>
                                        <MDTypography variant="h6" fontWeight="bold">
                                            Original
                                        </MDTypography>
                                        <MDTypography variant="button" color="text">
                                            Standard FIATA original set
                                        </MDTypography>
                                    </MDBox>
                                </MDBox>

                                <MDBox mt={2}>
                                    <MDTypography variant="caption" color="text">
                                        Includes front page and terms page merged into one PDF.
                                    </MDTypography>
                                </MDBox>
                            </MDBox>
                        </Grid>

                        <Grid item xs={12} md={6}>
                            <MDBox
                                sx={selectionCardSx(selectedPrintType === "seawaybill")}
                                onClick={() => setSelectedPrintType("seawaybill")}
                            >
                                <MDBox display="flex" alignItems="center" gap={1.5}>
                                    <MDBox
                                        sx={{
                                            width: 46,
                                            height: 46,
                                            borderRadius: "12px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            background: "rgba(25,118,210,0.12)",
                                            color: "#1976d2",
                                        }}
                                    >
                                        <LocalShippingOutlinedIcon/>
                                    </MDBox>

                                    <MDBox>
                                        <MDTypography variant="h6" fontWeight="bold">
                                            Seawaybill
                                        </MDTypography>
                                        <MDTypography variant="button" color="text">
                                            Non-negotiable waybill set
                                        </MDTypography>
                                    </MDBox>
                                </MDBox>

                                <MDBox mt={2}>
                                    <MDTypography variant="caption" color="text">
                                        Includes front page and terms page merged into one PDF.
                                    </MDTypography>
                                </MDBox>
                            </MDBox>
                        </Grid>
                    </Grid>
                    {selectedPrintType === "original" && !isDirectBL && (
                        <MDBox mt={3}>
                            <MDTypography variant="button" fontWeight="bold" sx={{display: "block", mb: 1}}>
                                Original or copy?
                            </MDTypography>
                            <MDBox display="flex" gap={1.5}>
                                {[
                                    {value: false, label: "Original", hint: "ORIGINAL on the blue form"},
                                    {value: true, label: "Copy", hint: "COPY in place of ORIGINAL"},
                                ].map((option) => (
                                    <MDBox
                                        key={option.label}
                                        onClick={() => setBlCopy(option.value)}
                                        sx={{...selectionCardSx(blCopy === option.value), flex: 1, py: 1.5}}
                                    >
                                        <MDTypography variant="h6" fontWeight="bold">
                                            {option.label}
                                        </MDTypography>
                                        <MDTypography variant="caption" color="text">
                                            {option.hint}
                                        </MDTypography>
                                    </MDBox>
                                ))}
                            </MDBox>
                        </MDBox>
                    )}
                    <MDBox mt={3}>
                        <Autocomplete
                            freeSolo
                            options={utikadNumberOptions}
                            value={
                                utikadNumber
                                    ? utikadNumberOptions.find((opt) => opt.label === utikadNumber) || utikadNumber
                                    : null
                            }
                            inputValue={utikadNumber || ""}
                            onInputChange={(_e, newInputValue) => {
                                setUtikadNumber(newInputValue || "");
                            }}
                            onChange={(_e, newValue) => {
                                if (typeof newValue === "string") {
                                    setUtikadNumber(newValue);
                                } else {
                                    setUtikadNumber(newValue?.label || "");
                                }
                            }}
                            getOptionLabel={(option) =>
                                typeof option === "string" ? option : option?.label || ""
                            }
                            isOptionEqualToValue={(option, value) => {
                                const optLabel = typeof option === "string" ? option : option?.label;
                                const valLabel = typeof value === "string" ? value : value?.label;
                                return optLabel === valLabel;
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="UTIKAD Number"
                                    placeholder="Select or type UTIKAD Number"
                                    fullWidth
                                    variant="outlined"
                                    InputLabelProps={{shrink: true}}
                                />
                            )}
                        />
                        <MDTypography
                            variant="caption"
                            color="text"
                            sx={{mt: 1, display: "block"}}
                        >
                            This value will replace the original UTIKAD Number on the top-right of the PDF.
                        </MDTypography>
                    </MDBox>
                </DialogContent>

                <DialogActions
                    sx={{
                        px: 3,
                        py: 2,
                        backgroundColor: "#fff",
                        borderTop: "1px solid #eef2f7",
                        justifyContent: "space-between",
                    }}
                >
                    <Button
                        onClick={handleClosePrintDialog}
                        variant="text"
                        sx={{
                            color: "#64748b",
                            fontWeight: 600,
                        }}
                    >
                        Cancel
                    </Button>

                    <Button
                        variant="contained"
                        onClick={handlePreviewMergedPdf}
                        sx={{
                            borderRadius: "12px",
                            px: 3,
                            py: 1.2,
                            fontWeight: 700,
                            background: "linear-gradient(135deg, #1976d2 0%, #1565c0 100%)",
                            boxShadow: "0 10px 25px rgba(25,118,210,0.28)",
                            "&:hover": {
                                background: "linear-gradient(135deg, #1565c0 0%, #0d47a1 100%)",
                                boxShadow: "0 12px 28px rgba(25,118,210,0.34)",
                            },
                        }}
                    >
                        Preview PDF
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={previewDialogOpen}
                onClose={handleClosePreviewDialog}
                maxWidth="xl"
                fullWidth
                TransitionComponent={Fade}
                PaperProps={{
                    sx: {
                        ...dialogPaperSx,
                        borderRadius: "22px",
                    },
                }}
            >
                <MDBox
                    sx={{
                        px: 3,
                        py: 2.5,
                        background: "linear-gradient(135deg, #0f172a 0%, #1e293b 100%)",
                        color: "#fff",
                        position: "relative",
                    }}
                >
                    <MDTypography variant="h5" fontWeight="bold" color="white">
                        {selectedPrintType === "original" ? (isCopyPrint() ? "Copy Preview" : "Original Preview") : "Seawaybill Preview"}
                    </MDTypography>
                    <MDTypography variant="button" color="white" sx={{opacity: 0.8}}>
                        Correct any text on the left, update the preview and download
                    </MDTypography>

                    <IconButton
                        onClick={handleClosePreviewDialog}
                        sx={{
                            position: "absolute",
                            right: 14,
                            top: 14,
                            color: "#fff",
                            backgroundColor: "rgba(255,255,255,0.10)",
                            "&:hover": {
                                backgroundColor: "rgba(255,255,255,0.18)",
                            },
                        }}
                    >
                        <CloseIcon/>
                    </IconButton>
                </MDBox>

                <DialogContent
                    dividers
                    sx={{
                        p: 2,
                        backgroundColor: "#f8fafc",
                        borderTop: "none",
                        borderBottom: "none",
                    }}
                >
                    <Grid container spacing={2}>
                        <Grid item xs={12} md={5}>
                            <MDBox
                                sx={{
                                    height: 760,
                                    overflowY: "auto",
                                    pr: 1,
                                    borderRadius: "16px",
                                    backgroundColor: "#f1f5f9",
                                    border: "1px solid #e2e8f0",
                                    p: 2,
                                }}
                            >
                                <BlPrintEditor
                                    texts={blTexts}
                                    onChange={(next) => {
                                        setBlTexts(next);
                                        setBlTextsDirty(true);
                                    }}
                                />
                            </MDBox>
                        </Grid>
                        <Grid item xs={12} md={7}>
                            <MDBox
                                sx={{
                                    borderRadius: "16px",
                                    overflow: "hidden",
                                    backgroundColor: "#fff",
                                    boxShadow: "0 8px 30px rgba(15,23,42,0.08)",
                                    border: "1px solid #e2e8f0",
                                }}
                            >
                                {previewMergedPdfUrl ? (
                                    <iframe
                                        src={previewMergedPdfUrl}
                                        title="Merged PDF Preview"
                                        width="100%"
                                        height="760"
                                        style={{
                                            border: "none",
                                            display: "block",
                                            background: "#fff",
                                        }}
                                    />
                                ) : null}
                            </MDBox>
                        </Grid>
                    </Grid>
                </DialogContent>

                <DialogActions
                    sx={{
                        px: 3,
                        py: 2,
                        backgroundColor: "#fff",
                        borderTop: "1px solid #eef2f7",
                        justifyContent: "space-between",
                    }}
                >
                    <Button
                        onClick={handleClosePreviewDialog}
                        variant="text"
                        sx={{
                            color: "#64748b",
                            fontWeight: 600,
                        }}
                    >
                        Close
                    </Button>

                    <MDBox display="flex" gap={1}>
                    {/* Shown only while the edited texts are not in the preview yet. */}
                    {blTextsDirty && (
                        <Button
                            variant="contained"
                            onClick={handleApplyBlTexts}
                            disabled={loading}
                            sx={{
                                borderRadius: "12px",
                                px: 3,
                                py: 1.2,
                                fontWeight: 700,
                                color: "#fff !important",
                                background: "linear-gradient(135deg, #1976d2 0%, #1565c0 100%)",
                                boxShadow: "0 10px 25px rgba(25,118,210,0.28)",
                                "&:hover": {background: "linear-gradient(135deg, #1565c0 0%, #0d47a1 100%)"},
                            }}
                        >
                            Update preview
                        </Button>
                    )}
                    <Button
                        variant="contained"
                        onClick={handleDownloadMergedPdf}
                        sx={{
                            borderRadius: "12px",
                            px: 3,
                            py: 1.2,
                            fontWeight: 700,
                            background: "linear-gradient(135deg, #16a34a 0%, #15803d 100%)",
                            boxShadow: "0 10px 25px rgba(22,163,74,0.24)",
                            "&:hover": {
                                background: "linear-gradient(135deg, #15803d 0%, #166534 100%)",
                                boxShadow: "0 12px 28px rgba(22,163,74,0.30)",
                            },
                        }}
                    >
                        Download PDF
                    </Button>
                    </MDBox>
                </DialogActions>
            </Dialog>

            <Dialog open={addressModalOpen} onClose={closeAddressModal} fullWidth maxWidth="sm">
                <DialogTitle>
                    {editingAddressId ? "Edit" : "Add"} {getAddressConfig().title}
                </DialogTitle>

                <DialogContent>
                    <MDBox mt={1}>
                        <TextField
                            label="Address Name"
                            value={addressForm.name}
                            onChange={(e) =>
                                setAddressForm((prev) => ({
                                    ...prev,
                                    name: e.target.value,
                                }))
                            }
                            fullWidth
                            margin="normal"
                            InputLabelProps={{shrink: true}}
                        />

                        <TextField
                            label="Address"
                            value={addressForm.address}
                            onChange={(e) =>
                                setAddressForm((prev) => ({
                                    ...prev,
                                    address: e.target.value,
                                }))
                            }
                            fullWidth
                            multiline
                            minRows={3}
                            margin="normal"
                            InputLabelProps={{shrink: true}}
                        />
                    </MDBox>
                </DialogContent>

                <DialogActions>
                    <Button onClick={closeAddressModal}>Cancel</Button>
                    <Button variant="contained" onClick={saveAddressFromModal} sx={{color: "#fff"}}>
                        Save
                    </Button>
                </DialogActions>
            </Dialog>
        </DashboardLayout>
    );
};

export default CreateOceanShipment;
